export interface Person {
  firstName: string;
  lastName: string;
  title: string;
  slug: string;
  dei: boolean;
  category: string;
}

export const people: Person[] = [
  {
    firstName: "Samantha",
    lastName: "Abate",
    title: "Assistant Director, Digital Marketing",
    slug: "samantha-abate",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kimberly",
    lastName: "Abbott",
    title: "Grants and Financial Manager",
    slug: "kimberly-abbott",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sarah",
    lastName: "Abbott",
    title: "Associate Director of Accounting",
    slug: "sarah-abbott",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Stephanie",
    lastName: "Abbott-Pandey",
    title:
      " Assistant to the Associate Vice President for Campus Life and Executive Director of Student Health and Wellness",
    slug: "stephanie-abbott-pandey",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Susi",
    lastName: "Abboud",
    title:
      " Assistant Director of New Student Programs and Community Initiatives",
    slug: "susi-abboud",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "maisune",
    lastName: "Abu-Elhaija",
    title: "Assistant Director, Campus Career Exploration",
    slug: "maisune-abu-elhaija",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Erin",
    lastName: "Acuff",
    title: "Event Planner Specialist",
    slug: "erin-acuff",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Joshua",
    lastName: "Adams",
    title: "Athletics Ticket Office Intern",
    slug: "joshua-adams",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stacey",
    lastName: "Adams",
    title: "Executive Assistant",
    slug: "stacey-adams",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christopher",
    lastName: "Adams",
    title: "Assistant Director of Athletics, Multimedia and Production",
    slug: "christopher-adams",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kelly",
    lastName: "Adams",
    title: "Assistant Director, Employment Services",
    slug: "kelly-adams",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jackson",
    lastName: "Adams-Pickles",
    title: "Brown Sports Network Production Crew",
    slug: "jackson-adams-pickles",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Nichole",
    lastName: "Addeo",
    title: "Web Producer and Content Strategist",
    slug: "nichole-addeo",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Marc",
    lastName: "Addeo",
    title: "Lead Web Developer",
    slug: "marc-addeo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Oludurotimi",
    lastName: "Adetunji",
    title: "Associate Dean for Undergraduate Research and Inclusive Science",
    slug: "oludurotimi-adetunji",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Maggie",
    lastName: "Adolf",
    title: "Administrative Coordinator",
    slug: "maggie-adolf",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Abbey",
    lastName: "Aevazelis",
    title:
      " Associate Director of Pre-College Programs and Director of STEM Programs",
    slug: "abbey-aevazelis",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ivy",
    lastName: "Affum",
    title: "Manager, Information Compliance and Risk",
    slug: "ivy-affum",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jennifer",
    lastName: "Agudelo",
    title: "Assistant Director of Student Accessibility Services",
    slug: "jennifer-agudelo",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Aaron",
    lastName: "Aguilar",
    title: "Brown Sports Network Production Crew",
    slug: "aaron-aguilar",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mol",
    lastName: "Ainley",
    title: "Pharmacist",
    slug: "mol-ainley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jordan",
    lastName: "Akinsulire",
    title: "Athletics Event Worker",
    slug: "jordan-akinsulire",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Afua",
    lastName: "Akoto",
    title: "Evening Events Manager",
    slug: "afua-akoto",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Chandra",
    lastName: "Alassah",
    title: "Accounting Coordinator",
    slug: "chandra-alassah",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Edward",
    lastName: "Albeno",
    title: "Athletics Event Worker",
    slug: "edward-albeno",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Julia",
    lastName: "Alexander",
    title: "Program Assistant",
    slug: "julia-alexander",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Martha",
    lastName: "Alexander",
    title:
      " Associate Vice President for Institutional Equity, Accessibility and Compliance",
    slug: "martha-alexander",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Lawrence",
    lastName: "Alexander",
    title: "Associate Director of Admission",
    slug: "lawrence-alexander",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Fareed",
    lastName: "Alhaddad",
    title: "Administrative Coordinator",
    slug: "fareed-alhaddad",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jacqueline",
    lastName: "Alibrandi",
    title: "Athletics Marketing Assistant",
    slug: "jacqueline-alibrandi",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ran",
    lastName: "Alix-Garth",
    title: "Director of Project Administration and Finance",
    slug: "ran-alix-garth",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Justine",
    lastName: "Allen",
    title: "Assistant Program Director",
    slug: "justine-allen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Perry",
    lastName: "Allen",
    title: "Lifeguard",
    slug: "perry-allen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David",
    lastName: "Allsworth",
    title: "Sergeant",
    slug: "david-allsworth",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sharon",
    lastName: "Allsworth",
    title: "Associate Director, Gift Accounting",
    slug: "sharon-allsworth",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Raquel",
    lastName: "Almeida",
    title: "Foreign National Tax Specialist",
    slug: "raquel-almeida",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kimberly",
    lastName: "Almeida",
    title: "Director of Benefits and Wellness",
    slug: "kimberly-almeida",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Maan",
    lastName: "Alsahoui",
    title: "Joukowsky Family Middle East Studies Librarian",
    slug: "maan-alsahoui",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elijah",
    lastName: "Alston",
    title: "Building Guard",
    slug: "elijah-alston",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephanie",
    lastName: "Altomari Cavanagh",
    title: "Managing Director, Workday Program and Management Initiatives",
    slug: "stephanie-altomari-cavanagh",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Beth",
    lastName: "Altringer",
    title: "Program Director, MADE Master's Program",
    slug: "beth-altringer",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Matthew",
    lastName: "Altum",
    title: "Senior Director of Development, BUSF",
    slug: "matthew-altum",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mabel",
    lastName: "Alvarado",
    title: "Gift Accounting Associate",
    slug: "mabel-alvarado",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Aly",
    lastName: "Alvarado",
    title: "Administrative Coordinator",
    slug: "aly-alvarado",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ronald",
    lastName: "Alves",
    title: "Supervisor, Custodial Services",
    slug: "ronald-alves",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Taylor",
    lastName: "Alward",
    title: "Assistant Director of Athletic Communications",
    slug: "taylor-alward",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Tiffany",
    lastName: "Amaral",
    title: "Director of Finance and Administration",
    slug: "tiffany-amaral",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kaitlyn",
    lastName: "Amaral",
    title: "Senior Stewardship Reporting Officer",
    slug: "kaitlyn-amaral",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Nicholas",
    lastName: "Amesbury",
    title: "Baker - 52 Weeks",
    slug: "nicholas-amesbury",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Henry",
    lastName: "Ameyaw",
    title: "IT Support Consultant",
    slug: "henry-ameyaw",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "James",
    lastName: "Amspacher",
    title:
      " Assistant Dean of the College for Careers in the Common Good & Director, Professional Pathways",
    slug: "james-amspacher",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michael",
    lastName: "Andal",
    title: "Grants and Financial Manager",
    slug: "michael-andal",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Samantha",
    lastName: "Andersen",
    title: "Assistant Director, Alumni Belonging Programs",
    slug: "samantha-andersen",
    dei: true,
    category: "Communications",
  },
  {
    firstName: "Kerri",
    lastName: "Anderson",
    title: "Service Response Coordinator",
    slug: "kerri-anderson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John",
    lastName: "Anderson",
    title: "Seasonal Reader",
    slug: "john-anderson",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Derrek",
    lastName: "Anderson",
    title: "Grants and Financial Specialist",
    slug: "derrek-anderson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Eric",
    lastName: "Anderson",
    title: "Lead Developer",
    slug: "eric-anderson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michelle",
    lastName: "Andolfo",
    title: "Grants and Financial Manager",
    slug: "michelle-andolfo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mark",
    lastName: "Andrade",
    title: "Athletic Ticket Office Representative",
    slug: "mark-andrade",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Matilde",
    lastName: "Andrade",
    title: "Academic Department Manager",
    slug: "matilde-andrade",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Andrew",
    lastName: "Andraos",
    title: "Educational Digital Media Producer, Editor",
    slug: "andrew-andraos",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Valerie",
    lastName: "Andrews",
    title: "Reading Room Coordinator",
    slug: "valerie-andrews",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Symone",
    lastName: "Andrews",
    title: "Residential Area Coordinator",
    slug: "symone-andrews",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kevin",
    lastName: "Andrews",
    title: "Sergeant",
    slug: "kevin-andrews",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "James",
    lastName: "Andrews",
    title: "Stockroom Coordinator",
    slug: "james-andrews",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karen",
    lastName: "Andrews",
    title: "Director of Student Accessibility Services",
    slug: "karen-andrews",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Nicholas",
    lastName: "Andrusin",
    title: "Collections Assistant",
    slug: "nicholas-andrusin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrew",
    lastName: "Anello",
    title: "Senior Educational Media Producer",
    slug: "andrew-anello",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sarah",
    lastName: "Aneyci",
    title: "Director of Academic Research Management and Development",
    slug: "sarah-aneyci",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Linda",
    lastName: "Angela",
    title: "Academic Manager",
    slug: "linda-angela",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tony",
    lastName: "Antetomaso",
    title: "Systems Support Coordinator",
    slug: "tony-antetomaso",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michael",
    lastName: "Antonelli",
    title: "Research Systems Administrator",
    slug: "michael-antonelli",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jamie",
    lastName: "Antonelli",
    title: "Manager, Custodial Services",
    slug: "jamie-antonelli",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jocelyn",
    lastName: "Antonio",
    title: "Director of Program Implementation and Policy",
    slug: "jocelyn-antonio",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael",
    lastName: "Anzalone",
    title: "Assistant Director of Admissions and PhD Funding",
    slug: "michael-anzalone",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Suzanne",
    lastName: "Araujo",
    title: "Director of Finance and Administration",
    slug: "suzanne-araujo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Katherine",
    lastName: "Archambault",
    title: "Administrative Coordinator",
    slug: "katherine-archambault",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Grace",
    lastName: "Argo",
    title: "Assistant Director, Community-Engaged Research",
    slug: "grace-argo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kennedy",
    lastName: "Arias",
    title: "Stockroom/Warehouse Coordinator",
    slug: "kennedy-arias",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jillian",
    lastName: "Arkles",
    title: "Director, Dean's Initiatives",
    slug: "jillian-arkles",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mark",
    lastName: "Armstrong",
    title: "Rare Material Research and Reference Librarian",
    slug: "mark-armstrong",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nicole",
    lastName: "Arnold",
    title: "Administrative Coordinator",
    slug: "nicole-arnold",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Adam",
    lastName: "Arruda",
    title: "IT Support Consultant",
    slug: "adam-arruda",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lauren",
    lastName: "Arsenault",
    title: "Administrative Coordinator",
    slug: "lauren-arsenault",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Denise",
    lastName: "Arver",
    title: "Academic Manager",
    slug: "denise-arver",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ellie",
    lastName: "Ash",
    title: "Development Coordinator, Regional Development",
    slug: "ellie-ash",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kate",
    lastName: "Ashe",
    title: "Athletics Marketing Assistant",
    slug: "kate-ashe",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Gina",
    lastName: "Astorini",
    title: "Associate Director of the Leadership Alliance",
    slug: "gina-astorini",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Taylor",
    lastName: "Aten",
    title: "Athletics Creative Content Assistant",
    slug: "taylor-aten",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Vaishali",
    lastName: "Atiku",
    title: "Application Developer",
    slug: "vaishali-atiku",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Zachary",
    lastName: "Atkins",
    title: "Associate Equipment Room Manager",
    slug: "zachary-atkins",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ivone",
    lastName: "Aubin",
    title: "Academic Advising Program Manager",
    slug: "ivone-aubin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christopher",
    lastName: "Aurelio",
    title: "Athletics Photography Assistant",
    slug: "christopher-aurelio",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Amni",
    lastName: "Austin",
    title: "Financial Coordinator",
    slug: "amni-austin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jessica",
    lastName: "Austin",
    title: "Payroll Supervisor",
    slug: "jessica-austin",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Joseph",
    lastName: "Austin",
    title: "Manager, Equipment Services",
    slug: "joseph-austin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "H.",
    lastName: "Avery",
    title: "Class Giving Associate",
    slug: "h-avery",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kadambari",
    lastName: "Ayithi",
    title: "Tutor, Gateways Program",
    slug: "kadambari-ayithi",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Geoffrey",
    lastName: "Ayoub",
    title: "Lead Windows System Administrator",
    slug: "geoffrey-ayoub",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Matthew",
    lastName: "Ayres",
    title: "Athletics Marketing Assistant",
    slug: "matthew-ayres",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lauren",
    lastName: "Azar",
    title: "Assistant Director, Project Management",
    slug: "lauren-azar",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mariah",
    lastName: "Azoti-Wright",
    title: "ArtsCrew Producing Assistant",
    slug: "mariah-azoti-wright",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth",
    lastName: "Bacon",
    title: "Financial Services Commerce Specialist",
    slug: "elizabeth-bacon",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Errica",
    lastName: "Bailey",
    title: "Senior Contract Specialist",
    slug: "errica-bailey",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Christine",
    lastName: "Bailey",
    title: "Administrative Coordinator",
    slug: "christine-bailey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laura",
    lastName: "Bailey",
    title: "Grants and Financial Manager",
    slug: "laura-bailey",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Samantha",
    lastName: "Bailey",
    title: "Major Gifts Officer",
    slug: "samantha-bailey",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Brenton",
    lastName: "Baker",
    title: "Technical Assistant",
    slug: "brenton-baker",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Paul",
    lastName: "Baker",
    title: "Athletics Public Address Announcer",
    slug: "paul-baker",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Koren",
    lastName: "Bakkegard",
    title: "Associate Vice President for Campus Life and Dean of Students",
    slug: "koren-bakkegard",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Devon",
    lastName: "Balfour",
    title: "Director of Enrollment Management",
    slug: "devon-balfour",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Karen",
    lastName: "Ball",
    title: "Administrative and Financial Coordinator",
    slug: "karen-ball",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sarah",
    lastName: "Ballman",
    title: "Assistant Director of Greek, Program and Theme Communities",
    slug: "sarah-ballman",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Prasad",
    lastName: "Bandarkar",
    title: "Senior Research Computing Consultant",
    slug: "prasad-bandarkar",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Monique",
    lastName: "Bandaronek",
    title: "Financial Coordinator",
    slug: "monique-bandaronek",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Will",
    lastName: "Bann",
    title: "Senior IT Support Consultant",
    slug: "will-bann",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dylan",
    lastName: "Bannister",
    title: "Senior Systems Administrator",
    slug: "dylan-bannister",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jaclyn",
    lastName: "Banville",
    title: "Communication Control Officer",
    slug: "jaclyn-banville",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Karen",
    lastName: "Baptist",
    title: "Senior Associate Director of Institutional Research",
    slug: "karen-baptist",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Paulo",
    lastName: "Baptista",
    title: "Manager, Research Systems",
    slug: "paulo-baptista",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Adele",
    lastName: "Baran",
    title: "Assistant Registrar for Systems Management",
    slug: "adele-baran",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Joann",
    lastName: "Barao",
    title: "Assistant Director of Applied Learning",
    slug: "joann-barao",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jayden",
    lastName: "Barber",
    title: "ArtsCrew Production Assistant",
    slug: "jayden-barber",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Corinne",
    lastName: "Barber",
    title: "Report Developer",
    slug: "corinne-barber",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Timberley",
    lastName: "Barber",
    title: "Associate Director, Learning Technologies",
    slug: "timberley-barber",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Caitlin",
    lastName: "Barkan",
    title: "Auditor 4",
    slug: "caitlin-barkan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jennifer",
    lastName: "Barlow",
    title: "Gynecological Exam",
    slug: "jennifer-barlow",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephen",
    lastName: "Barnabe",
    title: "Director, Health Information Applications",
    slug: "stephen-barnabe",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "David",
    lastName: "Barnes",
    title: "PLME Coordinator",
    slug: "david-barnes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christopher",
    lastName: "Barnes",
    title: "Business Intelligence Developer",
    slug: "christopher-barnes",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Katharine",
    lastName: "Barnes",
    title: "Director of Institutional Research",
    slug: "katharine-barnes",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tina",
    lastName: "Barnhardt",
    title: "Financial Coordinator",
    slug: "tina-barnhardt",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alexandrea",
    lastName: "Baron",
    title: "Grants and Financial Specialist",
    slug: "alexandrea-baron",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Genesis",
    lastName: "Barrera",
    title: "Public Services Librarian",
    slug: "genesis-barrera",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Marie-Anne",
    lastName: "Barron",
    title: "Admission Officer",
    slug: "marie-anne-barron",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Sam",
    lastName: "Barrus",
    title: "Assistant Director, Pre-College Student Life- Staff Development",
    slug: "sam-barrus",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Russell",
    lastName: "Bart",
    title: "Communication Control Officer",
    slug: "russell-bart",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Craig",
    lastName: "Barton",
    title: "University Architect",
    slug: "craig-barton",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lori",
    lastName: "Bassett",
    title: "Administrative Coordinator",
    slug: "lori-bassett",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Missy",
    lastName: "Bassler",
    title: "Bruno the Mascot",
    slug: "missy-bassler",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jennifer",
    lastName: "Bastin",
    title: "Development Coordinator, College Programs",
    slug: "jennifer-bastin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alexander",
    lastName: "Batten",
    title: "Program Manager, Rhodes and CSL",
    slug: "alexander-batten",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nadia",
    lastName: "Baum",
    title: "Associate Director, Young Alumni and Student Giving",
    slug: "nadia-baum",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Christine",
    lastName: "Baumgarthuber",
    title: "Senior Learning Designer",
    slug: "christine-baumgarthuber",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jordana",
    lastName: "Bautista",
    title: "Senior Customer Service Coordinator",
    slug: "jordana-bautista",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amy",
    lastName: "Beard",
    title: "Assistant Director, Program Innovation and Sustainability",
    slug: "amy-beard",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christopher",
    lastName: "Beattie",
    title: "Senior Associate Registrar for Systems and Quality Assurance",
    slug: "christopher-beattie",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Skylar",
    lastName: "Beckerman",
    title: "Senior Leadership Giving Officer",
    slug: "skylar-beckerman",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Emily",
    lastName: "Bedard",
    title: "Health System Grant & Financial Specialist",
    slug: "emily-bedard",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "John",
    lastName: "Beiermann",
    title: "IT Support Consultant",
    slug: "john-beiermann",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Bert",
    lastName: "Belle",
    title: "Second Baker - 52 Weeks",
    slug: "bert-belle",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jonathan",
    lastName: "Beller",
    title: "Mail Clerk",
    slug: "jonathan-beller",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julia",
    lastName: "Bengochea",
    title: "Senior Director of College Admission",
    slug: "julia-bengochea",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Aleida",
    lastName: "Benitez",
    title: "Manager, Community Partnership",
    slug: "aleida-benitez",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Barbara",
    lastName: "Bennett",
    title: "Academic Affairs Manager",
    slug: "barbara-bennett",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Antonio",
    lastName: "Bento",
    title: "Sergeant",
    slug: "antonio-bento",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ingrida",
    lastName: "Berberian",
    title: "Administrative Coordinator",
    slug: "ingrida-berberian",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Grace",
    lastName: "Berg",
    title: "Project Coordinator",
    slug: "grace-berg",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Matthew",
    lastName: "Berg",
    title: "Pharmacist",
    slug: "matthew-berg",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Paul",
    lastName: "Bergeron",
    title: "Director of Pharmacy",
    slug: "paul-bergeron",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tatum",
    lastName: "Berglund",
    title: "Director of Information Technology",
    slug: "tatum-berglund",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Christina",
    lastName: "Bernier",
    title: "Director, UHR Finance and Administration",
    slug: "christina-bernier",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Ethan",
    lastName: "Bernstein",
    title: "Executive Dean of Administration and Finance",
    slug: "ethan-bernstein",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Erin",
    lastName: "Berry",
    title: "Senior Technical Assistant",
    slug: "erin-berry",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jessica",
    lastName: "Berry",
    title: "Assistant Vice President, Sustainability & Resiliency",
    slug: "jessica-berry",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melissa",
    lastName: "Berry",
    title: "Sustainability and Living Labs Specialist",
    slug: "melissa-berry",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carrie",
    lastName: "Best",
    title: "Project Director, Center for Translational Neuroscience",
    slug: "carrie-best",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Aliosha",
    lastName: "Bielenberg",
    title: "College Project Specialist",
    slug: "aliosha-bielenberg",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Martin",
    lastName: "Bierer",
    title: "Web Strategist and Producer",
    slug: "martin-bierer",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cassandra",
    lastName: "Bigness",
    title: "Grants and Financial Specialist",
    slug: "cassandra-bigness",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Willis",
    lastName: "Bilderback",
    title: "Communications Specialist",
    slug: "willis-bilderback",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Regina",
    lastName: "Binda",
    title: "Neurology Clerkship Coordinator",
    slug: "regina-binda",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Helen",
    lastName: "Bingham",
    title: "Grants and Financial Specialist",
    slug: "helen-bingham",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Emily",
    lastName: "Binns",
    title: "EMS Shift Supervisor",
    slug: "emily-binns",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alina",
    lastName: "Birch",
    title: "Psychiatric Prescriber",
    slug: "alina-birch",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniel",
    lastName: "Bissonnette",
    title: "Brown Sports Network Production Crew",
    slug: "daniel-bissonnette",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Howard",
    lastName: "Bistline",
    title: "Hardware Services Clerk",
    slug: "howard-bistline",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Grady",
    lastName: "Bizyak",
    title: "Athletics Marketing Assistant",
    slug: "grady-bizyak",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "David",
    lastName: "Blair",
    title: "Senior IT Support Consultant",
    slug: "david-blair",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jaelyn",
    lastName: "Blair",
    title: "Grant/Contract Accountant I",
    slug: "jaelyn-blair",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Michelle",
    lastName: "Blais",
    title: "Director of Wellness and Nutrition",
    slug: "michelle-blais",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melissa",
    lastName: "Blais",
    title: "Undergraduate Student Records and Graduation Coordinator",
    slug: "melissa-blais",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ziggy",
    lastName: "Blake",
    title: "Supervisor, 2nd Shift HVAC and Controls",
    slug: "ziggy-blake",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sophia",
    lastName: "Blanchard-Camporeale",
    title: "ArtsCrew Production Assistant",
    slug: "sophia-blanchard-camporeale",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kyle",
    lastName: "Blanchette",
    title: "Development Officer, Academic Initiatives",
    slug: "kyle-blanchette",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lisa",
    lastName: "Blangeard",
    title: "Administrative Coordinator",
    slug: "lisa-blangeard",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amanda",
    lastName: "Blazka",
    title: "Career Counselor",
    slug: "amanda-blazka",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Henri",
    lastName: "Blouin",
    title: "Administrative Coordinator",
    slug: "henri-blouin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Malik",
    lastName: "Blue",
    title: "Senior Associate Dean of the College for Study Abroad",
    slug: "malik-blue",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Antwan",
    lastName: "Bluster",
    title: "Assistant Director for Student Activities",
    slug: "antwan-bluster",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Juliane",
    lastName: "Blyth",
    title: "Senior Director, Office of Research Integrity",
    slug: "juliane-blyth",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sara",
    lastName: "Boddery",
    title: "Director, Advancement Enterprise Solutions",
    slug: "sara-boddery",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Karen",
    lastName: "Boehnke",
    title: "Assistant Vice President of Development",
    slug: "karen-boehnke",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joshua",
    lastName: "Bolton",
    title: "Interim Associate University Chaplain for the Jewish Community",
    slug: "joshua-bolton",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kimberly",
    lastName: "Bond",
    title: "Training and Talent Development Manager",
    slug: "kimberly-bond",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Nicole",
    lastName: "Bonelli",
    title: "Human Resources Specialist",
    slug: "nicole-bonelli",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Marc",
    lastName: "Bontemps",
    title: "Athletics Creative Content Assistant",
    slug: "marc-bontemps",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Richard",
    lastName: "Booth",
    title: "Psychotherapist",
    slug: "richard-booth",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katy",
    lastName: "Booth",
    title: "Assistant Director, Digital Communications",
    slug: "katy-booth",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lisa",
    lastName: "Boothe",
    title: "Proposal Coordinator",
    slug: "lisa-boothe",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kathryn",
    lastName: "Boots",
    title: "Associate Director of Administration & Finance",
    slug: "kathryn-boots",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "William",
    lastName: "Bordac",
    title: "Senior Digital Strategist & Web Producer",
    slug: "william-bordac",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ariel",
    lastName: "Bordeaux",
    title: "Administrative and Communications Coordinator",
    slug: "ariel-bordeaux",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Pargol",
    lastName: "Borojerdi",
    title: "Administrative Coordinator",
    slug: "pargol-borojerdi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Madeleine",
    lastName: "Borsari",
    title: "Assistant Director of Development, Academic Initiatives",
    slug: "madeleine-borsari",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jennifer",
    lastName: "Borsavage",
    title: "House Staff Officer in Radiation Oncology",
    slug: "jennifer-borsavage",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Cameron",
    lastName: "Borselli",
    title: "Athletics Assistant Ticket Manager",
    slug: "cameron-borselli",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mathew",
    lastName: "Borton",
    title: "Director of Information Technology",
    slug: "mathew-borton",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cheryl",
    lastName: "Botelho",
    title: "Administrative Coordinator",
    slug: "cheryl-botelho",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kelly",
    lastName: "Bouchard",
    title: "Project Coordinator",
    slug: "kelly-bouchard",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karen",
    lastName: "Bouchard",
    title: "Arts and Humanities Librarian",
    slug: "karen-bouchard",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Gray",
    lastName: "Bouchard",
    title: "Director of Client Relations",
    slug: "gray-bouchard",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sarah",
    lastName: "Bouchard",
    title: "Director of Community Engagement",
    slug: "sarah-bouchard",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Tori",
    lastName: "Bouchard",
    title: "Athletic Trainer",
    slug: "tori-bouchard",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Elayna",
    lastName: "Boucher",
    title: "Lieutenant",
    slug: "elayna-boucher",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ethan",
    lastName: "Boudreau",
    title: "Brown Sports Network Production Crew",
    slug: "ethan-boudreau",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Chase",
    lastName: "Boulay",
    title: "Personal Trainer",
    slug: "chase-boulay",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jacqueline",
    lastName: "Boutcher",
    title: "ArtsCrew Visitor Services Assistant",
    slug: "jacqueline-boutcher",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jillian",
    lastName: "Boutcher",
    title: "Seasonal Sales Associate",
    slug: "jillian-boutcher",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sandra",
    lastName: "Boutcher",
    title: "Athletic Ticket Office Representative",
    slug: "sandra-boutcher",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Alexandra",
    lastName: "Boutros",
    title: "Human Research Protection Program (HRPP) Director",
    slug: "alexandra-boutros",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christine",
    lastName: "Bove",
    title: "Executive Assistant and Department Coordinator",
    slug: "christine-bove",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kellie",
    lastName: "Bowers",
    title: "Associate Curator",
    slug: "kellie-bowers",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tiffini",
    lastName: "Bowers",
    title: "Assistant Director of Special Collections for Art and Exhibitions",
    slug: "tiffini-bowers",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michael",
    lastName: "Bowers",
    title: "Chief University Auditor",
    slug: "michael-bowers",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Amari",
    lastName: "Boyd",
    title: "Associate Dean of the College for First-Year & Sophomore Studies",
    slug: "amari-boyd",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sabrina",
    lastName: "Boyk",
    title: "Administrative Coordinator",
    slug: "sabrina-boyk",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alex",
    lastName: "Boyle",
    title: "Annual Giving Coordinator",
    slug: "alex-boyle",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Megan",
    lastName: "Boyle",
    title: "Assistant Director, Planned Giving",
    slug: "megan-boyle",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Brenda",
    lastName: "Brackett",
    title: "Applied Learning Coordinator",
    slug: "brenda-brackett",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "James",
    lastName: "Brady",
    title: "Seasonal Sales Associate",
    slug: "james-brady",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Diane",
    lastName: "Brady",
    title: "Seasonal Sales Associate",
    slug: "diane-brady",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erin",
    lastName: "Brannan",
    title: "Assistant Director, Assessment and Evaluation",
    slug: "erin-brannan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Todd",
    lastName: "Brault",
    title: "Assistant Director, Gift Accounting Quality Assurance",
    slug: "todd-brault",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Victoria",
    lastName: "Bray",
    title: "Associate Director of Graduate Degree Enrollment",
    slug: "victoria-bray",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Joan",
    lastName: "Brazier",
    title: "Project Director",
    slug: "joan-brazier",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Howard",
    lastName: "Brennan",
    title: "Groundsworker",
    slug: "howard-brennan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Holly",
    lastName: "Brennan",
    title: "Graduate Admissions Counselor",
    slug: "holly-brennan",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Julia",
    lastName: "Brennan",
    title: "Senior Assistant Director of Admission",
    slug: "julia-brennan",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Courtenay",
    lastName: "Briggs",
    title: "Communication Control Officer",
    slug: "courtenay-briggs",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Arlene",
    lastName: "Bright",
    title: "Senior Accountant - Cash Specialist",
    slug: "arlene-bright",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Marc",
    lastName: "Brillon",
    title: "RICOH Mail Clerk",
    slug: "marc-brillon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Grace",
    lastName: "Brion",
    title: "Grants and Financial Specialist",
    slug: "grace-brion",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Joshua",
    lastName: "Bristow",
    title: "Assistant Producer",
    slug: "joshua-bristow",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alicia",
    lastName: "Brodeur",
    title: "Senior Paralegal, Litigation",
    slug: "alicia-brodeur",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Sean",
    lastName: "Broestl",
    title: "Lead VMware System Administrator",
    slug: "sean-broestl",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "David",
    lastName: "Brown",
    title: "Endpoint/Hardware Services Specialist",
    slug: "david-brown",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Bethany",
    lastName: "Brown",
    title: "Academic Coordinator",
    slug: "bethany-brown",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lisa",
    lastName: "Brown",
    title: "Visit Experience Coordinator",
    slug: "lisa-brown",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Sarah",
    lastName: "Brown",
    title: "Associate Director, Partner Engagement",
    slug: "sarah-brown",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Erica",
    lastName: "Brown",
    title: "Parking Officer",
    slug: "erica-brown",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David",
    lastName: "Brown",
    title: "Manager, IT Support Consultants",
    slug: "david-brown-1",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Susan",
    lastName: "Brown",
    title: "Assistant to the Executive Vice President for Planning and Policy",
    slug: "susan-brown",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Keelonda",
    lastName: "Brown",
    title: "Admissions Coordinator",
    slug: "keelonda-brown",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Michael",
    lastName: "Brown",
    title: "Senior IT Support Consultant",
    slug: "michael-brown",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dawn",
    lastName: "Browne",
    title: "Psychotherapist",
    slug: "dawn-browne",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erik",
    lastName: "Brunnenmeyer",
    title: "IT Support Consultant",
    slug: "erik-brunnenmeyer",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cara",
    lastName: "Bruno",
    title: "Digital Marketing Specialist",
    slug: "cara-bruno",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Crystal",
    lastName: "Brusch",
    title: "Digital Publications Designer",
    slug: "crystal-brusch",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Gary",
    lastName: "Bryson",
    title: "Senior IT Support Consultant",
    slug: "gary-bryson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Deana",
    lastName: "Buccheri",
    title: "Benefits Administrative Specialist",
    slug: "deana-buccheri",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Hayley",
    lastName: "Buckey",
    title: "Project Manager",
    slug: "hayley-buckey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alison",
    lastName: "Buckser",
    title: "Director, Corporate and Foundation Relations",
    slug: "alison-buckser",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ian",
    lastName: "Budish",
    title: "Exhibition Installation Manager",
    slug: "ian-budish",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Peter",
    lastName: "Bulan",
    title: "Financial Aid Counselor",
    slug: "peter-bulan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Karen",
    lastName: "Bulock",
    title: "Managing Director, Brown Biomedical Innovations",
    slug: "karen-bulock",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Leo",
    lastName: "Bunyea",
    title: "Systems Administrator",
    slug: "leo-bunyea",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Amanda",
    lastName: "Burke",
    title: "International Advancement Associate",
    slug: "amanda-burke",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kelly",
    lastName: "Burke",
    title: "Assistant Grounds Superintendent",
    slug: "kelly-burke",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gena",
    lastName: "Burke",
    title: "Learning Technologies Administrator",
    slug: "gena-burke",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Emily",
    lastName: "Burmeister",
    title: "Senior Athletic Trainer",
    slug: "emily-burmeister",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Alicia",
    lastName: "Burnett",
    title: "Digital Content Producer",
    slug: "alicia-burnett",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Joshua",
    lastName: "Burnett",
    title: "Communication Control Officer",
    slug: "joshua-burnett",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Anais",
    lastName: "Bustos",
    title: "ArtsCrew Production Assistant",
    slug: "anais-bustos",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sydney",
    lastName: "Butera",
    title: "Brown Sports Network Production Crew",
    slug: "sydney-butera",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Donna",
    lastName: "Butler",
    title: "Senior Director, Custodial Services",
    slug: "donna-butler",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Teal",
    lastName: "Butterworth",
    title:
      " Co-Executive Director of Annual Giving, Class and Constituent Giving",
    slug: "teal-butterworth",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lourdez",
    lastName: "Caballeros",
    title: "Administrative Coordinator",
    slug: "lourdez-caballeros",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dawn",
    lastName: "Cabral",
    title: "Administrative & Financial Coordinator",
    slug: "dawn-cabral",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Allie",
    lastName: "Cabral",
    title: "University Scheduler",
    slug: "allie-cabral",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michaela",
    lastName: "Cabral",
    title: "Gift Accounting Associate",
    slug: "michaela-cabral",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ryn",
    lastName: "Caddick",
    title: "ArtsCrew Exhibitions Assistant",
    slug: "ryn-caddick",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cindy",
    lastName: "Calabro",
    title: "Executive Assistant",
    slug: "cindy-calabro",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Neil",
    lastName: "Calabro",
    title: "Research Strategy & Development Project Manager",
    slug: "neil-calabro",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sam",
    lastName: "Caldis",
    title: "Associate Dean",
    slug: "sam-caldis",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jason",
    lastName: "Calhoun",
    title: "Director of Golf",
    slug: "jason-calhoun",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Grace",
    lastName: "Calhoun",
    title: "Vice President for Athletics and Recreation",
    slug: "grace-calhoun",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Donald",
    lastName: "Calitri",
    title: "Grants and Financial Specialist",
    slug: "donald-calitri",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mary",
    lastName: "Callan",
    title:
      " Vice President for Community Engagement and Stark Family Executive Director, Howard R. Swearer Center for Public Service",
    slug: "mary-callan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Pell",
    lastName: "Callanan",
    title: "Investment Associate",
    slug: "pell-callanan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sasha",
    lastName: "Callejas",
    title: "Associate Director, Talent and Learning",
    slug: "sasha-callejas",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Genesis",
    lastName: "Camacho",
    title: "Program Associate, Regional Clubs",
    slug: "genesis-camacho",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kris",
    lastName: "Cambra",
    title: "Assistant Dean of Biomedical Communications",
    slug: "kris-cambra",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michael",
    lastName: "Campagna",
    title: "Athletics Marketing Assistant",
    slug: "michael-campagna",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Victoria",
    lastName: "Campbell",
    title: "Director of Business Development - Physical Sciences",
    slug: "victoria-campbell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Frank",
    lastName: "Campo",
    title:
      " Associate Director, Engagement Programs, Brown University Sports Foundation",
    slug: "frank-campo",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Diana",
    lastName: "Canales Osorio",
    title: "Administration Coordinator",
    slug: "diana-canales-osorio",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Guinet",
    lastName: "Canas Maio",
    title: "Admissions Specialist",
    slug: "guinet-canas-maio",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Richard",
    lastName: "Cancio",
    title: "Education and Training Manager, Diversity, Equity, and Inclusion",
    slug: "richard-cancio",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Karen",
    lastName: "Canis",
    title: "Financial and Systems Manager",
    slug: "karen-canis",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jade",
    lastName: "Cannata",
    title: "ArtsCrew Production Assistant",
    slug: "jade-cannata",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mary",
    lastName: "Cannon",
    title: "Director, Content Strategy and Planning",
    slug: "mary-cannon",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Xiabin",
    lastName: "Cao",
    title: "Administrative Coordinator",
    slug: "xiabin-cao",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emma",
    lastName: "Cape",
    title: "Program Manager",
    slug: "emma-cape",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katie",
    lastName: "Capener",
    title: "Events Manager",
    slug: "katie-capener",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Frederick",
    lastName: "Capozzoli",
    title: "Supervisor, Plumbing",
    slug: "frederick-capozzoli",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robert",
    lastName: "Cappalli",
    title: "Application Support Specialist",
    slug: "robert-cappalli",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Giana",
    lastName: "Cappelli",
    title: "Athletics Communications Officer",
    slug: "giana-cappelli",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Desiree",
    lastName: "Caprio",
    title: "Custodial Shift Assistant",
    slug: "desiree-caprio",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Fran-Marie",
    lastName: "Carbone",
    title: "Athletic Ticket Office Representative",
    slug: "fran-marie-carbone",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katelyn",
    lastName: "Carden",
    title: "Administrative Coordinator for Advising",
    slug: "katelyn-carden",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Amy",
    lastName: "Cardone",
    title: "Service Response Coordinator",
    slug: "amy-cardone",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maria",
    lastName: "Cardone",
    title: "Academic Program Manager",
    slug: "maria-cardone",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Briana",
    lastName: "Cardwell",
    title: "Assistant Dean of Student Conduct & Community Standards",
    slug: "briana-cardwell",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Russell",
    lastName: "Carey",
    title: "Executive Vice President for Planning and Policy",
    slug: "russell-carey",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Robin",
    lastName: "Carillo",
    title: "Endpoint/Mobile Device Specialist",
    slug: "robin-carillo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Pam",
    lastName: "Carlson",
    title: "Executive Assistant",
    slug: "pam-carlson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Abby",
    lastName: "Carlson",
    title: "Leave and Accommodation Manager",
    slug: "abby-carlson",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Kevin",
    lastName: "Carlson",
    title: "Flow Cytometry Facility Manager",
    slug: "kevin-carlson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Haleigh",
    lastName: "Carlson",
    title: "Equipment Room Specialist",
    slug: "haleigh-carlson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael",
    lastName: "Carnevale",
    title: "Brown Sports Network Production Crew",
    slug: "michael-carnevale",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah",
    lastName: "Carnevale",
    title: "Residency Program Manager",
    slug: "sarah-carnevale",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mark",
    lastName: "Carney",
    title: "Executive Director, Advancement Information Services",
    slug: "mark-carney",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Heather",
    lastName: "Carreiro",
    title: "Administrative Manager",
    slug: "heather-carreiro",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michele",
    lastName: "Carreiro",
    title: "Associate Director of Administration",
    slug: "michele-carreiro",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erica",
    lastName: "Carrita",
    title: "Administrative Coordinator",
    slug: "erica-carrita",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Charles",
    lastName: "Carroll",
    title: "Associate Director for Graduate Student Writing",
    slug: "charles-carroll",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jessica",
    lastName: "Carroll",
    title: "HR Service Center Manager",
    slug: "jessica-carroll",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Patrice",
    lastName: "Carroll",
    title: "Senior Director, Office of Sponsored Projects",
    slug: "patrice-carroll",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nancy",
    lastName: "Carroll",
    title: "Associate Dean, Finance and Administration",
    slug: "nancy-carroll",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "James",
    lastName: "Carroll",
    title: "Instrument Maker/Machinist",
    slug: "james-carroll",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sheryl",
    lastName: "Carter",
    title: "Director of Advancement Digital and Creative Solutions",
    slug: "sheryl-carter",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "John",
    lastName: "Carvalho",
    title: "Lieutenant",
    slug: "john-carvalho",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joseph",
    lastName: "Casamassima",
    title: "Program Manager",
    slug: "joseph-casamassima",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer",
    lastName: "Casasanto",
    title: "Associate Dean for Strategy, Administration and External Affairs",
    slug: "jennifer-casasanto",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Anthony",
    lastName: "Casello",
    title: "Senior Director of Design & Construction",
    slug: "anthony-casello",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Greg",
    lastName: "Caso",
    title: "Assistant Dean of Student Conduct & Community Standards",
    slug: "greg-caso",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jillian",
    lastName: "Castaneda",
    title: "Administrative Coordinator",
    slug: "jillian-castaneda",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hilda",
    lastName: "Castillo",
    title: "Engagement and Outreach Specialist",
    slug: "hilda-castillo",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Yolanda",
    lastName: "Castillo-Appollonio",
    title:
      " Senior Associate Dean and Director of Student Conduct & Community Standards",
    slug: "yolanda-castillo-appollonio",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "David",
    lastName: "Cavallaro",
    title: "Assistant Director for Assignments",
    slug: "david-cavallaro",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kimberley",
    lastName: "Cavanaugh",
    title: "Senior Grants and Contracts Accountant",
    slug: "kimberley-cavanaugh",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Aaron",
    lastName: "Cavender-McCoy",
    title: "Learning Designer",
    slug: "aaron-cavender-mccoy",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "PJ",
    lastName: "Centofanti",
    title: "Senior Visual Designer",
    slug: "pj-centofanti",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Anthony",
    lastName: "Centore Jr",
    title: "Brown Sports Network Production Crew",
    slug: "anthony-centore-jr",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jason",
    lastName: "Cerrato",
    title: "STEM Instruction Librarian",
    slug: "jason-cerrato",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Cindy",
    lastName: "Chadderton",
    title: "Senior IT Contract Specialist",
    slug: "cindy-chadderton",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mary-Margaret",
    lastName: "Chaffee",
    title: "Alumni Leadership Programs Coordinator",
    slug: "mary-margaret-chaffee",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Benjamin",
    lastName: "Chalot",
    title: "Associate Director, Professional Development and Alumni Engagement",
    slug: "benjamin-chalot",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anthony",
    lastName: "Champagne",
    title: "Athletics Marketing Assistant",
    slug: "anthony-champagne",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michelle",
    lastName: "Chan",
    title: "ISE Administrative Coordinator",
    slug: "michelle-chan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sake",
    lastName: "Chan",
    title: "Grants and Financial Specialist",
    slug: "sake-chan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jane",
    lastName: "Chang",
    title: "Tutor, Gateways Program",
    slug: "jane-chang",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Peggy",
    lastName: "Chang",
    title:
      " Director of the Curricular Resource Center and Associate Dean of the College for Curricular Engagement",
    slug: "peggy-chang",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kelley",
    lastName: "Chase",
    title: "Director, Alumni Belonging Programs",
    slug: "kelley-chase",
    dei: true,
    category: "Student Life",
  },
  {
    firstName: "Gianna",
    lastName: "Chaves",
    title: "Administrative Coordinator",
    slug: "gianna-chaves",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Valeria",
    lastName: "Chavez-Ayala",
    title: "Assistant Director, U-Fli Center",
    slug: "valeria-chavez-ayala",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Naroth",
    lastName: "Chek",
    title: "Financial Coordinator 2",
    slug: "naroth-chek",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ruby",
    lastName: "Cheng",
    title: "Assistant Director, Global Brown Center for International Students",
    slug: "ruby-cheng",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Courtney",
    lastName: "Cheng",
    title: "Digital Specialist and Art Production Manager",
    slug: "courtney-cheng",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Niji",
    lastName: "Cheng",
    title: "Seasonal Application Reader",
    slug: "niji-cheng",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Peter",
    lastName: "Chenot",
    title: "Director of Marketing and Communications",
    slug: "peter-chenot",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Herman",
    lastName: "Chenwi",
    title: "Tutor, Gateways Program",
    slug: "herman-chenwi",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Joan",
    lastName: "Chepngeno",
    title: "Project Coordinator",
    slug: "joan-chepngeno",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bethany",
    lastName: "Cherms",
    title: "Subcontract & Research Analytics Administrator",
    slug: "bethany-cherms",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alana",
    lastName: "Chetlen",
    title: "Assistant Director of HRPP",
    slug: "alana-chetlen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amy",
    lastName: "Chew",
    title: "Assistant Dean of Medical Education, Gateways",
    slug: "amy-chew",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Raymond",
    lastName: "Chiang",
    title: "Tutor, Gateways Program",
    slug: "raymond-chiang",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Edward",
    lastName: "Chin",
    title: "Pharmacist",
    slug: "edward-chin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ryan",
    lastName: "Chin",
    title: "Grant/Contract Accountant II",
    slug: "ryan-chin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Phil",
    lastName: "Chisholm",
    title: "Athletics Event Worker",
    slug: "phil-chisholm",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Diane",
    lastName: "Chouinard",
    title: "Financial Manager",
    slug: "diane-chouinard",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nancy",
    lastName: "Ciminelli",
    title: "Program Manager",
    slug: "nancy-ciminelli",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Caroline",
    lastName: "Claflin",
    title: "SPH Director of Communications",
    slug: "caroline-claflin",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Brian",
    lastName: "Clark",
    title: "Vice President for News and Strategic Campus Communications",
    slug: "brian-clark",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Michelle",
    lastName: "Clark",
    title: "Financial Coordinator",
    slug: "michelle-clark",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lauren",
    lastName: "Clarke",
    title: "Event Communications and Program Support Manager",
    slug: "lauren-clarke",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sarah",
    lastName: "Clarke",
    title: "Marketing Communications Manager",
    slug: "sarah-clarke",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Stacey",
    lastName: "Claveria",
    title: "Advancement Events Coordinator",
    slug: "stacey-claveria",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Max",
    lastName: "Clermont",
    title: "Seasonal Application Reader",
    slug: "max-clermont",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Kelly",
    lastName: "Cleveland",
    title: "Senior Technical Assistant",
    slug: "kelly-cleveland",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cass",
    lastName: "Cliatt",
    title: "Senior Vice President for Communications",
    slug: "cass-cliatt",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Alyssia",
    lastName: "Coates",
    title: "Senior Director of Development, Inclusive Philanthropic Engagement",
    slug: "alyssia-coates",
    dei: true,
    category: "Finance",
  },
  {
    firstName: "Mauricio",
    lastName: "Cobian",
    title: "Associate Dean of the College for Curricular Integration",
    slug: "mauricio-cobian",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Katie",
    lastName: "Coble",
    title: "SHARE Advocate",
    slug: "katie-coble",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kevin",
    lastName: "Coccio",
    title: "Program Advising Specialist",
    slug: "kevin-coccio",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Travis",
    lastName: "Cochran",
    title: "Director, Bookstore and University Brand Licensing",
    slug: "travis-cochran",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Grace",
    lastName: "Cockfield-Dina",
    title: "ArtsCrew Marketing & Communications Assistant",
    slug: "grace-cockfield-dina",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Caitlin",
    lastName: "Coffey",
    title: "Athletics Ticket Representative",
    slug: "caitlin-coffey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dani",
    lastName: "Cofoni",
    title:
      " Executive Assistant to the Senior Vice President for Communications",
    slug: "dani-cofoni",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Amanda",
    lastName: "Cogan",
    title: "Associate Director of Global Engagement",
    slug: "amanda-cogan",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Amy",
    lastName: "Cohen",
    title: "Department Manager",
    slug: "amy-cohen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jacob",
    lastName: "Cohen",
    title: "Brown Sports Network Production Crew",
    slug: "jacob-cohen",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "David",
    lastName: "Coite",
    title: "First Baker - 52 Weeks",
    slug: "david-coite",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John",
    lastName: "Colarusso",
    title: "Manager, Structural Projects",
    slug: "john-colarusso",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brandon",
    lastName: "Cole",
    title: "Senior Leadership Giving Officer",
    slug: "brandon-cole",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Heather",
    lastName: "Cole",
    title:
      " Head, Special Collections Instruction and Curator, Literary and Popular Culture",
    slug: "heather-cole",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Gwendolyn",
    lastName: "Collaco",
    title: "Anne S.K. Brown Curator for Military & Society",
    slug: "gwendolyn-collaco",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "William",
    lastName: "Collins",
    title: "Merchandise Planner",
    slug: "william-collins",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ashley",
    lastName: "Collins",
    title: "Assistant Vice President, Chief Procurement Officer",
    slug: "ashley-collins",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Karen",
    lastName: "Colon-Cruz",
    title: "Accounts Receivable / Payable Coordinator",
    slug: "karen-colon-cruz",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jeremy",
    lastName: "Conary",
    title: "Senior IT Support Consultant",
    slug: "jeremy-conary",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Christopher",
    lastName: "Condon",
    title: "Personal Trainer",
    slug: "christopher-condon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicole",
    lastName: "Confar",
    title: "Senior AIS Developer",
    slug: "nicole-confar",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Catherine",
    lastName: "Conley",
    title: "Research Administrator - Department of Dermatology",
    slug: "catherine-conley",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Brittanny",
    lastName: "Connelly",
    title: "Director for Pre-College Student Life",
    slug: "brittanny-connelly",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Michael",
    lastName: "Connetta",
    title: "Print Services Specialist",
    slug: "michael-connetta",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kerri",
    lastName: "Connolly",
    title: "Director of the Administrative Core, Advance-CTR",
    slug: "kerri-connolly",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brynne",
    lastName: "Connolly",
    title: "Senior Digital Content Producer",
    slug: "brynne-connolly",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Keirsten",
    lastName: "Connors",
    title: "Director of Student Financial Services & University Bursar",
    slug: "keirsten-connors",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Beth",
    lastName: "Conroy",
    title: "Associate Athletic Trainer",
    slug: "beth-conroy",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Christine",
    lastName: "Conway",
    title: "Director, Pre-Award Services",
    slug: "christine-conway",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Susan",
    lastName: "Coogan",
    title: "Graduate Recruitment Manager",
    slug: "susan-coogan",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Rachel",
    lastName: "Coogan",
    title: "IBEAM Manager",
    slug: "rachel-coogan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "David",
    lastName: "Cook",
    title: "CRM System Administrator",
    slug: "david-cook",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sayou",
    lastName: "Cooper",
    title: "ArtsCrew Marketing & Communications Assistant",
    slug: "sayou-cooper",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Martha",
    lastName: "Cooper",
    title: "Herbarium Curatorial Assistant",
    slug: "martha-cooper",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Janet",
    lastName: "Cooper Nelson",
    title: "Chaplain of The University",
    slug: "janet-cooper-nelson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Danny",
    lastName: "Cordeiro",
    title: "Lead CRM Developer",
    slug: "danny-cordeiro",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Scott",
    lastName: "Cordischi",
    title: "Manager of Broadcasting",
    slug: "scott-cordischi",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lilly",
    lastName: "Cordova",
    title: "IT Communications Manager",
    slug: "lilly-cordova",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jason",
    lastName: "Cornell",
    title: "Lead, Audio Visual Support",
    slug: "jason-cornell",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Arlene",
    lastName: "Correa",
    title: "Research Director",
    slug: "arlene-correa",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ben",
    lastName: "Correa-Goldberg",
    title: "ArtsCrew Marketing & Communications Assistant",
    slug: "ben-correa-goldberg",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Stefan",
    lastName: "Correia",
    title: "Brown Sports Network Production Crew",
    slug: "stefan-correia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Courtney",
    lastName: "Correia",
    title: "Application Support Specialist",
    slug: "courtney-correia",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Joshua",
    lastName: "Corria",
    title: "Assistant Director, City Relations",
    slug: "joshua-corria",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Carlin",
    lastName: "Corrigan",
    title: "Associate Director, Educational Media",
    slug: "carlin-corrigan",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Melissa",
    lastName: "Corso",
    title: "Administrative and Financial Coordinator",
    slug: "melissa-corso",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Luisa",
    lastName: "Cortes Mora",
    title: "Consultant Accountant",
    slug: "luisa-cortes-mora",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Vilma",
    lastName: "Cortez Jusayan",
    title: "Manager of Academic Affairs",
    slug: "vilma-cortez-jusayan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "James",
    lastName: "Cosby",
    title: "Supervisor, Central Heat Plant",
    slug: "james-cosby",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jason",
    lastName: "Costa",
    title: "Supervisor, BioMed Mailroom",
    slug: "jason-costa",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Caroline",
    lastName: "Costa",
    title: "Research Interviewer",
    slug: "caroline-costa",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Carla",
    lastName: "Costa",
    title: "Supervisor, Custodial Services",
    slug: "carla-costa",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Isabel",
    lastName: "Costa",
    title: "Director of Finance",
    slug: "isabel-costa",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Roberto",
    lastName: "Costa",
    title: "Communication Control Officer",
    slug: "roberto-costa",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Karen",
    lastName: "Costello",
    title: "Grants and Financial Coordinator",
    slug: "karen-costello",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Melissa",
    lastName: "Cote",
    title: "Administrative and Project Manager",
    slug: "melissa-cote",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shiyoko",
    lastName: "Cothren",
    title:
      " Associate Director of Administration, Cancer Center at Brown University",
    slug: "shiyoko-cothren",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alfred",
    lastName: "Coulombe",
    title: "Senior Endpoint/Hardware Services Specialist",
    slug: "alfred-coulombe",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Patricia",
    lastName: "Coulter",
    title: "Communications Manager",
    slug: "patricia-coulter",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jennifer",
    lastName: "Cournoyer",
    title: "Art Director",
    slug: "jennifer-cournoyer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carina",
    lastName: "Cournoyer",
    title: "Social Sciences Librarian",
    slug: "carina-cournoyer",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tracy",
    lastName: "Couto",
    title: "Customer Service Assistant",
    slug: "tracy-couto",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Arthur",
    lastName: "Couto",
    title: "Parking Officer",
    slug: "arthur-couto",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maria",
    lastName: "Couto",
    title: "Administrative Coordinator",
    slug: "maria-couto",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shannon",
    lastName: "Covill",
    title: "Associate Director, Contracts",
    slug: "shannon-covill",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "David",
    lastName: "Cox",
    title: "Athletic Trainer",
    slug: "david-cox",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dolores",
    lastName: "Cox",
    title: "Executive Assistant",
    slug: "dolores-cox",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nancy",
    lastName: "Coyne",
    title: "Pharmacist",
    slug: "nancy-coyne",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amy",
    lastName: "Cracco",
    title: "Director, IT Strategy, Project and Portfolio Management",
    slug: "amy-cracco",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ruth",
    lastName: "Crane",
    title: "Assistant Director of Administration and Finance",
    slug: "ruth-crane",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Linda",
    lastName: "Craven",
    title: "Baker",
    slug: "linda-craven",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Madyson",
    lastName: "Crawford",
    title: "Assistant Director, Sarah Doyle Center for Women and Gender",
    slug: "madyson-crawford",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Viola",
    lastName: "Crawford",
    title: "Administrative Coordinator",
    slug: "viola-crawford",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christopher",
    lastName: "Crawley",
    title: "Athletic Trainer",
    slug: "christopher-crawley",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Andrew",
    lastName: "Creamer",
    title: "Open Science Librarian",
    slug: "andrew-creamer",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Cory",
    lastName: "Crew",
    title: "Information Security Awareness and Training Specialist",
    slug: "cory-crew",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Stephen",
    lastName: "Crocker",
    title: "Video Producer",
    slug: "stephen-crocker",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Tracey",
    lastName: "Cronin",
    title: "Manager, Bio Med Graduate Studies",
    slug: "tracey-cronin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Susan",
    lastName: "Cronin",
    title: "Editorial Content Coordinator",
    slug: "susan-cronin",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ciara",
    lastName: "Cronin",
    title: "Athletics Marketing Intern",
    slug: "ciara-cronin",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kariamu",
    lastName: "Cross",
    title: "Tutor, Gateways Program",
    slug: "kariamu-cross",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jen",
    lastName: "Croteau",
    title: "Project Director",
    slug: "jen-croteau",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karen",
    lastName: "Crowley",
    title: "Manager of Health Data Science",
    slug: "karen-crowley",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Steven",
    lastName: "Cruickshank",
    title: "Senior Accounts Payable Specialist",
    slug: "steven-cruickshank",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Joe",
    lastName: "Crumlish",
    title: "ArtsCrew Production Assistant",
    slug: "joe-crumlish",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Graciphy",
    lastName: "Cruz",
    title: "Senior Assistant Director",
    slug: "graciphy-cruz",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Azurae",
    lastName: "Cruz",
    title: "Digital Media Producer",
    slug: "azurae-cruz",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Cinthya",
    lastName: "Cruz Colon",
    title: "ArtsCrew Production Assistant",
    slug: "cinthya-cruz-colon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Victoria",
    lastName: "Cuartas",
    title: "Coordinator of Undergraduate Programs",
    slug: "victoria-cuartas",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Megan",
    lastName: "Cullinane Healy",
    title: "Assistant Director of Athletics Compliance",
    slug: "megan-cullinane-healy",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "MJ",
    lastName: "Cunniff",
    title: "Archival Assistant",
    slug: "mj-cunniff",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ann",
    lastName: "Cunningham",
    title: "Sergeant",
    slug: "ann-cunningham",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nichole",
    lastName: "Curley",
    title: "Associate Controller",
    slug: "nichole-curley",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Christina",
    lastName: "Curley",
    title: "Director, Academic Records",
    slug: "christina-curley",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sean",
    lastName: "Curran",
    title:
      " Assistant Director for Education, Evaluation, and Advising, Gateways to Medicine, Healthcare and Research Program",
    slug: "sean-curran",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Connor",
    lastName: "Curtis",
    title: "SHARE Advocate",
    slug: "connor-curtis",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lynda",
    lastName: "Curtis",
    title: "Media Relations Manager",
    slug: "lynda-curtis",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Carol",
    lastName: "Cutler",
    title: "Lead Database Administrator",
    slug: "carol-cutler",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "John",
    lastName: "D'Aloisio",
    title: "Athletics Public Address Announcer",
    slug: "john-d-aloisio",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kara",
    lastName: "D'Ambrosio",
    title: "Director of Advancement Events",
    slug: "kara-d-ambrosio",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Nicole",
    lastName: "da Cruz",
    title: "Executive Director, Talent and Resource Management",
    slug: "nicole-da-cruz",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Emilia",
    lastName: "Da Lomba",
    title: "Cashier/Checker/Clerk",
    slug: "emilia-da-lomba",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jaci",
    lastName: "DaCosta",
    title: "Art Director",
    slug: "jaci-dacosta",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alex",
    lastName: "DaCosta",
    title: "UHR Intern",
    slug: "alex-dacosta",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Courtney",
    lastName: "DaCosta",
    title: "Field Coordinator, Event Support",
    slug: "courtney-dacosta",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Albert",
    lastName: "Dahlberg",
    title: "Associate Vice President for Government and Community Relations",
    slug: "albert-dahlberg",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Bobby",
    lastName: "Daigle",
    title: "Athletic Trainer",
    slug: "bobby-daigle",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brian",
    lastName: "Daigneault",
    title: "Senior Athletic Trainer",
    slug: "brian-daigneault",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Shawn",
    lastName: "Daily",
    title: "Talent Acquisition Sourcing Specialist",
    slug: "shawn-daily",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Sandra",
    lastName: "Dalomba",
    title: "Grants and Financial Specialist",
    slug: "sandra-dalomba",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Holly",
    lastName: "Damm",
    title: "Director of Development, Brown University Sports Foundation",
    slug: "holly-damm",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Errol",
    lastName: "Danehy",
    title: "Events Production Specialist",
    slug: "errol-danehy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cherie",
    lastName: "Daniel",
    title: "Communications Specialist",
    slug: "cherie-daniel",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sophia",
    lastName: "Daphnis",
    title: "Parent Giving and Engagement Officer",
    slug: "sophia-daphnis",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Kelly",
    lastName: "daPonte",
    title: "Grants and Contracts Manager",
    slug: "kelly-daponte",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Caitlyn",
    lastName: "Darcy",
    title: "Leadership Giving Officer",
    slug: "caitlyn-darcy",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Grace",
    lastName: "Darko",
    title: "Equipment Room Specialist",
    slug: "grace-darko",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Victoria",
    lastName: "DaRosa",
    title: "Service Response Coordinator",
    slug: "victoria-darosa",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melissa",
    lastName: "DaRosa",
    title: "Assistant Director of Advocacy and Engagement",
    slug: "melissa-darosa",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Manny",
    lastName: "Darosa",
    title: "Master Locksmith, Lead",
    slug: "manny-darosa",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sofia",
    lastName: "Darovskikh",
    title: "Communications Specialist",
    slug: "sofia-darovskikh",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ashton",
    lastName: "Darrett",
    title: "Associate Dean of Student Support Services",
    slug: "ashton-darrett",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kevin",
    lastName: "DaSilva",
    title: "Director, Network Technology",
    slug: "kevin-dasilva",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nicholas",
    lastName: "DaSilva",
    title: "Proteomics Core Manager",
    slug: "nicholas-dasilva",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stacey",
    lastName: "Daudelin",
    title: "Purchasing and Inventory Manager",
    slug: "stacey-daudelin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "R",
    lastName: "Davenport",
    title: "Managing Director, Brown Institute of Brain Science",
    slug: "r-davenport",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jennifer",
    lastName: "Davey",
    title: "Digital Communications Productions Specialist",
    slug: "jennifer-davey",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Patricia",
    lastName: "Davey",
    title: "Academic and Outreach Manager",
    slug: "patricia-davey",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Moses",
    lastName: "Davies",
    title: "Custodial Shift Assistant",
    slug: "moses-davies",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lisa",
    lastName: "Davila",
    title: "Project Director",
    slug: "lisa-davila",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jorge",
    lastName: "Davila-Carrasquillo",
    title: "Senior IT Help Desk Specialist",
    slug: "jorge-davila-carrasquillo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Evan",
    lastName: "Davis",
    title: "Research Intervention Counselor",
    slug: "evan-davis",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Yolanda",
    lastName: "Davis",
    title: "Assistant Dean, Pre-College Programs",
    slug: "yolanda-davis",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Amalia",
    lastName: "Davis",
    title: "Assistant Secretary of the Corporation",
    slug: "amalia-davis",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Lorna",
    lastName: "Dawes",
    title: "Exploration and Research Librarian",
    slug: "lorna-dawes",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Brian",
    lastName: "Dawson",
    title: "Benefits Data Manager",
    slug: "brian-dawson",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Meredith",
    lastName: "Dawson",
    title: "Director of Financial Planning and Analysis",
    slug: "meredith-dawson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Norka",
    lastName: "De La Rosa Ramirez",
    title: "Deans' Coordinator for Planning and Research",
    slug: "norka-de-la-rosa-ramirez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Andre",
    lastName: "De los santos",
    title: "Athletics Creative Content Assistant",
    slug: "andre-de-los-santos",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "John",
    lastName: "de Szendeffy",
    title: "Senior Learning Designer",
    slug: "john-de-szendeffy",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Amy",
    lastName: "Dean",
    title: "Associate Director of Athletics, Recreation",
    slug: "amy-dean",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jeana",
    lastName: "DeAngelis",
    title: "Personal Trainer",
    slug: "jeana-deangelis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erik",
    lastName: "DeAngelis",
    title: "Adjunct Reader",
    slug: "erik-deangelis",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "David",
    lastName: "DeAngelis",
    title: "Plumbing and Electrical Manager",
    slug: "david-deangelis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melissa",
    lastName: "DeAugustinis",
    title: "Manager of Research Management Support",
    slug: "melissa-deaugustinis",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michelle",
    lastName: "Debelak",
    title: "Executive Director of Planned Giving and Philanthropic Strategies",
    slug: "michelle-debelak",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Chris",
    lastName: "DeBlois",
    title: "Manager, IT Support Consultants",
    slug: "chris-deblois",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "William",
    lastName: "DeBlois",
    title: "Lead Database Administrator",
    slug: "william-deblois",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Taylor",
    lastName: "DeFreitas",
    title: "Seasonal Sales Associate",
    slug: "taylor-defreitas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eli",
    lastName: "DeFreitas",
    title: "Contract and Purchasing Specialist",
    slug: "eli-defreitas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Diane",
    lastName: "Deignan",
    title: "Grants and Financial Manager",
    slug: "diane-deignan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Gianni",
    lastName: "Dejesus",
    title: "Annual Leadership Giving Associate",
    slug: "gianni-dejesus",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Marielena",
    lastName: "Del Pozo",
    title: "Program Manager, Diversity, Equity, and Inclusion",
    slug: "marielena-del-pozo",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Daniel",
    lastName: "Del Valle",
    title: "Tutor, Gateways Program",
    slug: "daniel-del-valle",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Gabriela",
    lastName: "Delaney",
    title: "Senior Visual Designer",
    slug: "gabriela-delaney",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Clarissa",
    lastName: "DelGiudice",
    title: "Workplace Safety Specialist",
    slug: "clarissa-delgiudice",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Victoria",
    lastName: "Delmonico",
    title: "Grants and Financial Specialist",
    slug: "victoria-delmonico",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Shannon",
    lastName: "DeLuca",
    title:
      " Stamen Arrillaga Family Associate Dean of the College for Financial Advising",
    slug: "shannon-deluca",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Amber",
    lastName: "DeMalia",
    title: "University Scheduler",
    slug: "amber-demalia",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Anastasia",
    lastName: "Dementieva Scripter",
    title: "International Student Program Manager",
    slug: "anastasia-dementieva-scripter",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Delphain",
    lastName: "Demosthenes",
    title: "Associate University Chaplain for the Protestant Community",
    slug: "delphain-demosthenes",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Priscilla",
    lastName: "Demosthenous",
    title: "Financial Coordinator",
    slug: "priscilla-demosthenous",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kat",
    lastName: "DeNardo",
    title: "Human Resources Specialist",
    slug: "kat-denardo",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Kelsey",
    lastName: "Dennis",
    title: "Assistant Director, International Student Services",
    slug: "kelsey-dennis",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Mary",
    lastName: "Dennis",
    title: "Herbarium Assistant",
    slug: "mary-dennis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Flannery",
    lastName: "Denny",
    title: "Bootstrap Project Coordinator",
    slug: "flannery-denny",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicholas",
    lastName: "Dentamaro",
    title: "Senior Marketing and Communications Photographer",
    slug: "nicholas-dentamaro",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ryan",
    lastName: "DePasquale",
    title: "Assistant Director of Financial Aid",
    slug: "ryan-depasquale",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Kristen",
    lastName: "DePetro",
    title: "Financial Coordinator",
    slug: "kristen-depetro",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Brandon",
    lastName: "Deragon",
    title: "Hockey Equipment Specialist",
    slug: "brandon-deragon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anton",
    lastName: "Derevyanko",
    title: "Communications Specialist",
    slug: "anton-derevyanko",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Samuel",
    lastName: "DeRotto",
    title: "Athletics Marketing Intern",
    slug: "samuel-derotto",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dianne",
    lastName: "Desabris",
    title: "Welcome Center Specialist",
    slug: "dianne-desabris",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Nancy",
    lastName: "DeSousa",
    title: "Director of Institutional Equity and Diversity",
    slug: "nancy-desousa",
    dei: true,
    category: "Miscellaneous",
  },
  {
    firstName: "Matthew",
    lastName: "DeSousa",
    title: "Media Services Assistant",
    slug: "matthew-desousa",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lianne",
    lastName: "Desrosiers",
    title: "Executive Assistant",
    slug: "lianne-desrosiers",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Thomas",
    lastName: "Devine",
    title: "Steamfitter",
    slug: "thomas-devine",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melany",
    lastName: "Dew",
    title: "Graduate Recruitment Coordinator",
    slug: "melany-dew",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Alex",
    lastName: "Di Iorio",
    title: "Senior Business Intelligence Developer",
    slug: "alex-di-iorio",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Birkin",
    lastName: "Diana",
    title: "Lead Developer, Digital Technologies",
    slug: "birkin-diana",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Joseph",
    lastName: "Diaz",
    title:
      " Associate Dean for Diversity and Multicultural Affairs, Associate Professor of Medical Science, Associate Professor of Medicine",
    slug: "joseph-diaz",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Kayla",
    lastName: "Diaz",
    title: "Alumni Ambassadors Associate",
    slug: "kayla-diaz",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Karla",
    lastName: "Diaz Capeles",
    title: "Gynecological Exam",
    slug: "karla-diaz-capeles",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hernan",
    lastName: "Diaz Sosa",
    title: "Manager, IT Help Desk",
    slug: "hernan-diaz-sosa",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Barbara",
    lastName: "Dickinson",
    title: "Administrative Coordinator",
    slug: "barbara-dickinson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amanda",
    lastName: "Dickinson Beirne",
    title: "Associate Dean and Associate Director of Student Support Services",
    slug: "amanda-dickinson-beirne",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Rob",
    lastName: "Diehl",
    title: "Collections Assistant",
    slug: "rob-diehl",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kimberly",
    lastName: "Dieroff",
    title: "Athletics Marketing Manager",
    slug: "kimberly-dieroff",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Paul",
    lastName: "Dietel",
    title: "Assistant Vice President, Planning, Design & Construction",
    slug: "paul-dietel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jane",
    lastName: "Dietze",
    title: "Vice President and Chief Investment Officer",
    slug: "jane-dietze",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kara",
    lastName: "Diggins",
    title: "Cashier/Checker/Clerk",
    slug: "kara-diggins",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laurie",
    lastName: "DiLibero",
    title: "Senior IT Support Consultant",
    slug: "laurie-dilibero",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sheila",
    lastName: "Dillon",
    title: "Brown Alumni Magazine Managing Editor",
    slug: "sheila-dillon",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Gregory",
    lastName: "Dillon",
    title: "Learning Designer",
    slug: "gregory-dillon",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Karen",
    lastName: "DiMartino",
    title: "MTL Teaching Associate",
    slug: "karen-dimartino",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Diane",
    lastName: "DiMasi",
    title: "Lead Developer",
    slug: "diane-dimasi",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Carl",
    lastName: "Dimitri",
    title: "Senior Writer",
    slug: "carl-dimitri",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Nora",
    lastName: "Dimmock",
    title: "Deputy University Librarian",
    slug: "nora-dimmock",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Cutler",
    lastName: "Dimond",
    title: "Assistant Director of Planning and Analytics",
    slug: "cutler-dimond",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Violanta",
    lastName: "Diniz",
    title: "Cashier/Checker/Clerk - 52 Weeks",
    slug: "violanta-diniz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicholas",
    lastName: "Dionizio",
    title: "Athletics Event Worker",
    slug: "nicholas-dionizio",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Laura",
    lastName: "Dionne",
    title: "Data Manager",
    slug: "laura-dionne",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kathleen",
    lastName: "DiOrio",
    title: "Manager of Student Affairs",
    slug: "kathleen-diorio",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Bailey",
    lastName: "DiOrio",
    title: "Associate Director of Admission",
    slug: "bailey-diorio",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Constance",
    lastName: "DiPanfilo",
    title: "Senior Annual Leadership Giving Officer",
    slug: "constance-dipanfilo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mark",
    lastName: "Dirksen",
    title: "Radiation Safety Officer",
    slug: "mark-dirksen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Talin",
    lastName: "Dirocco",
    title: "IT Support Consultant",
    slug: "talin-dirocco",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mike",
    lastName: "DiToro",
    title: "Lead Windows System Administrator",
    slug: "mike-ditoro",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jennifer",
    lastName: "DiTusa",
    title: "Program Manager",
    slug: "jennifer-ditusa",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth",
    lastName: "Doherty",
    title: "Deputy Provost for Academic Affairs",
    slug: "elizabeth-doherty",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sasha",
    lastName: "Dolgicer",
    title: "Executive Director of Corporate and Foundation Relations",
    slug: "sasha-dolgicer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Heather",
    lastName: "Dominey",
    title: "Director, University Post-Award Services",
    slug: "heather-dominey",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Brittany",
    lastName: "Donahue",
    title: "Associate Director, Regional Engagement Programs",
    slug: "brittany-donahue",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jo-Ann",
    lastName: "Donatelli",
    title: "Project Director",
    slug: "jo-ann-donatelli",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Matthew",
    lastName: "Donato",
    title:
      " Executive Director, Center for Career Exploration & Associate Dean of the College",
    slug: "matthew-donato",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lisa",
    lastName: "Donham",
    title: "Vice President of Development",
    slug: "lisa-donham",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Laura",
    lastName: "Donnelly",
    title: "ArtsCrew Visitor Services Assistant",
    slug: "laura-donnelly",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Frank",
    lastName: "Donnelly",
    title: "Head, GIS and Data Services",
    slug: "frank-donnelly",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Pamela",
    lastName: "Donnelly",
    title: "Benefits Specialist",
    slug: "pamela-donnelly",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Katharine",
    lastName: "Donnelly",
    title: "Financial Services Specialist",
    slug: "katharine-donnelly",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kimberly",
    lastName: "Donovan",
    title: "Investment Director",
    slug: "kimberly-donovan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Anne-Marie",
    lastName: "Dorning",
    title: "Associate Vice President for Advancement Communications",
    slug: "anne-marie-dorning",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Joao",
    lastName: "Dos Santos",
    title: "Senior Application Developer",
    slug: "joao-dos-santos",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jaleesa",
    lastName: "Dos Santos",
    title: "Cashier/Checker/Clerk",
    slug: "jaleesa-dos-santos",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Phoebe",
    lastName: "Doscher",
    title: "Marketing Copywriter",
    slug: "phoebe-doscher",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kristy",
    lastName: "dosReis",
    title: "Director of Communications",
    slug: "kristy-dosreis",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Virginia",
    lastName: "Douglas",
    title: "Administrative and Events Coordinator",
    slug: "virginia-douglas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maria",
    lastName: "DoVale",
    title: "Communications and Events Specialist",
    slug: "maria-dovale",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sean",
    lastName: "Dowers Colon",
    title: "Administrative Lab Coordinator",
    slug: "sean-dowers-colon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christina",
    lastName: "Downs",
    title: "Senior Accountant",
    slug: "christina-downs",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Katie",
    lastName: "Doyle",
    title: "Managing Director",
    slug: "katie-doyle",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer",
    lastName: "Dressen",
    title: "Assistant Director, International Student Services",
    slug: "jennifer-dressen",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Simone",
    lastName: "Driscoll Nicholaus",
    title: "Seasonal Sales Associate",
    slug: "simone-driscoll-nicholaus",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Meredith",
    lastName: "Drozd",
    title: "Assistant to the Senior Vice President",
    slug: "meredith-drozd",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristen",
    lastName: "Drummey",
    title: "Health System Grants & Financial Specialist",
    slug: "kristen-drummey",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ja-Nae",
    lastName: "Duane",
    title: "Academic Director, Master’s in Innovation Management",
    slug: "ja-nae-duane",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Carlotta",
    lastName: "Duarte",
    title: "Service Response Coordinator",
    slug: "carlotta-duarte",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Justin",
    lastName: "Dubois",
    title: "Technical Assistant",
    slug: "justin-dubois",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Adam",
    lastName: "Dubuc",
    title: "ArtsCrew Preparator Assistant",
    slug: "adam-dubuc",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer",
    lastName: "Ducharme",
    title: "Administrative Coordinator",
    slug: "jennifer-ducharme",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer",
    lastName: "Duff",
    title: "Project Manager",
    slug: "jennifer-duff",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Patricia",
    lastName: "Duff",
    title: "Contract & Data Manager",
    slug: "patricia-duff",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maryann",
    lastName: "Duggan",
    title: "Data Coordinator",
    slug: "maryann-duggan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kimberly",
    lastName: "Duguay",
    title: "Project Manager",
    slug: "kimberly-duguay",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Madhuri",
    lastName: "Dugyala",
    title: "Psychotherapist, Graduate Student Focus",
    slug: "madhuri-dugyala",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jody",
    lastName: "Duhaime",
    title: "Training and Compliance Coordinator",
    slug: "jody-duhaime",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Sarah",
    lastName: "Dumas",
    title: "Assistant Director, Brown Annual Fund Initiatives",
    slug: "sarah-dumas",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jumoke",
    lastName: "Dumont",
    title: "Associate Director of BioMed Digital Solutions",
    slug: "jumoke-dumont",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jennifer",
    lastName: "Dunbar Yrigoyen",
    title: "Psychotherapist",
    slug: "jennifer-dunbar-yrigoyen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Steven",
    lastName: "Duncan",
    title: "Assistant CIO, Enterprise Applications",
    slug: "steven-duncan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jennifer",
    lastName: "Dunlap",
    title: "Rare Materials Cataloguer",
    slug: "jennifer-dunlap",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Diane",
    lastName: "Duphily",
    title: "Executive Assistant",
    slug: "diane-duphily",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christopher",
    lastName: "Dupont",
    title: "Captain",
    slug: "christopher-dupont",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tracy",
    lastName: "Dupras",
    title: "Financial Coordinator",
    slug: "tracy-dupras",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Megan",
    lastName: "Dupre",
    title: "Director of Alumni Experiences",
    slug: "megan-dupre",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lindsay",
    lastName: "Durant",
    title: "Proposal Coordinator",
    slug: "lindsay-durant",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Abigail",
    lastName: "Durmaz",
    title: "Senior Events Manager",
    slug: "abigail-durmaz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ayla",
    lastName: "Durst",
    title: "Project Manager",
    slug: "ayla-durst",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ben",
    lastName: "Dustin",
    title: "Senior IT Support Consultant",
    slug: "ben-dustin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lauren",
    lastName: "Dutchak",
    title: "Senior Associate Director of Admission",
    slug: "lauren-dutchak",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Juliet",
    lastName: "Duyster",
    title: "Director, Finance",
    slug: "juliet-duyster",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Faye",
    lastName: "Dvorchak",
    title: "Project Director",
    slug: "faye-dvorchak",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ryan",
    lastName: "Dwyer",
    title: "Media Services Specialist",
    slug: "ryan-dwyer",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Robert",
    lastName: "Eaton",
    title: "Director, Budget, Planning and Analysis",
    slug: "robert-eaton",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Becky",
    lastName: "Ebeling",
    title: "Director of Events and Internal Communications",
    slug: "becky-ebeling",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Karen",
    lastName: "Eberhart",
    title: "Head, Collections Services and Metadata",
    slug: "karen-eberhart",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rachelle",
    lastName: "Edgar",
    title: "Project Director",
    slug: "rachelle-edgar",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mark",
    lastName: "Edmonds",
    title: "Sergeant",
    slug: "mark-edmonds",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rachel",
    lastName: "Edwards Harvith",
    title: "Assistant Dean of the College for Careers in Arts & Media",
    slug: "rachel-edwards-harvith",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kelly",
    lastName: "Egan",
    title: "Associate Director, Creative Technologies",
    slug: "kelly-egan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dina",
    lastName: "Egge",
    title: "Academic Department Manager",
    slug: "dina-egge",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mamdouh",
    lastName: "Elanani",
    title: "Lead Report Developer",
    slug: "mamdouh-elanani",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nicholas",
    lastName: "Elias",
    title: "Athletics Marketing Intern",
    slug: "nicholas-elias",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jennifer",
    lastName: "Eliezer",
    title: "Associate Director of Learning Initiatives & Inclusive Community",
    slug: "jennifer-eliezer",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Hannah",
    lastName: "Elliot",
    title: "Lead, Media Support and Orchestration",
    slug: "hannah-elliot",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Cynthia",
    lastName: "Ellis",
    title: "Associate Dean of Student Support Services",
    slug: "cynthia-ellis",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Susan",
    lastName: "Ely",
    title: "Communications and Special Events Manager",
    slug: "susan-ely",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Youssef",
    lastName: "Elzahaby",
    title: "Lead UNIX System Administrator",
    slug: "youssef-elzahaby",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Heather",
    lastName: "Emerick",
    title: "Senior Learning Designer",
    slug: "heather-emerick",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lisa",
    lastName: "Emgushov",
    title: "Assistant Director of Research Administration",
    slug: "lisa-emgushov",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Francie",
    lastName: "Emlen",
    title: "Assistant Dean, Research Administration and Strategic Initiatives",
    slug: "francie-emlen",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Eric",
    lastName: "Emma",
    title: "Media Production Specialist",
    slug: "eric-emma",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sara",
    lastName: "Emmenecker",
    title: "Associate Director, Stewardship Reporting",
    slug: "sara-emmenecker",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sarah",
    lastName: "Enloe-Pelletier",
    title: "Marketing & Communications Coordinator",
    slug: "sarah-enloe-pelletier",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Susan",
    lastName: "Ennes",
    title: "Baker - 52 Weeks",
    slug: "susan-ennes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melissa",
    lastName: "Enos",
    title: "Financial Coordinator",
    slug: "melissa-enos",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Paige",
    lastName: "Eppenstein Anderson",
    title: "Seasonal Application Reader",
    slug: "paige-eppenstein-anderson",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Claire",
    lastName: "Erlandson",
    title: "Athletics Event Worker",
    slug: "claire-erlandson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cinthia",
    lastName: "Espinal",
    title: "Lead Administrative Coordinator",
    slug: "cinthia-espinal",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Luz",
    lastName: "Espinal",
    title: "Grants and Financial Specialist",
    slug: "luz-espinal",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Olanda",
    lastName: "Estrada-Dos Santos",
    title: "Academic Program Manager",
    slug: "olanda-estrada-dos-santos",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Stephanie",
    lastName: "Eto",
    title: "Associate Director of Admission",
    slug: "stephanie-eto",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Eliza",
    lastName: "Etter",
    title: "Director of Communications and Outreach",
    slug: "eliza-etter",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Mark",
    lastName: "Etzelmueller",
    title: "Research Development Manager",
    slug: "mark-etzelmueller",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Robin",
    lastName: "Eubank",
    title: "Director, Research Financial Compliance",
    slug: "robin-eubank",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nayeema",
    lastName: "Eusuf",
    title: "Seasonal Sales Associate",
    slug: "nayeema-eusuf",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chloe",
    lastName: "Evans",
    title: "Residential Area Coordinator",
    slug: "chloe-evans",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kerri",
    lastName: "Evans - Ruggieri",
    title: "Director of Research Administration and Information Systems",
    slug: "kerri-evans-ruggieri",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sarah",
    lastName: "Evelyn",
    title: "Director of Academic Engagement",
    slug: "sarah-evelyn",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Naby",
    lastName: "Exceus",
    title: "Residential Area Coordinator",
    slug: "naby-exceus",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Hanna",
    lastName: "Exel",
    title: "Brown-RISD Program Manager",
    slug: "hanna-exel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joseph",
    lastName: "Faial",
    title: "Catering Coordinator - 52 Weeks",
    slug: "joseph-faial",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Caitlin",
    lastName: "Fairfield Hasson",
    title: "Pre-College Seasonal Reader",
    slug: "caitlin-fairfield-hasson",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Laura",
    lastName: "Faken",
    title: "Director of Research Training Programs",
    slug: "laura-faken",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Amy",
    lastName: "Falcao",
    title: "Environmental Compliance Specialist",
    slug: "amy-falcao",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Grace",
    lastName: "Falken",
    title: "Project Director",
    slug: "grace-falken",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Xiaoyu",
    lastName: "Fan",
    title: "Research Computing Consultant",
    slug: "xiaoyu-fan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lynn",
    lastName: "Fanella",
    title: "MRI Facility Manager",
    slug: "lynn-fanella",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Walter",
    lastName: "Farber",
    title: "Associate Director for Advancement Reporting Services",
    slug: "walter-farber",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Diane",
    lastName: "Farber",
    title: "Psychotherapist",
    slug: "diane-farber",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maria",
    lastName: "Faria",
    title: "Admission Coordinator",
    slug: "maria-faria",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Robert",
    lastName: "Farizer",
    title: "Groundsworker",
    slug: "robert-farizer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kai",
    lastName: "Farje-Van Vlack",
    title: "Technical Assistant 1",
    slug: "kai-farje-van-vlack",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Timothy",
    lastName: "Fater",
    title: "Associate Vice President for Budget and Planning",
    slug: "timothy-fater",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Anees",
    lastName: "Fatima",
    title: "Assistant Director, Conflict of Interest and Research Integrity",
    slug: "anees-fatima",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Annabeth",
    lastName: "Faucher",
    title: "Assistant Director, Lifelong Learning",
    slug: "annabeth-faucher",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ann",
    lastName: "Favata",
    title: "Financial Specialist",
    slug: "ann-favata",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Charles",
    lastName: "Fay",
    title: "Lifeguard",
    slug: "charles-fay",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nat",
    lastName: "Feikes",
    title: "Admission Officer",
    slug: "nat-feikes",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Diane",
    lastName: "Felber",
    title: "Administrative Coordinator",
    slug: "diane-felber",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephen",
    lastName: "Felice",
    title: "Steamfitter",
    slug: "stephen-felice",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julianne",
    lastName: "Fenn",
    title: "Associate Director of Admission",
    slug: "julianne-fenn",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Amy",
    lastName: "Fernandes",
    title: "Finance/Billing Specialist",
    slug: "amy-fernandes",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Solanchi",
    lastName: "Fernandez",
    title: "Family & Community Engagement Specialist",
    slug: "solanchi-fernandez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mary",
    lastName: "Fernandez",
    title: "Project Manager",
    slug: "mary-fernandez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sean",
    lastName: "Ferns",
    title: "Frederic M. Alper Dean of Financial Aid",
    slug: "sean-ferns",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Briana",
    lastName: "Ferraioli",
    title: "Visual Design Specialist",
    slug: "briana-ferraioli",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Cynthia",
    lastName: "Ferreira",
    title: "Manager of Finance and Administration",
    slug: "cynthia-ferreira",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tracey",
    lastName: "Ferreira",
    title: "Grants and Financial Specialist",
    slug: "tracey-ferreira",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Paula",
    lastName: "Ferreira",
    title: "Financial Coordinator",
    slug: "paula-ferreira",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sandra",
    lastName: "Ferretti",
    title: "Program Director, Master of Healthcare Leadership",
    slug: "sandra-ferretti",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Emily",
    lastName: "Ferrier",
    title: "Head, Academic Engagement Liaison Services",
    slug: "emily-ferrier",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Victor",
    lastName: "Fesenmeyer",
    title: "ArtsCrew Production Assistant",
    slug: "victor-fesenmeyer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Vania",
    lastName: "Figueiredo",
    title: "Administrative Coordinator",
    slug: "vania-figueiredo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Farah",
    lastName: "Figuereo",
    title: "ArtsCrew Production Assistant",
    slug: "farah-figuereo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brenda",
    lastName: "Figueroa",
    title: "Senior Research Subcontracting Grant & Contract Administrator",
    slug: "brenda-figueroa",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Patricia",
    lastName: "Figueroa",
    title: "Curator, Iberian and Latin American Collections",
    slug: "patricia-figueroa",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bianca",
    lastName: "Figueroa-Santana",
    title: "Institutional Equity Investigator",
    slug: "bianca-figueroa-santana",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Amy",
    lastName: "Fink",
    title: "ArtsCrew Production Assistant",
    slug: "amy-fink",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kyle",
    lastName: "Finn",
    title: "Brown Sports Network Production Crew",
    slug: "kyle-finn",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bobby",
    lastName: "Fiorito",
    title: "Welcome Center Specialist",
    slug: "bobby-fiorito",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Mariesa",
    lastName: "Fischer",
    title: "ArtsCrew Visitor Services Assistant",
    slug: "mariesa-fischer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Corey",
    lastName: "Fitzgerald",
    title: "Psychotherapist / Outreach Coordinator",
    slug: "corey-fitzgerald",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robert",
    lastName: "Fitzgerald",
    title: "University Registrar",
    slug: "robert-fitzgerald",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rita",
    lastName: "Fitzgerald",
    title: "HR Administrative Specialist",
    slug: "rita-fitzgerald",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "John",
    lastName: "Flaherty",
    title: "Research Interviewer",
    slug: "john-flaherty",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katherine",
    lastName: "Fleck",
    title: "Director, University Pre-Award Services",
    slug: "katherine-fleck",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "RoseMary",
    lastName: "Fletcher",
    title: "Administrative Coordinator",
    slug: "rosemary-fletcher",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Thomas",
    lastName: "Flood",
    title: "Lead Windows System Administrator",
    slug: "thomas-flood",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Erin",
    lastName: "Flores",
    title: "Grants and Financial Specialist",
    slug: "erin-flores",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Andy",
    lastName: "Flores",
    title: "Shipping/Receiving Stockroom Coordinator",
    slug: "andy-flores",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Aline",
    lastName: "Flores",
    title: "Athletics Photography Assistant",
    slug: "aline-flores",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ariel",
    lastName: "Flowers",
    title: "The Divided America Project Archivist",
    slug: "ariel-flowers",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Suzanne",
    lastName: "Flynn",
    title: "Director, Finance and Administration",
    slug: "suzanne-flynn",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Emily",
    lastName: "Foeri",
    title: "Graduate Recruitment Coordinator",
    slug: "emily-foeri",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Kimberly",
    lastName: "Foeri",
    title: "Admission Coordinator",
    slug: "kimberly-foeri",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Nicholas",
    lastName: "Fogell",
    title: "Grants and Financial Coordinator",
    slug: "nicholas-fogell",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Emily",
    lastName: "Folan",
    title: "Events Coordinator",
    slug: "emily-folan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joseph",
    lastName: "Folcarelli",
    title: "Master Locksmith",
    slug: "joseph-folcarelli",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Deirdre",
    lastName: "Foley",
    title: "Academic Department Manager",
    slug: "deirdre-foley",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "James",
    lastName: "Foley",
    title: "Director, Digital Learning & Design",
    slug: "james-foley",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jacob",
    lastName: "Fonseca",
    title: "Human Resources Coordinator",
    slug: "jacob-fonseca",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Kathleen",
    lastName: "Fonseca",
    title: "Catering Event Specialist",
    slug: "kathleen-fonseca",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tiffany",
    lastName: "Fontaine-Helm",
    title: "Assistant Director, Employer Partnerships",
    slug: "tiffany-fontaine-helm",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rachel",
    lastName: "Fontes",
    title: "Cashier/Checker/Clerk",
    slug: "rachel-fontes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Matthew",
    lastName: "Force",
    title: "Fleet Manager",
    slug: "matthew-force",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bryant",
    lastName: "Ford",
    title: "Director of Psychological Services",
    slug: "bryant-ford",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ronald",
    lastName: "Foreman",
    title: "Director, Career Counseling",
    slug: "ronald-foreman",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Michael",
    lastName: "Forstadt",
    title: "Mashgiach",
    slug: "michael-forstadt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joie",
    lastName: "Forte",
    title: "Senior Associate Dean and Director of Student Activities",
    slug: "joie-forte",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kayla",
    lastName: "Fortes",
    title: "Cashier/Checker/Clerk",
    slug: "kayla-fortes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Zenaida",
    lastName: "Fortes",
    title: "Custodial Shift Assistant",
    slug: "zenaida-fortes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marisa",
    lastName: "Fortney",
    title:
      " Assistant Director, Stephen Robert '62 Campus Center & Student Activities",
    slug: "marisa-fortney",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Austin",
    lastName: "Foster",
    title: "Grants and Contracts Coordinator",
    slug: "austin-foster",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Elon",
    lastName: "Foster",
    title: "Rigger, Men's & Women's Crew",
    slug: "elon-foster",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Heather",
    lastName: "Fournier",
    title: "Assistant Director, Project Management",
    slug: "heather-fournier",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Heidi",
    lastName: "Fox",
    title: "Assistant Director of Nursing",
    slug: "heidi-fox",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah",
    lastName: "Fraidin Roggie",
    title: "Seasonal Reader",
    slug: "sarah-fraidin-roggie",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Paula",
    lastName: "Francis",
    title: "Grants and Financial Manager",
    slug: "paula-francis",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Michele",
    lastName: "Franco",
    title: "Administrative Coordinator",
    slug: "michele-franco",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brett",
    lastName: "Franklin",
    title: "Intramural and Club Sports Coordinator",
    slug: "brett-franklin",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lisa",
    lastName: "Frappier",
    title: "Psychiatrist",
    slug: "lisa-frappier",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrea",
    lastName: "Frazer",
    title: "Assistant Registrar for Graduate & Professional Education",
    slug: "andrea-frazer",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Donna",
    lastName: "Frazier",
    title: "Senior Accounts Payable Specialist",
    slug: "donna-frazier",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Faith",
    lastName: "Freeman",
    title: "Program Manager, Curricular Resource Center",
    slug: "faith-freeman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ivana",
    lastName: "Freitas",
    title: "Assistant Director of Global Programs",
    slug: "ivana-freitas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jocelyn",
    lastName: "Frelier",
    title: "Associate Director, Brown in Washington",
    slug: "jocelyn-frelier",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amanda",
    lastName: "Frias-Howard",
    title: "Administrative Coordinator",
    slug: "amanda-frias-howard",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kyle",
    lastName: "Frisolone",
    title: "Mail Clerk",
    slug: "kyle-frisolone",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Paul",
    lastName: "Frisone",
    title: "Manager of Football Player Development",
    slug: "paul-frisone",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tracy",
    lastName: "Frisone",
    title: "Associate Director of Financial Aid",
    slug: "tracy-frisone",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Julia",
    lastName: "Frizzell",
    title: "Senior IT Support Consultant",
    slug: "julia-frizzell",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Poppy",
    lastName: "Frost",
    title: "Assistant Director of Compliance",
    slug: "poppy-frost",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Makoto",
    lastName: "Fujisaki",
    title: "Seasonal Application Reader",
    slug: "makoto-fujisaki",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Sam",
    lastName: "Fulcomer",
    title: "HPC IT Architect",
    slug: "sam-fulcomer",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Emily",
    lastName: "Fulginiti",
    title: "Grants and Financial Specialist",
    slug: "emily-fulginiti",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kia",
    lastName: "Fuller",
    title: "HRPP Administrator",
    slug: "kia-fuller",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karla",
    lastName: "Gacasan",
    title:
      " Sr. Associate Director of Athletics for Human Resources & Talent Management",
    slug: "karla-gacasan",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Christina",
    lastName: "Gaffney",
    title: "Director of Enrollment Planning and Analysis",
    slug: "christina-gaffney",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Paul",
    lastName: "Gagne",
    title: "Supervisor, Custodial Services",
    slug: "paul-gagne",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Matthew",
    lastName: "Gagnon",
    title: "Chief Risk Officer",
    slug: "matthew-gagnon",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Charlie",
    lastName: "Gagnon",
    title: "Development Associate, Academic Initiatives",
    slug: "charlie-gagnon",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Danielle",
    lastName: "Gal",
    title: "Seasonal Application Reader",
    slug: "danielle-gal",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Lisa",
    lastName: "Gallant-Stanzione",
    title: "Executive Assistant",
    slug: "lisa-gallant-stanzione",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chris",
    lastName: "Gallogly",
    title: "Communications Manager",
    slug: "chris-gallogly",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Martin",
    lastName: "Gallogly",
    title: "Communications Specialist",
    slug: "martin-gallogly",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Clarence",
    lastName: "Gallop",
    title: "Lead Receiver",
    slug: "clarence-gallop",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katie",
    lastName: "Galvin",
    title: "Investment Director",
    slug: "katie-galvin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Emma",
    lastName: "Garcia",
    title: "Personal Trainer",
    slug: "emma-garcia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lindsay",
    lastName: "Garcia",
    title:
      " Associate Dean of the College for Junior/Senior Studies & Recovery and Substance-Free Student Initiatives",
    slug: "lindsay-garcia",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kelly",
    lastName: "Garcia",
    title: "Personal Trainer",
    slug: "kelly-garcia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jill",
    lastName: "Gardner",
    title: "Senior Director, Principal Gifts",
    slug: "jill-gardner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jonathan",
    lastName: "Garris",
    title: "Communications Specialist",
    slug: "jonathan-garris",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Carly",
    lastName: "Gasca",
    title: "Project Director",
    slug: "carly-gasca",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Leonora",
    lastName: "Gatto",
    title: "Administrative and Project Coordinator",
    slug: "leonora-gatto",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "James",
    lastName: "Gauthier",
    title: "Regional Development Director",
    slug: "james-gauthier",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brian",
    lastName: "Gauvin",
    title: "Lead Data Warehouse Architect",
    slug: "brian-gauvin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ryan",
    lastName: "Gavin",
    title: "Football Game Day Filmer",
    slug: "ryan-gavin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Antonelis",
    lastName: "Gaviria",
    title: "Grants and Financial Specialist",
    slug: "antonelis-gaviria",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Viktor",
    lastName: "Gavrielov",
    title:
      " Karuna Assistant Dean of the College for Careers in Technology & Tech Ventures",
    slug: "viktor-gavrielov",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Donna",
    lastName: "Gayer",
    title: "Payroll Taxation Specialist",
    slug: "donna-gayer",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Gregory",
    lastName: "Gaylord",
    title: "Direct Marketing Production Specialist",
    slug: "gregory-gaylord",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Maya",
    lastName: "Gee",
    title: "Senior Admission Officer",
    slug: "maya-gee",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Timothy",
    lastName: "Geer",
    title: "Assistant Director of Athletic Communications",
    slug: "timothy-geer",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lorrie",
    lastName: "Gehlbach",
    title: "Director, Academic Support",
    slug: "lorrie-gehlbach",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Joshua",
    lastName: "Geller",
    title: "Communication Control Officer",
    slug: "joshua-geller",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Thierry",
    lastName: "Gentis",
    title: "Head Curator",
    slug: "thierry-gentis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cris",
    lastName: "George",
    title: "Assistant Technical Director",
    slug: "cris-george",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tiffiney",
    lastName: "George",
    title: "Associate Director of Admission",
    slug: "tiffiney-george",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Steve",
    lastName: "Gerencser",
    title: "Director of Federal Relations",
    slug: "steve-gerencser",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kathleen",
    lastName: "Gerlach",
    title: "Department Manager",
    slug: "kathleen-gerlach",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Martires",
    lastName: "Germosen",
    title: "Manager, Custodial Services",
    slug: "martires-germosen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Olga",
    lastName: "Gervasi",
    title: "Fitness and Wellness Coordinator",
    slug: "olga-gervasi",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Stephanie",
    lastName: "Gesualdi",
    title: "Administrative Coordinator",
    slug: "stephanie-gesualdi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Caitlin",
    lastName: "Giannetti",
    title: "Career Counselor, STEM",
    slug: "caitlin-giannetti",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Tayla",
    lastName: "Giguere",
    title: "Project Coordinator",
    slug: "tayla-giguere",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eldridge",
    lastName: "Gilbert",
    title: "Leadership Coach, Health Equity Scholars Program",
    slug: "eldridge-gilbert",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christopher",
    lastName: "Gilbody",
    title: "Director of Financial Aid",
    slug: "christopher-gilbody",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Allison",
    lastName: "Gill",
    title: "Senior Director, Research and Prospect Development",
    slug: "allison-gill",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Michael",
    lastName: "Gillardi",
    title: "Accounts Payable Manager",
    slug: "michael-gillardi",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kellye",
    lastName: "Gilley",
    title: "Grants and Financial Specialist",
    slug: "kellye-gilley",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Logan",
    lastName: "Gin",
    title: "Assistant Director, STEM",
    slug: "logan-gin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nikole",
    lastName: "Giovannone",
    title: "Project Manager",
    slug: "nikole-giovannone",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michelle",
    lastName: "Giovino",
    title: "Senior AIS Developer",
    slug: "michelle-giovino",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Laurice",
    lastName: "Girouard",
    title: "Psychotherapist",
    slug: "laurice-girouard",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David",
    lastName: "Givens",
    title: "Director of Resource Acquisitions",
    slug: "david-givens",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lorrie",
    lastName: "Giventer",
    title: "Program Manager",
    slug: "lorrie-giventer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maria",
    lastName: "Glanvill",
    title: "Executive Assistant to the Dean and Graduate School Office Manager",
    slug: "maria-glanvill",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tammy",
    lastName: "Glass",
    title: "Administrative Coordinator",
    slug: "tammy-glass",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tristan",
    lastName: "Glenn",
    title:
      " Assistant Vice President of Inclusion, Campus Culture, and Engagement",
    slug: "tristan-glenn",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Brandi",
    lastName: "Glover",
    title: "Assistant Director, Post-Award Services",
    slug: "brandi-glover",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jaclyn",
    lastName: "Glover",
    title: "Senior Associate Director, Strategic Stewardship",
    slug: "jaclyn-glover",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Michelle",
    lastName: "Goldhaber",
    title: "Rabbinic Intern",
    slug: "michelle-goldhaber",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jacqueline",
    lastName: "Goldman",
    title: "Project Director",
    slug: "jacqueline-goldman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katherine",
    lastName: "Goldman",
    title: "Communications Manager",
    slug: "katherine-goldman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ed",
    lastName: "Goll",
    title: "Administrative Coordinator",
    slug: "ed-goll",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sam",
    lastName: "Gomberg",
    title: "ArtsCrew Production Assistant",
    slug: "sam-gomberg",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Aleid",
    lastName: "Gomes",
    title: "Supervisor, Custodial Services",
    slug: "aleid-gomes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katherine",
    lastName: "Gomez",
    title: "Administrative Communications Coordinator",
    slug: "katherine-gomez",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jason",
    lastName: "Gomez",
    title: "Custodial Shift Assistant",
    slug: "jason-gomez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hannah",
    lastName: "Gomez",
    title: "Communications and Outreach Manager",
    slug: "hannah-gomez",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jennifer",
    lastName: "Gomez",
    title: "Residential Area Coordinator",
    slug: "jennifer-gomez",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jessica",
    lastName: "Goncalo",
    title: "Administrative Coordinator",
    slug: "jessica-goncalo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amanda",
    lastName: "Goncalves",
    title: "Department Manager",
    slug: "amanda-goncalves",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sergio",
    lastName: "Gonzalez",
    title: "Senior Vice President for Advancement",
    slug: "sergio-gonzalez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Luis",
    lastName: "Gonzalez",
    title: "Building/Project Manager",
    slug: "luis-gonzalez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrez",
    lastName: "Gonzalez",
    title: "Technology Center Team Lead",
    slug: "andrez-gonzalez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Annette",
    lastName: "Gonzalez",
    title: "Executive Assistant and Office Manager",
    slug: "annette-gonzalez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Darius",
    lastName: "Gonzalez",
    title: "Seasonal Sales Associate",
    slug: "darius-gonzalez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bonny",
    lastName: "Gonzalez",
    title: "Associate Director, Budget, Planning, and Analysis",
    slug: "bonny-gonzalez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Hector",
    lastName: "Gonzalez",
    title: "Customer Service Coordinator",
    slug: "hector-gonzalez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rosa",
    lastName: "Gonzalez",
    title: "Cashier/Checker/Clerk",
    slug: "rosa-gonzalez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Diamond",
    lastName: "Gonzalez",
    title: "Grants and Financial Coordinator",
    slug: "diamond-gonzalez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Menny",
    lastName: "Gonzalez Miramontes",
    title: "Human Resources Coordinator",
    slug: "menny-gonzalez-miramontes",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Tyler",
    lastName: "Goodman",
    title: "Hardware Equipment Specialist",
    slug: "tyler-goodman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Paige",
    lastName: "Goodwine",
    title: "Residential Area Coordinator",
    slug: "paige-goodwine",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Vidya",
    lastName: "Gopalan",
    title: "Associate Director, Data Management",
    slug: "vidya-gopalan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Christopher",
    lastName: "Gordon",
    title: "Manager, Database Services",
    slug: "christopher-gordon",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Melanie",
    lastName: "Gorman",
    title: "Program Manager, COBRE",
    slug: "melanie-gorman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joan",
    lastName: "Gorman",
    title: "Interviewer",
    slug: "joan-gorman",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Colleen",
    lastName: "Gosetti",
    title: "Administrative Assistant",
    slug: "colleen-gosetti",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jamal",
    lastName: "Gould",
    title: "Stockroom Coordinator",
    slug: "jamal-gould",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Donna",
    lastName: "Gould",
    title: "Executive Director",
    slug: "donna-gould",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Noelle",
    lastName: "Gouvert",
    title: "Director of Recruitment",
    slug: "noelle-gouvert",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Stephanie",
    lastName: "Gove",
    title:
      " Mindfulness-Based Blood Pressure Reduction (MB-BPR) interventionist",
    slug: "stephanie-gove",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Josh",
    lastName: "Grab",
    title: "Visual Designer",
    slug: "josh-grab",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Michael",
    lastName: "Grabo",
    title: "Senior Associate General Counsel",
    slug: "michael-grabo",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Daniel",
    lastName: "Grady",
    title: "Campus Planner",
    slug: "daniel-grady",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Madeline",
    lastName: "Grady",
    title: "Athletic Trainer",
    slug: "madeline-grady",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Stacie",
    lastName: "Grant",
    title: "Executive Director, Brown University Sports Foundation",
    slug: "stacie-grant",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Raymond",
    lastName: "Grant",
    title: "Senior Associate Director of Athletics, Recreation",
    slug: "raymond-grant",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lucia",
    lastName: "Grappi",
    title: "Academic Records Coordinator",
    slug: "lucia-grappi",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Laurinda",
    lastName: "Grasso",
    title: "Executive Assistant and Office Administrator for Campus Life",
    slug: "laurinda-grasso",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Madeline",
    lastName: "Gravelle",
    title: "Production Management Assistant",
    slug: "madeline-gravelle",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michelle",
    lastName: "Graves",
    title: "Human Resources Specialist",
    slug: "michelle-graves",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Stephen",
    lastName: "Graydon",
    title: "Staff Assistant and Special Projects Coordinator",
    slug: "stephen-graydon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nina",
    lastName: "Grayson",
    title: "Financial Coordinator",
    slug: "nina-grayson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kirsten",
    lastName: "Green",
    title: "Athletics Chief of Staff",
    slug: "kirsten-green",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "James",
    lastName: "Green",
    title: "Deputy General Counsel",
    slug: "james-green",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Heather",
    lastName: "Green",
    title: "Project Coordinator",
    slug: "heather-green",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sara",
    lastName: "Green",
    title: "Nutrition and Sustainability Manager",
    slug: "sara-green",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joshua",
    lastName: "Greenberg",
    title: "Equipment Room Specialist",
    slug: "joshua-greenberg",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stacy",
    lastName: "Greenberg",
    title: "Executive Assistant",
    slug: "stacy-greenberg",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ashley",
    lastName: "Greene",
    title:
      " Director of Community Partnership/Assistant Dean of the College for Community Engagement",
    slug: "ashley-greene",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "John",
    lastName: "Greene",
    title: "Groundsworker",
    slug: "john-greene",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Geoffrey",
    lastName: "Greene",
    title: "Director, Departmental Systems",
    slug: "geoffrey-greene",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kyle",
    lastName: "Greene",
    title: "Assistant Director of Advancement Events",
    slug: "kyle-greene",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Tara",
    lastName: "Greenwood",
    title: "Financial and Administrative Coordinator",
    slug: "tara-greenwood",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Craig",
    lastName: "Grein",
    title: "Director, Post-Award Services",
    slug: "craig-grein",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lichen",
    lastName: "Grewer",
    title: "Director of Campus Planning",
    slug: "lichen-grewer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carolyn",
    lastName: "Gridelli",
    title: "Assistant Director, BioMed Human Resources",
    slug: "carolyn-gridelli",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Elizabeth",
    lastName: "Griffin",
    title: "Project Coordinator",
    slug: "elizabeth-griffin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Paul",
    lastName: "Griffin",
    title: "Project Manager",
    slug: "paul-griffin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cory",
    lastName: "Griffin",
    title: "Grants and Financial Specialist",
    slug: "cory-griffin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Natalie",
    lastName: "Grilli",
    title: "Human Resources Specialist",
    slug: "natalie-grilli",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Christopher",
    lastName: "Grossi",
    title: "Associate Director, Endpoint Systems and Software",
    slug: "christopher-grossi",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mary",
    lastName: "Grosvenor",
    title: "Leadership Giving Officer",
    slug: "mary-grosvenor",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Megan",
    lastName: "Grzybowski",
    title: "Associate Director, Employer Partnerships",
    slug: "megan-grzybowski",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Salvatore",
    lastName: "Gualtieri",
    title: "Athletics Communications Officer",
    slug: "salvatore-gualtieri",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sherry",
    lastName: "Gubata",
    title: "Senior Assistant Registrar for Systems Management",
    slug: "sherry-gubata",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jonah",
    lastName: "Guerin",
    title: "Intramural and Club Sport Manager",
    slug: "jonah-guerin",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lorraine",
    lastName: "Guerra",
    title: "ArtsCrew Visitor Services",
    slug: "lorraine-guerra",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Moytrayee",
    lastName: "Guha",
    title: "Assistant Director, Dean's Special Projects",
    slug: "moytrayee-guha",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Maria",
    lastName: "Guido",
    title: "Manager, Custodial Services",
    slug: "maria-guido",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Donovan",
    lastName: "Guin",
    title: "MTL Teaching Associate",
    slug: "donovan-guin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Katelyn",
    lastName: "Gundersen",
    title: "Associate Director, Advancement Events",
    slug: "katelyn-gundersen",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kestin",
    lastName: "Gussoff",
    title: "Assistant Registrar for University Scheduling",
    slug: "kestin-gussoff",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kayleigh",
    lastName: "Gustafson",
    title: "Associate Director, Marketing Communications",
    slug: "kayleigh-gustafson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Isabel",
    lastName: "Gutierrez",
    title: "Senior Benefits Programs Specialist",
    slug: "isabel-gutierrez",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Nora",
    lastName: "Guttman",
    title: "ArtsCrew Production Assistant",
    slug: "nora-guttman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Diego",
    lastName: "Guzman",
    title: "Cashier/Checker/Clerk",
    slug: "diego-guzman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erin",
    lastName: "Haas",
    title: "Seasonal Reader",
    slug: "erin-haas",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Kyle",
    lastName: "Haberle",
    title: "Athletics Event Worker",
    slug: "kyle-haberle",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "William",
    lastName: "Haberman",
    title: "Athletics Public Address Announcer",
    slug: "william-haberman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Carolyn",
    lastName: "Haddad",
    title: "Director of Class Giving and Initiatives",
    slug: "carolyn-haddad",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Justin",
    lastName: "Haggerty",
    title: "Payroll Manager",
    slug: "justin-haggerty",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Sheila",
    lastName: "Haggerty",
    title: "Associate Director",
    slug: "sheila-haggerty",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kayleigh",
    lastName: "Halasz",
    title: "Athletics Photography Assistant",
    slug: "kayleigh-halasz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Naushon",
    lastName: "Hale",
    title: "Museum Coordinator",
    slug: "naushon-hale",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kelly",
    lastName: "Haley",
    title: "Senior Project Manager",
    slug: "kelly-haley",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ivy",
    lastName: "Hall",
    title: "Financial Coordinator",
    slug: "ivy-hall",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Debra",
    lastName: "Hall",
    title: "Director, Regional Development",
    slug: "debra-hall",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Phoebe",
    lastName: "Hall",
    title: "Associate Director of BioMedical Communications",
    slug: "phoebe-hall",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Meghan",
    lastName: "Hall",
    title: "Events Consultant",
    slug: "meghan-hall",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brendan",
    lastName: "Halloran",
    title: "Chief Compliance Officer",
    slug: "brendan-halloran",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Maija",
    lastName: "Hallsmith",
    title: "Assistant Director of Graduate Academic Diversity",
    slug: "maija-hallsmith",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Eric",
    lastName: "Halpern",
    title: "Groundsworker",
    slug: "eric-halpern",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Courtney",
    lastName: "Hamann",
    title: "Manager of Finance and Administration",
    slug: "courtney-hamann",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Dana",
    lastName: "Hamdan",
    title: "Associate Vice President for Administration",
    slug: "dana-hamdan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael",
    lastName: "Hamel",
    title: "Groundsworker - Lead",
    slug: "michael-hamel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Todd",
    lastName: "Hampson",
    title: "Web Developer",
    slug: "todd-hampson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Charles",
    lastName: "Hampton",
    title: "Welcome Center Specialist",
    slug: "charles-hampton",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Rachel",
    lastName: "Hampton",
    title: "Senior Campus Planner",
    slug: "rachel-hampton",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rob",
    lastName: "Hancock",
    title: "Associate Dean of Strategic Communications",
    slug: "rob-hancock",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Alex",
    lastName: "Hand",
    title: "Grants and Financial Specialist",
    slug: "alex-hand",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Heather",
    lastName: "Hanjack",
    title: "Athletic Trainer",
    slug: "heather-hanjack",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "John",
    lastName: "Hanni",
    title: "Senior Groundsworker",
    slug: "john-hanni",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Madeline",
    lastName: "Hansen",
    title: "Grants and Financial Coordinator",
    slug: "madeline-hansen",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Carlyn",
    lastName: "Hansen-Decelles",
    title: "Assistant Director of Compliance",
    slug: "carlyn-hansen-decelles",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Kate",
    lastName: "Hao",
    title: "Curatorial Coordinator",
    slug: "kate-hao",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dianne",
    lastName: "Haritos",
    title: "Administrative Coordinator/Buyer",
    slug: "dianne-haritos",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Meaghan",
    lastName: "Harkin",
    title: "Development Coordinator",
    slug: "meaghan-harkin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Niyati",
    lastName: "Harneja",
    title: "HRPP Consultant",
    slug: "niyati-harneja",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julia",
    lastName: "Harnish",
    title: "Aquatics Coordinator",
    slug: "julia-harnish",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Iqra",
    lastName: "Haroon",
    title: "Grant/Contract Accountant I",
    slug: "iqra-haroon",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Diego",
    lastName: "Harrington",
    title: "Athletics Event Worker",
    slug: "diego-harrington",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Carolyn",
    lastName: "Harris",
    title: "Manager of Analytics, Curriculum and Student Programming",
    slug: "carolyn-harris",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Othniel",
    lastName: "Harris",
    title: "Program Manager, Taubman Center",
    slug: "othniel-harris",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Vincent",
    lastName: "Harris",
    title: "Associate Dean and Director of Brown Center for Students of Color",
    slug: "vincent-harris",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "David",
    lastName: "Harrisville",
    title: "Learning Designer",
    slug: "david-harrisville",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Isabelle",
    lastName: "Hart",
    title: "Grant/Contract Administrator",
    slug: "isabelle-hart",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Shannon",
    lastName: "Hartman",
    title: "Longitudinal Integrated Clerkship Coordinator",
    slug: "shannon-hartman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Peter",
    lastName: "Harty",
    title: "Senior Project Manager",
    slug: "peter-harty",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Christopher",
    lastName: "Harwood",
    title:
      " Director of Emergency Management, Resiliency and Business Continuity",
    slug: "christopher-harwood",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jan",
    lastName: "Hatfield",
    title: "Advancement Events Associate",
    slug: "jan-hatfield",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Courtney",
    lastName: "Hawes",
    title: "Project Manager",
    slug: "courtney-hawes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "William",
    lastName: "Hayes",
    title:
      " Assistant Director of Development, Brown University Sports Foundation",
    slug: "william-hayes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laura",
    lastName: "Haygood",
    title: "Health Sciences Librarian for Public Health",
    slug: "laura-haygood",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marley",
    lastName: "Haynes",
    title: "Athletics Ticket Representative",
    slug: "marley-haynes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dana",
    lastName: "Hayward",
    title: "Assistant Director for Assessment and Evaluation",
    slug: "dana-hayward",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Andrew",
    lastName: "Heald",
    title: "Director, Global Brown Center for International Students",
    slug: "andrew-heald",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Mimi",
    lastName: "Healy",
    title: "Project Associate",
    slug: "mimi-healy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Charles",
    lastName: "Heaney",
    title: "Custodial Shift Assistant",
    slug: "charles-heaney",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ethan",
    lastName: "Hebert",
    title: "Manager of Admissions and Enrollment Services",
    slug: "ethan-hebert",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Janice",
    lastName: "Hebert",
    title: "Executive Assistant",
    slug: "janice-hebert",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jen",
    lastName: "Heim",
    title: "Field Coordinator, Event Support",
    slug: "jen-heim",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karen",
    lastName: "Heine",
    title: "Grants and Financial Coordinator",
    slug: "karen-heine",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Bryan",
    lastName: "Heitzenrater",
    title: "Shipping and Receiving Clerk",
    slug: "bryan-heitzenrater",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Scott",
    lastName: "Helfrich",
    title: "Director of Residential Education",
    slug: "scott-helfrich",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Chris",
    lastName: "Hemmer",
    title: "Assistant Director, Brown University Sports Foundation",
    slug: "chris-hemmer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sean",
    lastName: "Hendricks",
    title:
      " Sr. Associate Director of Athletics for Student-Athlete Development",
    slug: "sean-hendricks",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Erica",
    lastName: "Hendricks",
    title: "Event Coordinator",
    slug: "erica-hendricks",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Maxime",
    lastName: "Hendrikse Liu",
    title: "ArtsCrew Production Assistant",
    slug: "maxime-hendrikse-liu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dylan",
    lastName: "Hennigan",
    title: "Program Administrative Manager",
    slug: "dylan-hennigan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Derek",
    lastName: "Henries",
    title: "Manager, Service Response Center",
    slug: "derek-henries",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laura",
    lastName: "Henriques",
    title: "Administrative Coordinator",
    slug: "laura-henriques",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joel",
    lastName: "Hernandez",
    title: "Financial Coordinator",
    slug: "joel-hernandez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Carlos",
    lastName: "Hernandez",
    title: "Director of Custodial Services Day/Evenings",
    slug: "carlos-hernandez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jesus",
    lastName: "Hernandez",
    title: "Director, Community-Engaged Learning",
    slug: "jesus-hernandez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Courtney",
    lastName: "Hernandez",
    title: "Administrative Coordinator",
    slug: "courtney-hernandez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Francisco",
    lastName: "Hernandez",
    title: "Senior Director, Diversity, Equity and Inclusion",
    slug: "francisco-hernandez",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Agueda",
    lastName: "Hernandez",
    title: "Cashier/Checker/Clerk",
    slug: "agueda-hernandez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yanilka",
    lastName: "Hernandez",
    title: "Manager of BioMed Contracting",
    slug: "yanilka-hernandez",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Silvina",
    lastName: "Hernandez Duran",
    title: "Assistant Director of Alumni Belonging",
    slug: "silvina-hernandez-duran",
    dei: true,
    category: "Miscellaneous",
  },
  {
    firstName: "Izra",
    lastName: "Hernandez Rivera",
    title: "Research Consultant",
    slug: "izra-hernandez-rivera",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Matt",
    lastName: "Herzfeld",
    title: "Grant Writer",
    slug: "matt-herzfeld",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sheila",
    lastName: "Hever",
    title: "Payroll and TDI Coordinator",
    slug: "sheila-hever",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Tyler",
    lastName: "Hie",
    title: "Direct Marketing Specialist",
    slug: "tyler-hie",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ashley",
    lastName: "Hill",
    title: "Associate Director, State Alliance",
    slug: "ashley-hill",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Simone",
    lastName: "Hill",
    title: "Grants and Financial Specialist",
    slug: "simone-hill",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sandra",
    lastName: "Hinthorn",
    title: "Financial and Administrative Coordinator",
    slug: "sandra-hinthorn",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jeffrey",
    lastName: "Hiris",
    title: "Director of Information Technology",
    slug: "jeffrey-hiris",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Brian",
    lastName: "Hiskey",
    title: "Senior Associate Director of Athletics, Governance & Compliance",
    slug: "brian-hiskey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "James",
    lastName: "Hlavacek",
    title: "Controller",
    slug: "james-hlavacek",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Christina",
    lastName: "Hodge",
    title: "Associate Director",
    slug: "christina-hodge",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Wendy",
    lastName: "Hoffman",
    title: "Merchandise Planner",
    slug: "wendy-hoffman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kelly",
    lastName: "Hogan",
    title: "Foreign National Payroll Specialist",
    slug: "kelly-hogan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Andrew",
    lastName: "Hollis",
    title:
      " Associate Director Graduate Student Activities and Student Leadership Development",
    slug: "andrew-hollis",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Emily",
    lastName: "Holt",
    title: "Reunion Giving Officer",
    slug: "emily-holt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bentley",
    lastName: "Holt",
    title: "Assistant Director, Communications and Outreach",
    slug: "bentley-holt",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Adam",
    lastName: "Holtzman",
    title: "Senior Web Developer",
    slug: "adam-holtzman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jay",
    lastName: "Holzer",
    title: "Executive Assistant",
    slug: "jay-holzer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Patrick",
    lastName: "Hood",
    title: "IT Support Consultant",
    slug: "patrick-hood",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jeana",
    lastName: "Horton",
    title: "Senior Institutional Equity Investigator",
    slug: "jeana-horton",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Kimberly",
    lastName: "Horvath",
    title: "Administrative and Financial Coordinator",
    slug: "kimberly-horvath",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Debi",
    lastName: "Horvath",
    title: "Assistant Director, Leave and Accommodation Services",
    slug: "debi-horvath",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Kate",
    lastName: "Howard",
    title: "Gift Compliance Officer",
    slug: "kate-howard",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Carla",
    lastName: "Howell",
    title: "Assistant Director, Post Award Services",
    slug: "carla-howell",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Elizabeth",
    lastName: "Hucul",
    title: "Project Coordinator",
    slug: "elizabeth-hucul",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexander",
    lastName: "Hugh",
    title: "Grants and Financial Specialist",
    slug: "alexander-hugh",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tara",
    lastName: "Hulbig",
    title: "Grants Specialist",
    slug: "tara-hulbig",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Shelly",
    lastName: "Hull",
    title: "Senior Grant/Contract Accountant",
    slug: "shelly-hull",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Patrick",
    lastName: "Humphrey",
    title: "Environmental Compliance Officer",
    slug: "patrick-humphrey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Megan",
    lastName: "Humphrey",
    title: "Director, Prospect Research",
    slug: "megan-humphrey",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Stephanie",
    lastName: "Hunt",
    title: "Director of Financial Aid",
    slug: "stephanie-hunt",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Christine",
    lastName: "Huntley",
    title: "Chief of Staff to the Dean",
    slug: "christine-huntley",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Peter",
    lastName: "Hurowitz",
    title: "ArtsCrew Production Assistant",
    slug: "peter-hurowitz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Johanna",
    lastName: "Hussey",
    title: "Director, Career & Life Design",
    slug: "johanna-hussey",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jim",
    lastName: "Hutchison",
    title: "Budget Administrator",
    slug: "jim-hutchison",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Cristine",
    lastName: "Hutchison-Jones",
    title: "Director of Special Projects",
    slug: "cristine-hutchison-jones",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "April",
    lastName: "Huth",
    title: "Digital Content Producer",
    slug: "april-huth",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "O'rya",
    lastName: "Hyde-Keller",
    title: "Associate Director, Alumni Communications",
    slug: "o-rya-hyde-keller",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "David",
    lastName: "Iannantuoni",
    title: "Athletics Public Address Announcer",
    slug: "david-iannantuoni",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brenda",
    lastName: "Ice",
    title: "Assistant Vice President for Residential and Community Living",
    slug: "brenda-ice",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Samiyah",
    lastName: "Iddinn",
    title: "Grant/Contract Accountant II",
    slug: "samiyah-iddinn",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Elisa",
    lastName: "Igliozzi",
    title: "Senior Gift Accountant",
    slug: "elisa-igliozzi",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Savanna",
    lastName: "Illinger",
    title: "Communications Coordinator",
    slug: "savanna-illinger",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Erin",
    lastName: "Indermill",
    title: "Assistant Director, Athletics Business Office",
    slug: "erin-indermill",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jane",
    lastName: "Indorf",
    title: "Manager of Undergraduate & Graduate Programs",
    slug: "jane-indorf",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Dilania",
    lastName: "Inoa",
    title: "Senior Manager, Community Partnership",
    slug: "dilania-inoa",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Afia",
    lastName: "Islam",
    title: "Assistant Director of Admission Systems",
    slug: "afia-islam",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Jocelyn",
    lastName: "Isley",
    title: "HRPP Consultant",
    slug: "jocelyn-isley",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Julia",
    lastName: "Issa",
    title: "Assistant Director, Communications",
    slug: "julia-issa",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Janet",
    lastName: "Isserlis",
    title: "Assistant Director, Curricular Resource Center",
    slug: "janet-isserlis",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rochelle",
    lastName: "Ives",
    title:
      " Administrative Project Manager and Executive Assistant to the Vice President",
    slug: "rochelle-ives",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John",
    lastName: "Ivy",
    title: "Regional Alliance Liaison",
    slug: "john-ivy",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sandhya",
    lastName: "Iyer",
    title: "Senior Vice President and General Counsel",
    slug: "sandhya-iyer",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Danielle",
    lastName: "Izzi",
    title: "Senior Events Manager",
    slug: "danielle-izzi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alberta",
    lastName: "Jacavone",
    title: "Lead Research Interviewer",
    slug: "alberta-jacavone",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Pippa",
    lastName: "Jack",
    title: "Editor & Publisher",
    slug: "pippa-jack",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jarred",
    lastName: "Jackson",
    title: "Planning Project Manager",
    slug: "jarred-jackson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katrina",
    lastName: "Jackson",
    title: "Director of Cataloging and Discovery",
    slug: "katrina-jackson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Avery",
    lastName: "Jackson",
    title: "Brown Sports Network Production Crew",
    slug: "avery-jackson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Seann",
    lastName: "Jackson",
    title: "Manager, Telecommunications",
    slug: "seann-jackson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mae",
    lastName: "Jackson",
    title: "Communications Specialist",
    slug: "mae-jackson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Elizabeth",
    lastName: "Jackvony",
    title: "Coordinator of Dual Degree Programs",
    slug: "elizabeth-jackvony",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Amy",
    lastName: "Jacobson",
    title: "Director, Regional Development",
    slug: "amy-jacobson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jason",
    lastName: "Jacques",
    title: "Manager, IT Support Consultants",
    slug: "jason-jacques",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Geeta",
    lastName: "Jakkaraju",
    title: "Learning Designer",
    slug: "geeta-jakkaraju",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jeffrey",
    lastName: "Jakulevicius",
    title: "Assistant Director, Compliance and Data Integrity",
    slug: "jeffrey-jakulevicius",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Elizabeth",
    lastName: "James",
    title: "Communications and Outreach Specialist",
    slug: "elizabeth-james",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Susan",
    lastName: "Jamiel",
    title: "Executive Assistant and Office Manager",
    slug: "susan-jamiel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jordan",
    lastName: "Jancosek",
    title: "Archivist, Collections Management and Accessioning",
    slug: "jordan-jancosek",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Denise",
    lastName: "Jandreski",
    title: "Executive Assistant to the Vice President for Regional Development",
    slug: "denise-jandreski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Allen",
    lastName: "Janicki",
    title: "Communication Control Officer",
    slug: "allen-janicki",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Christopher",
    lastName: "Janicki",
    title: "Custodial Shift Assistant",
    slug: "christopher-janicki",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cindy",
    lastName: "Jardin",
    title: "Senior IT Support Consultant",
    slug: "cindy-jardin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Caryl",
    lastName: "Jardon",
    title: "Grants and Financial Specialist",
    slug: "caryl-jardon",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Chonlada",
    lastName: "Jarukitisakul",
    title: "Psychotherapist",
    slug: "chonlada-jarukitisakul",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amar",
    lastName: "Jasti",
    title: "Manager, Enterprise and Research Storage Services",
    slug: "amar-jasti",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Anthony",
    lastName: "Jaworski",
    title: "Lead Windows System Administrator",
    slug: "anthony-jaworski",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kevin",
    lastName: "Jenkins",
    title: "Payroll Tax Compliance Manager",
    slug: "kevin-jenkins",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Diane",
    lastName: "Jensen",
    title: "Assistant Director, Compensation & Organizational Services",
    slug: "diane-jensen",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Wen",
    lastName: "Jian",
    title: "Senior Regional Director for International Advancement",
    slug: "wen-jian",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Wenjuan",
    lastName: "Jiang",
    title: "Senior Regional Director for International Advancement",
    slug: "wenjuan-jiang",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Charles",
    lastName: "Jin",
    title: "Investment Associate",
    slug: "charles-jin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sara",
    lastName: "Jlilati",
    title: "Academic Support Specialist",
    slug: "sara-jlilati",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Anna",
    lastName: "Joharjian",
    title: "Administrative Coordinator",
    slug: "anna-joharjian",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lexis",
    lastName: "Johnson",
    title: "Athletics Event Worker",
    slug: "lexis-johnson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Wrenford",
    lastName: "Johnson",
    title: "Director, Digital Transformation",
    slug: "wrenford-johnson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jennifer",
    lastName: "Johnson",
    title: "Associate HRPP Administrator",
    slug: "jennifer-johnson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Colin",
    lastName: "Johnson",
    title: "Director of Systems and Services",
    slug: "colin-johnson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Megan",
    lastName: "Johnson",
    title: "Project Coordinator",
    slug: "megan-johnson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Henry",
    lastName: "Johnson",
    title: "Senior IT Support Consultant",
    slug: "henry-johnson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Wilthonie",
    lastName: "Johnson-Goncalves",
    title: "Psychotherapist",
    slug: "wilthonie-johnson-goncalves",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristen",
    lastName: "Jones",
    title: "Executive Assistant",
    slug: "kristen-jones",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shannon",
    lastName: "Jones",
    title: "Grants and Financial Coordinator",
    slug: "shannon-jones",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jennifer",
    lastName: "Jones",
    title: "Director of Presidential Communications",
    slug: "jennifer-jones",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "August",
    lastName: "Jones",
    title: "Athletics Event Worker",
    slug: "august-jones",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Mary",
    lastName: "Jordan",
    title: "Director of New Student Programs and Community Initiatives",
    slug: "mary-jordan",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Laurie",
    lastName: "Jordan",
    title: "Executive Assistant",
    slug: "laurie-jordan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrew",
    lastName: "Jordan",
    title: "Senior Application Developer",
    slug: "andrew-jordan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tracy",
    lastName: "Jordan",
    title: "Director of Payroll Services and International Taxation",
    slug: "tracy-jordan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jamil",
    lastName: "Jorge",
    title: "Human Resources Specialist, ArtsCrew",
    slug: "jamil-jorge",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Susan",
    lastName: "Jorge",
    title: "Cashier/Checker/Clerk",
    slug: "susan-jorge",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ivan",
    lastName: "Joutz",
    title: "Lifeguard",
    slug: "ivan-joutz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rebecca",
    lastName: "Joyce",
    title: "Project Director (CADRE)",
    slug: "rebecca-joyce",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laura",
    lastName: "Joyce",
    title: "Manager, Continuum Magazine",
    slug: "laura-joyce",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Qiwen",
    lastName: "Ju",
    title: "Visual Designer",
    slug: "qiwen-ju",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sarah",
    lastName: "Justus",
    title: "Senior Stewardship Reporting Officer",
    slug: "sarah-justus",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jacqueline",
    lastName: "Jutras",
    title: "Administrative Coordinator",
    slug: "jacqueline-jutras",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amr",
    lastName: "Kaadan",
    title: "Tutor, Gateways Program",
    slug: "amr-kaadan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Victoria",
    lastName: "Kabakian",
    title: "Web and Digital Project Coordinator",
    slug: "victoria-kabakian",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Matt",
    lastName: "Kadrie",
    title: "Senior Report Developer",
    slug: "matt-kadrie",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kristi",
    lastName: "Kaeppel",
    title: "Senior Learning Designer",
    slug: "kristi-kaeppel",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Benjamin",
    lastName: "Kahn",
    title: "Assistant Director, Pre-Award Services",
    slug: "benjamin-kahn",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nicole",
    lastName: "Kaimer",
    title: "Accessibility and Learning Specialist",
    slug: "nicole-kaimer",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Laura",
    lastName: "Kalafarski",
    title: "Executive Assistant",
    slug: "laura-kalafarski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Theodore",
    lastName: "Kalaitzidis",
    title: "Assistant Director, Classroom Tech & Innovation",
    slug: "theodore-kalaitzidis",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Eric",
    lastName: "Kaldor",
    title: "Director for Assessment and Interdisciplinary Teaching Programs",
    slug: "eric-kaldor",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Cheryl",
    lastName: "Kaletsch",
    title: "Cataloging Assistant",
    slug: "cheryl-kaletsch",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah",
    lastName: "Kamara",
    title: "Key Service Center Manager",
    slug: "sarah-kamara",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melissa",
    lastName: "Kane",
    title: "Director of Online Program Development",
    slug: "melissa-kane",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Bruce",
    lastName: "Kane",
    title: "Lead Database Administrator",
    slug: "bruce-kane",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Benjamin",
    lastName: "Kaplan",
    title: "Preparator",
    slug: "benjamin-kaplan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erin",
    lastName: "Karalekas",
    title: "Administrative Coordinator, Support Services",
    slug: "erin-karalekas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lauren",
    lastName: "Karnes",
    title: "Financial Coordinator",
    slug: "lauren-karnes",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alexandra",
    lastName: "Karppinen",
    title: "Director of Biomedical Development",
    slug: "alexandra-karppinen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Len",
    lastName: "Katzman",
    title: "Director of Business Development",
    slug: "len-katzman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ertugrul",
    lastName: "Kaya",
    title: "Groundsworker",
    slug: "ertugrul-kaya",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David",
    lastName: "Keeffe",
    title: "Associate Vice President of Development, Principal Gifts",
    slug: "david-keeffe",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christopher",
    lastName: "Keith",
    title:
      " Vice President for Information Technology and Chief Information Officer",
    slug: "christopher-keith",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kara",
    lastName: "Kelley",
    title: "Chief of Staff",
    slug: "kara-kelley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrew",
    lastName: "Kelly",
    title:
      " Senior Associate Director of Athletics, Business Development and Revenue Generation",
    slug: "andrew-kelly",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Margaret",
    lastName: "Kelly",
    title: "Assistant Director for Systems and Processing",
    slug: "margaret-kelly",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Colleen",
    lastName: "Kelly",
    title: "Senior Associate Director of Athletics, Recruiting and Retention",
    slug: "colleen-kelly",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kathryn",
    lastName: "Kempton Amaral",
    title: "Senior Director of Public Health Leadership",
    slug: "kathryn-kempton-amaral",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maeghan",
    lastName: "Kennard",
    title: "Tutor, Gateways Program",
    slug: "maeghan-kennard",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Joshua",
    lastName: "Kennedy",
    title: "Deputy Chief Investment Officer",
    slug: "joshua-kennedy",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kathleen",
    lastName: "Kenney",
    title: "Director of Human Resources for the Office of the Provost",
    slug: "kathleen-kenney",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Michelle",
    lastName: "Kenny",
    title: "Graduate Admissions Officer",
    slug: "michelle-kenny",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Thomas",
    lastName: "Kenny",
    title: "Grants and Financial Specialist",
    slug: "thomas-kenny",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Earth",
    lastName: "Kentro",
    title: "Seasonal Sales Associate",
    slug: "earth-kentro",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anne",
    lastName: "Kerkian",
    title: "Associate Director for English Language Support",
    slug: "anne-kerkian",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jesse",
    lastName: "Kerstetter",
    title: "Program Manager, Community Mentoring & Service-Learning",
    slug: "jesse-kerstetter",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ronan",
    lastName: "Khalsa",
    title: "Bruno the Mascot",
    slug: "ronan-khalsa",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sohaib",
    lastName: "Khan",
    title: "Lead Hyper-V System Administrator",
    slug: "sohaib-khan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Natalia",
    lastName: "Kharkovskaia",
    title: "Events & Communications Coordinator",
    slug: "natalia-kharkovskaia",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Aixa",
    lastName: "Kidd",
    title:
      " Director, Partner Engagement & Deputy Director, Center for Career Exploration",
    slug: "aixa-kidd",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Thomas",
    lastName: "Kiefer",
    title: "Manual Machinist/Technical Officer",
    slug: "thomas-kiefer",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Alison",
    lastName: "Kiely",
    title: "Associate Director, Parent and Family Giving",
    slug: "alison-kiely",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Dan",
    lastName: "Kiley",
    title: "Athletics Event Worker",
    slug: "dan-kiley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christine",
    lastName: "Kilgus",
    title: "Events Manager",
    slug: "christine-kilgus",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Judy",
    lastName: "Kimberly",
    title: "Evaluation Director",
    slug: "judy-kimberly",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melissa",
    lastName: "Kimmell",
    title: "Development Coordinator",
    slug: "melissa-kimmell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julie",
    lastName: "Kindschy",
    title: "Manager, Admission",
    slug: "julie-kindschy",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Michelle",
    lastName: "King",
    title: "Continuing Medical Education Coordinator",
    slug: "michelle-king",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Olivia",
    lastName: "King",
    title: "Athletics Photography Assistant",
    slug: "olivia-king",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kathleen",
    lastName: "Kirk",
    title: "Assistant Director of Student & Partner Engagement",
    slug: "kathleen-kirk",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Matthew",
    lastName: "Kirkpatrick",
    title: "Athletic Trainer",
    slug: "matthew-kirkpatrick",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kendall",
    lastName: "Kitahara",
    title: "Admission Officer",
    slug: "kendall-kitahara",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Carly",
    lastName: "Kite Lapinski",
    title: "Vice President for Marketing Communications and Content Strategy",
    slug: "carly-kite-lapinski",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Rebecca",
    lastName: "Kittredge",
    title: "Manager of Audience Services",
    slug: "rebecca-kittredge",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Janaya",
    lastName: "Kizzie",
    title: "Processing Archivist",
    slug: "janaya-kizzie",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lutz",
    lastName: "Klein",
    title:
      " Digital Technology Specialist for Archaeology and the Ancient World",
    slug: "lutz-klein",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Thatcher",
    lastName: "Kling",
    title: "Athletics Photography Assistant",
    slug: "thatcher-kling",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nash",
    lastName: "Klinger",
    title: "Tutor, Gateways Program",
    slug: "nash-klinger",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "KB",
    lastName: "Knapp",
    title: "Investment Associate",
    slug: "kb-knapp",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Paul",
    lastName: "Knott",
    title: "Director of Development for Academic Initiatives",
    slug: "paul-knott",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Dee",
    lastName: "Knox",
    title: "Administrative Coordinator",
    slug: "dee-knox",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sara",
    lastName: "Knox",
    title: "Associate Director of Financial Aid",
    slug: "sara-knox",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Celinda",
    lastName: "Kofron",
    title: "Associate Dean, Educational Initiatives",
    slug: "celinda-kofron",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Charles",
    lastName: "Kolie",
    title: "Athletics Event Worker",
    slug: "charles-kolie",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Carl",
    lastName: "Kopf",
    title: "IT Support Consultant",
    slug: "carl-kopf",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Art",
    lastName: "Kopischke",
    title: "Theatrical Audio Video Supervisor",
    slug: "art-kopischke",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Natalie",
    lastName: "Kopp",
    title: "Director of Strategic Priorities",
    slug: "natalie-kopp",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Paul",
    lastName: "Koussa",
    title: "Associate Director, Research Systems",
    slug: "paul-koussa",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Allison",
    lastName: "Kowalewski",
    title: "Tutor, Gateways Program",
    slug: "allison-kowalewski",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kate",
    lastName: "Kraczon",
    title: "Exhibitions Director and Chief Curator",
    slug: "kate-kraczon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dayna",
    lastName: "Krakower",
    title: "Senior Associate Director of Admission",
    slug: "dayna-krakower",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Maxwell",
    lastName: "Krieger",
    title: "Project Director",
    slug: "maxwell-krieger",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hariharan",
    lastName: "Krishnaswamy",
    title: "Manager, Student Systems",
    slug: "hariharan-krishnaswamy",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Taryn",
    lastName: "Kubik",
    title: "Coordinator, Athletics Recruiting and Retention",
    slug: "taryn-kubik",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kofua",
    lastName: "Kulah",
    title: "Building Guard",
    slug: "kofua-kulah",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jeffrey",
    lastName: "Kulie",
    title: "Assistant Director for Advising, Student Support, and Outreach",
    slug: "jeffrey-kulie",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "David",
    lastName: "Kutcher",
    title: "Field Support Representative",
    slug: "david-kutcher",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Daniel",
    lastName: "LaBelle",
    title: "Talent Acquisition Manager",
    slug: "daniel-labelle",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jenna",
    lastName: "LaBombard",
    title: "Development Associate, Academic Initiatives",
    slug: "jenna-labombard",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sophia",
    lastName: "LaCava-Bohanan",
    title: "Associate Director, Partnerships and Engagement",
    slug: "sophia-lacava-bohanan",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kerry",
    lastName: "Lachmann",
    title: "Brown Alumni Magazine Advertising and Business Manager",
    slug: "kerry-lachmann",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Megan",
    lastName: "Lackie",
    title: "Communication and Events Specialist to the Dean",
    slug: "megan-lackie",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jennifer",
    lastName: "Lafaille",
    title: "Assistant Director of Financial Planning and Analysis",
    slug: "jennifer-lafaille",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Liisa",
    lastName: "Laine",
    title: "Project Specialist",
    slug: "liisa-laine",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jake",
    lastName: "Lally",
    title: "Tutor, Gateways Program",
    slug: "jake-lally",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Wunneanatsu",
    lastName: "Lamb-Cason",
    title: "Assistant Director",
    slug: "wunneanatsu-lamb-cason",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Courtney",
    lastName: "Lambrese",
    title: "Athletics Event Worker",
    slug: "courtney-lambrese",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kelly",
    lastName: "Lambrese",
    title: "Athletics Event Worker",
    slug: "kelly-lambrese",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Daniel",
    lastName: "Landi Conde",
    title: "Biological Safety Specialist",
    slug: "daniel-landi-conde",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer",
    lastName: "Lane",
    title: "Assistant Director, Business Intelligence",
    slug: "jennifer-lane",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Erin",
    lastName: "Lane-Aaronian",
    title: "Associate Director, Counseling and Psychological Services",
    slug: "erin-lane-aaronian",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Alex",
    lastName: "Langille",
    title: "Assistant Director of Marketing",
    slug: "alex-langille",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Zack",
    lastName: "Langway",
    title: "Vice President for Alumni Relations",
    slug: "zack-langway",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessica",
    lastName: "Lankering",
    title: "Assistant Director, Donor Recognition Programs",
    slug: "jessica-lankering",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mark",
    lastName: "Lanum",
    title: "Senior Director of Donor Relations",
    slug: "mark-lanum",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniel",
    lastName: "Lapati",
    title: "Custodial Shift Assistant",
    slug: "daniel-lapati",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Vanessa",
    lastName: "LaPorte",
    title: "Senior Events Manager",
    slug: "vanessa-laporte",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristofer",
    lastName: "Laratta",
    title: "Lead Web Developer",
    slug: "kristofer-laratta",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Karen",
    lastName: "Largess",
    title: "Alumni Relations Events Associate",
    slug: "karen-largess",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Derek",
    lastName: "Laroche",
    title: "IT Support Consultant",
    slug: "derek-laroche",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Alexis",
    lastName: "Larrea",
    title: "Director, Planned Giving",
    slug: "alexis-larrea",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "John",
    lastName: "Larsen",
    title: "Lead UNIX System Administrator",
    slug: "john-larsen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Hannah",
    lastName: "Larson",
    title: "Human Resources Specialist",
    slug: "hannah-larson",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Rodney",
    lastName: "Lartey-Otoo",
    title: "Athletics Public Address Announcer",
    slug: "rodney-lartey-otoo",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Nancy",
    lastName: "Laska",
    title: "Data Management Associate",
    slug: "nancy-laska",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sarah",
    lastName: "Latham",
    title: "Executive Vice President for Finance and Administration",
    slug: "sarah-latham",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Georgina",
    lastName: "Lau",
    title: "Class Giving Associate",
    slug: "georgina-lau",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alytheia",
    lastName: "Laughlin",
    title: "Center Manager",
    slug: "alytheia-laughlin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jerry",
    lastName: "Lavoie",
    title: "Director, Internal Consulting Group",
    slug: "jerry-lavoie",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jacob",
    lastName: "Lavoie",
    title: "Network Specialist",
    slug: "jacob-lavoie",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tina",
    lastName: "Lawber",
    title: "Grants Financial Manager (Post-Award)",
    slug: "tina-lawber",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Stacey",
    lastName: "Lawrence",
    title: "Director for STEM Initiatives",
    slug: "stacey-lawrence",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Bill",
    lastName: "Lawrence",
    title: "Racquet Court Attendant",
    slug: "bill-lawrence",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Richard",
    lastName: "Lawson",
    title: "IT Support Consultant",
    slug: "richard-lawson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Susan",
    lastName: "Layden",
    title: "Senior Director for Student Success and Chief of Staff",
    slug: "susan-layden",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Vanessa",
    lastName: "Lazar",
    title: "Assistant Director of Research Development",
    slug: "vanessa-lazar",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Amanda",
    lastName: "Lazarus",
    title: "Co-Executive Director of Annual Giving, Annual Leadership Giving",
    slug: "amanda-lazarus",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sasha",
    lastName: "Laziuk",
    title: "Administrative Coordinator",
    slug: "sasha-laziuk",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hung",
    lastName: "Le",
    title: "Medical Director of Sports Medicine",
    slug: "hung-le",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tina",
    lastName: "Leach",
    title: "ArtsCrew Producing Assistant",
    slug: "tina-leach",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Pedro",
    lastName: "Leal",
    title: "Associate Director for Digital Asset Management",
    slug: "pedro-leal",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Megan",
    lastName: "Leamy",
    title: "Associate Director for Web Strategy and Digital Solutions",
    slug: "megan-leamy",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jennifer",
    lastName: "LeBeau",
    title: "Administrative Coordinator",
    slug: "jennifer-lebeau",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Veronica",
    lastName: "Leblanc",
    title: "Assistant Director, IT Contracts",
    slug: "veronica-leblanc",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lisa",
    lastName: "Leblanc",
    title: "Executive Director of Advancement Data Services",
    slug: "lisa-leblanc",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Anna",
    lastName: "Lebrun",
    title: "Fitness and Wellness Manager",
    slug: "anna-lebrun",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carmen",
    lastName: "Leca",
    title: "Custodial Shift Assistant",
    slug: "carmen-leca",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katie",
    lastName: "LeClair",
    title: "Director of Stewardship and Donor Recognition",
    slug: "katie-leclair",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brittany",
    lastName: "Leclerc",
    title: "Academic Manager",
    slug: "brittany-leclerc",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Shannon",
    lastName: "Leclerc",
    title: "Athletics Event Worker",
    slug: "shannon-leclerc",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Brandon",
    lastName: "Ledoux",
    title: "Seasonal Sales Associate",
    slug: "brandon-ledoux",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Matthew",
    lastName: "Lee",
    title: "Assistant Director of Executive Leadership Support",
    slug: "matthew-lee",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "John",
    lastName: "Lee",
    title: "Shipping & Receiving Stockroom Manager",
    slug: "john-lee",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Priscilla",
    lastName: "Lee",
    title: "Associate Director of Engagement, West Coast",
    slug: "priscilla-lee",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Peter",
    lastName: "Lee",
    title: "Auditor 4",
    slug: "peter-lee",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Anja",
    lastName: "Lee",
    title: "Associate Dean of Student Support Services",
    slug: "anja-lee",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Gail",
    lastName: "Lee",
    title: "Human Resources Coordinator",
    slug: "gail-lee",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Bradford",
    lastName: "Lefoley",
    title: "Biological Safety Officer",
    slug: "bradford-lefoley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jaimy",
    lastName: "LeFort",
    title: "Service Response Coordinator",
    slug: "jaimy-lefort",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicole",
    lastName: "Legault",
    title: "Assistant Director, Workday Training and Communications",
    slug: "nicole-legault",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michael",
    lastName: "Leitao",
    title: "Systems Manager",
    slug: "michael-leitao",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Christina",
    lastName: "LeMarbre",
    title: "Senior Associate Director of International Admission",
    slug: "christina-lemarbre",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Kelly",
    lastName: "Lemieux",
    title: "Project Manager",
    slug: "kelly-lemieux",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lettie",
    lastName: "Lemoi",
    title: "Leave and Accommodations Administrative Coordinator",
    slug: "lettie-lemoi",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Mairelys",
    lastName: "Lemus-Rojas",
    title: "Head of Open Metadata Production and Initiatives",
    slug: "mairelys-lemus-rojas",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Marisa",
    lastName: "Lenardson",
    title: "Educational Media Producer, Videographer",
    slug: "marisa-lenardson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Violet",
    lastName: "Leroux",
    title: "Assistant Director, Career Network Engagement",
    slug: "violet-leroux",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sophia",
    lastName: "Leuci",
    title: "Lifeguard",
    slug: "sophia-leuci",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kylie",
    lastName: "Leung",
    title: "Tutor, Gateways Program",
    slug: "kylie-leung",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ryan",
    lastName: "Leverone",
    title: "Financial and Administrative Coordinator",
    slug: "ryan-leverone",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jennifer",
    lastName: "Levesque",
    title: "Finance Manager",
    slug: "jennifer-levesque",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jill",
    lastName: "Levin",
    title: "Class Giving Officer",
    slug: "jill-levin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kate",
    lastName: "Levin",
    title: "Associate Director for Marketing and Communications",
    slug: "kate-levin",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Peter",
    lastName: "Levine",
    title: "Managing Director",
    slug: "peter-levine",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Allison",
    lastName: "Levy",
    title: "Director, Brown University Digital Publications",
    slug: "allison-levy",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ximena",
    lastName: "Levy",
    title: "Director of Regulatory Advising",
    slug: "ximena-levy",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Mark-Anthony",
    lastName: "Lewis",
    title: "Deans Communications Specialist",
    slug: "mark-anthony-lewis",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jean",
    lastName: "Lewis",
    title: "Brown Alumni Magazine Advertising Sales Agent",
    slug: "jean-lewis",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Meghan",
    lastName: "Lewis",
    title: "Coordinator for Dean's Initiative and Planning",
    slug: "meghan-lewis",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Bailey",
    lastName: "Lewis",
    title: "Athletic Trainer",
    slug: "bailey-lewis",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jessica",
    lastName: "Li",
    title: "Assistant Director of Communications",
    slug: "jessica-li",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Scott",
    lastName: "Li",
    title: "Assistant Dean of the College for Careers in Finance & Consulting",
    slug: "scott-li",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Joe",
    lastName: "Li",
    title: "Director of Operational Due Diligence",
    slug: "joe-li",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jing",
    lastName: "Liang",
    title: "Administrative and Financial Coordinator",
    slug: "jing-liang",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Perry",
    lastName: "Liberty",
    title: "Associate Director of Gift Compliance",
    slug: "perry-liberty",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Andre",
    lastName: "Lie",
    title: "Lead Database Administrator",
    slug: "andre-lie",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Katie",
    lastName: "Liesener",
    title: "Communications Manager",
    slug: "katie-liesener",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Leneli",
    lastName: "Liggayu",
    title: "Program Manager",
    slug: "leneli-liggayu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carleia",
    lastName: "Lighty",
    title: "Director, Transportation & Brown Card Services",
    slug: "carleia-lighty",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ernest",
    lastName: "Lilavois",
    title: "Senior IT Support Consultant",
    slug: "ernest-lilavois",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Zhichun",
    lastName: "Lin",
    title:
      " Associate Director, Career Counseling & Graduate Student Professional Development",
    slug: "zhichun-lin",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Mark",
    lastName: "Lindenberg",
    title: "Groundsworker - Lead/Landscape Maintenance",
    slug: "mark-lindenberg",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Scottye",
    lastName: "Lindsey",
    title: "Assistant Dean of the College for Careers in Finance & Consulting",
    slug: "scottye-lindsey",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Morgan",
    lastName: "Linzmeier",
    title: "Graduate Recruitment Coordinator",
    slug: "morgan-linzmeier",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Emma",
    lastName: "Lipinski",
    title: "Recruitment Events Coordinator",
    slug: "emma-lipinski",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Rebekah",
    lastName: "Lippiatt",
    title: "Administrative Assistant",
    slug: "rebekah-lippiatt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amy",
    lastName: "Lipsitz",
    title: "Director of Marketing and Digital Content Strategy",
    slug: "amy-lipsitz",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Donna",
    lastName: "Lisker",
    title: "Chief of Staff to the Senior Vice President for Advancement",
    slug: "donna-lisker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jill",
    lastName: "Litman",
    title: "Personal Trainer",
    slug: "jill-litman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yang",
    lastName: "Liu",
    title: "Assistant Director, Research Computing Services",
    slug: "yang-liu",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Shuyuan",
    lastName: "Liu",
    title: "Assistant Director of English Language Support",
    slug: "shuyuan-liu",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michael",
    lastName: "Liu",
    title: "Assistant Director, Research Subcontracting",
    slug: "michael-liu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gladys",
    lastName: "Loa",
    title: "Senior Front-end Web Developer",
    slug: "gladys-loa",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Yessenia",
    lastName: "Lobo",
    title: "Admissions Coordinator",
    slug: "yessenia-lobo",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Timothy",
    lastName: "Lockhart",
    title: "Senior IT Support Consultant",
    slug: "timothy-lockhart",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "David",
    lastName: "Loerke",
    title: "Director, Corporate and Foundation Relations",
    slug: "david-loerke",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jeanne",
    lastName: "Loewenstein",
    title: "Academic Program Manager",
    slug: "jeanne-loewenstein",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "John",
    lastName: "Logan",
    title: "Assistant Director, Brown Sports Foundation Annual Giving",
    slug: "john-logan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "James",
    lastName: "Logan",
    title: "Peer Support Specialist",
    slug: "james-logan",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Victoria",
    lastName: "Lonardo",
    title: "Program Assistant, Leadership Institute Program",
    slug: "victoria-lonardo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jaime",
    lastName: "Longval",
    title: "Grants Coordinator - Dept of Dermatology",
    slug: "jaime-longval",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Albertino",
    lastName: "Lopes",
    title: "Custodial Shift Assistant",
    slug: "albertino-lopes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Fifi",
    lastName: "Lopes",
    title: "Cashier/Checker/Clerk",
    slug: "fifi-lopes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jaelah",
    lastName: "Lopes",
    title: "Administrative HR Coordinator",
    slug: "jaelah-lopes",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Anabela",
    lastName: "Lopes",
    title: "Supervisor, Custodial Services",
    slug: "anabela-lopes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Esmeralda",
    lastName: "Lopez",
    title: "Administrative Department Manager",
    slug: "esmeralda-lopez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marcelo",
    lastName: "Lopez",
    title: "IT Support Consultant",
    slug: "marcelo-lopez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jose",
    lastName: "Lopez",
    title: "Director of Internal Audits",
    slug: "jose-lopez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Pedro",
    lastName: "Lopez",
    title: "Director, Gift Accounting",
    slug: "pedro-lopez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Pedro",
    lastName: "Lora Torres",
    title: "Grant/Contract Accountant II",
    slug: "pedro-lora-torres",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Betsy",
    lastName: "Loucks",
    title: "Associate Director, Research Strategy Development",
    slug: "betsy-loucks",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michelle",
    lastName: "Lough",
    title: "Executive Director of Alumni Relations",
    slug: "michelle-lough",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marshall",
    lastName: "Love",
    title: "Chief of Staff",
    slug: "marshall-love",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jarrah",
    lastName: "Lovejoy",
    title: "Associate Director, Alumni Events and Experiences",
    slug: "jarrah-lovejoy",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Leo",
    lastName: "Lovemore",
    title: "Librarian for History, Society, and Culture",
    slug: "leo-lovemore",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Leah",
    lastName: "Lovgren",
    title: "Associate Director for Research and Program Management",
    slug: "leah-lovgren",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Bryce",
    lastName: "Lowry",
    title: "Graduate Admissions Counselor",
    slug: "bryce-lowry",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Kelsey",
    lastName: "Lubin",
    title: "Assistant Director of Research Integrity",
    slug: "kelsey-lubin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Amanda",
    lastName: "Lucciarini",
    title: "Grants and Contracts Coordinator",
    slug: "amanda-lucciarini",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jen",
    lastName: "Lucero",
    title:
      " Assistant Director and Safety Specialist for the Performing and Visual Arts",
    slug: "jen-lucero",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Megan",
    lastName: "Ludlow",
    title: "Assistant Director, Pre-Professional Advising",
    slug: "megan-ludlow",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "John",
    lastName: "Luipold",
    title:
      " Vice President for Business Affairs, Auxiliary Services and Real Estate",
    slug: "john-luipold",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christopher",
    lastName: "Lujan",
    title: "Associate Dean & Associate Director of Student Support Services",
    slug: "christopher-lujan",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Cristin",
    lastName: "Lukasiewicz",
    title: "Pharmacist",
    slug: "cristin-lukasiewicz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nisha",
    lastName: "Lulla",
    title: "Chief of Staff to the Dean of the School of Public Health",
    slug: "nisha-lulla",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Oke",
    lastName: "Lundin",
    title: "Manager, Technology Projects",
    slug: "oke-lundin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Shelley",
    lastName: "Lundin",
    title: "Athletic Trainer",
    slug: "shelley-lundin",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jinping",
    lastName: "Luo",
    title: "Director, Transgenic Facility",
    slug: "jinping-luo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dave",
    lastName: "Lustberg",
    title: "Athletics Event Worker",
    slug: "dave-lustberg",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lily",
    lastName: "Lustig",
    title: "Communications Coordinator",
    slug: "lily-lustig",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jerrie",
    lastName: "Lyndon-Sylvia",
    title: "ArtsCrew Visitor Services",
    slug: "jerrie-lyndon-sylvia",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Benjamin",
    lastName: "Lyons",
    title: "Senior Technical Assistant",
    slug: "benjamin-lyons",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Alexander",
    lastName: "Lyte",
    title: "Grants and Financial Specialist",
    slug: "alexander-lyte",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jasmine",
    lastName: "Lyth",
    title: "Athletics Event Worker",
    slug: "jasmine-lyth",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marco",
    lastName: "Ma",
    title: "Technical and Internship Engagement Specialist",
    slug: "marco-ma",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ufuoma",
    lastName: "MaCaulay Thaddeus",
    title: "Tutor, Gateways Program",
    slug: "ufuoma-macaulay-thaddeus",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lindsay",
    lastName: "MacDonald",
    title: "Research Compliance Assistant",
    slug: "lindsay-macdonald",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Iris",
    lastName: "Macedo",
    title: "ArtsCrew Visitor Services",
    slug: "iris-macedo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Peter",
    lastName: "Mackie",
    title: "Sports Archivist",
    slug: "peter-mackie",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Caleigh",
    lastName: "MacKinnon",
    title: "Residential Area Coordinator",
    slug: "caleigh-mackinnon",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Robert",
    lastName: "Mackisey",
    title: "Lieutenant",
    slug: "robert-mackisey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christopher",
    lastName: "Macri",
    title: "Reunion Giving Officer",
    slug: "christopher-macri",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Agnes",
    lastName: "Madriaga",
    title: "Lead Administrative Coordinator",
    slug: "agnes-madriaga",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ismael",
    lastName: "Madrigal",
    title: "Supervisor, Custodial Services (3rd shift - part time)",
    slug: "ismael-madrigal",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jeffrey",
    lastName: "Magill",
    title: "EMS Shift Supervisor",
    slug: "jeffrey-magill",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Danielle",
    lastName: "Magivney",
    title: "Health System Grant & Financial Specialist",
    slug: "danielle-magivney",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Imanah",
    lastName: "Mahmoud",
    title: "Associate Director, Regional and Generational Programs",
    slug: "imanah-mahmoud",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stefanie",
    lastName: "Mahon",
    title: "Human Resources Specialist",
    slug: "stefanie-mahon",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Andrew",
    lastName: "Majcher",
    title: "Head, Digital Services and Records Management",
    slug: "andrew-majcher",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mia",
    lastName: "Maldonado",
    title: "Adjunct Reader",
    slug: "mia-maldonado",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Robert",
    lastName: "Malekoff",
    title: "Athletics Event Worker",
    slug: "robert-malekoff",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristin",
    lastName: "Malloy",
    title: "Compliance Director",
    slug: "kristin-malloy",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Carolyn",
    lastName: "Malone",
    title: "Project Coordinator",
    slug: "carolyn-malone",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer",
    lastName: "Maloney",
    title: "Assistant Director, CME Accreditation and Special Projects",
    slug: "jennifer-maloney",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "MJ",
    lastName: "Malpiedi",
    title: "Manager, Staff Engagement Programs",
    slug: "mj-malpiedi",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Patricia",
    lastName: "Mancieri",
    title: "Undergraduate Concentration Coordinator",
    slug: "patricia-mancieri",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Danielle",
    lastName: "Mancini",
    title: "Grants and Financial Specialist",
    slug: "danielle-mancini",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Bertie",
    lastName: "Mandelblatt",
    title: "George S. Parker II ’51 Curator of Maps and Prints",
    slug: "bertie-mandelblatt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brittany",
    lastName: "Mandeville",
    title: "Academic Support Specialist",
    slug: "brittany-mandeville",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Maria",
    lastName: "Manino",
    title: "Financial and Administrative Coordinator",
    slug: "maria-manino",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Margaret",
    lastName: "Manning",
    title:
      " Assistant Director, Limited Submission, Internal Funding, and Awards",
    slug: "margaret-manning",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mac",
    lastName: "Manning",
    title: "Director, Office of Military Affiliated Students",
    slug: "mac-manning",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Alice",
    lastName: "Manning",
    title: "CRM System Administrator",
    slug: "alice-manning",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Becca",
    lastName: "Manning Szabo",
    title: "Marketing Editorial Manager & Copywriter",
    slug: "becca-manning-szabo",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Georgina",
    lastName: "Manok",
    title: "Senior Director of Strategy and Assessment",
    slug: "georgina-manok",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eric",
    lastName: "Manthei",
    title: "Financial Coordinator",
    slug: "eric-manthei",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Dan",
    lastName: "Manuyag",
    title: "Seasonal Reader",
    slug: "dan-manuyag",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Cal",
    lastName: "Manuzza",
    title: "Project Coordinator",
    slug: "cal-manuzza",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sherri",
    lastName: "Marcantonio",
    title: "Communication Control Officer",
    slug: "sherri-marcantonio",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Adrienne",
    lastName: "Marcus",
    title: "Dean, Pre-College and Undergraduate Programs",
    slug: "adrienne-marcus",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Maria",
    lastName: "Marin",
    title: "Program Manager",
    slug: "maria-marin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "A",
    lastName: "Marinelli",
    title: "SPS Teaching Associate - MHL",
    slug: "a-marinelli",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Margaret",
    lastName: "Marisi",
    title: "Manager, Administrative Services",
    slug: "margaret-marisi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniel",
    lastName: "Mark",
    title: "Senior Admission Officer",
    slug: "daniel-mark",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Paul",
    lastName: "Marsella",
    title: "Lead, Media Production",
    slug: "paul-marsella",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Hugo",
    lastName: "Martin",
    title: "ArtsCrew Production Assistant",
    slug: "hugo-martin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jonathan",
    lastName: "Martin",
    title: "Athletics Event Worker",
    slug: "jonathan-martin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jane",
    lastName: "Martin",
    title: "Financial Coordinator",
    slug: "jane-martin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lehua",
    lastName: "Martin",
    title: "Grants and Financial Coordinator",
    slug: "lehua-martin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Shane",
    lastName: "Martin",
    title: "Lead IT Support Consultant",
    slug: "shane-martin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Taina",
    lastName: "Martinez",
    title: "Service Response Coordinator",
    slug: "taina-martinez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "James",
    lastName: "Martinez",
    title: "Athletics Event Worker",
    slug: "james-martinez",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Soljane",
    lastName: "Martinez",
    title: "Director of Library Diversity, Equity, and Inclusion",
    slug: "soljane-martinez",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Gary",
    lastName: "Martins",
    title: "Sr. Manager, Special Projects and Programs",
    slug: "gary-martins",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rebecca",
    lastName: "Martish",
    title: "Assistant Director of Sponsored Research Analytics and Systems",
    slug: "rebecca-martish",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kaitlin",
    lastName: "Mason",
    title: "Project Manager",
    slug: "kaitlin-mason",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melissa",
    lastName: "Masquelette",
    title: "Director of Advancement Finance and Administration",
    slug: "melissa-masquelette",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Aaron",
    lastName: "Masri",
    title: "Grants and Financial Specialist",
    slug: "aaron-masri",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "James",
    lastName: "Massey",
    title: "Sergeant",
    slug: "james-massey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alex",
    lastName: "Mastromarchi",
    title: "Grant and Contract Administrator",
    slug: "alex-mastromarchi",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Carla",
    lastName: "Mastromatteo-Ma",
    title: "Communications Coordinator",
    slug: "carla-mastromatteo-ma",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Brett",
    lastName: "Mastropoll",
    title: "Associate Head Athletic Trainer",
    slug: "brett-mastropoll",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Monique",
    lastName: "Mata",
    title: "International Advancement Coordinator",
    slug: "monique-mata",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kelly",
    lastName: "Matias",
    title: "Benefits Data Specialist",
    slug: "kelly-matias",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Robert",
    lastName: "Mattei",
    title: "Manager, Windows Systems",
    slug: "robert-mattei",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jacqueleen",
    lastName: "Mazick",
    title: "Senior Associate Director, Prospect Management",
    slug: "jacqueleen-mazick",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Gina",
    lastName: "Mazza",
    title: "Guest Services - House Manager",
    slug: "gina-mazza",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John",
    lastName: "Mazza",
    title: "Associate Director of Web and Multimedia Production",
    slug: "john-mazza",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Teresa",
    lastName: "Mc Allister",
    title: "Administrative and Financial Coordinator",
    slug: "teresa-mc-allister",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Samuel",
    lastName: "McAdoo",
    title: "Archivist",
    slug: "samuel-mcadoo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robert",
    lastName: "McCabe",
    title:
      " Program Manager, Energy Transition and Campus Utilities Infrastructure",
    slug: "robert-mccabe",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kenia",
    lastName: "McCarthy",
    title: "Director, BioMed Human Resources",
    slug: "kenia-mccarthy",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Ellen",
    lastName: "McCarthy",
    title: "Senior Editorial Manager",
    slug: "ellen-mccarthy",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Leah",
    lastName: "McCue",
    title: "Communications and Outreach Manager",
    slug: "leah-mccue",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Joshua",
    lastName: "McCurdy",
    title: "Lead Developer",
    slug: "joshua-mccurdy",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michael",
    lastName: "McDade",
    title: "Bookstore and Technology Manager",
    slug: "michael-mcdade",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julia",
    lastName: "McDaniel",
    title: "Senior Stewardship Officer",
    slug: "julia-mcdaniel",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Byrd",
    lastName: "McDaniel",
    title: "Assistant Dean of Student Development",
    slug: "byrd-mcdaniel",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Aimee",
    lastName: "McDermott",
    title: "Human Resources Coordinator",
    slug: "aimee-mcdermott",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Kirk",
    lastName: "McDonough",
    title: "Research Subcontracting Grant & Contract Administrator",
    slug: "kirk-mcdonough",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Keri",
    lastName: "McDonough",
    title:
      " Assistant Director for the LGBTQ Center and Graduate Student Engagement",
    slug: "keri-mcdonough",
    dei: true,
    category: "Student Life",
  },
  {
    firstName: "Debra",
    lastName: "McEleney",
    title: "Administrative Manager",
    slug: "debra-mceleney",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Cathleen",
    lastName: "McElroy",
    title: "Administrative Coordinator",
    slug: "cathleen-mcelroy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joanne",
    lastName: "McEvoy",
    title: "Director of Admissions",
    slug: "joanne-mcevoy",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Carolyn",
    lastName: "McGarry",
    title: "Senior Assistant Director of Admission",
    slug: "carolyn-mcgarry",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Emma",
    lastName: "McGhan",
    title: "Senior Leadership Giving Officer, West Coast",
    slug: "emma-mcghan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nicole",
    lastName: "McGhee",
    title: "Associate Director, Reunion Giving",
    slug: "nicole-mcghee",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kate",
    lastName: "McGinn",
    title: "Assistant Director of Employee Relations",
    slug: "kate-mcginn",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Megan",
    lastName: "McGrath",
    title: "Director of Alumni and Donor Engagement",
    slug: "megan-mcgrath",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Brendan",
    lastName: "McGrath",
    title: "Sergeant",
    slug: "brendan-mcgrath",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amanda",
    lastName: "McGregor",
    title: "Deputy Director for News and Editorial Development",
    slug: "amanda-mcgregor",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Caroline",
    lastName: "McGuire",
    title: "Senior Associate Dean of the College for Co-Curriculum",
    slug: "caroline-mcguire",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jack",
    lastName: "McGuirk",
    title: "Brown Sports Network Production Crew",
    slug: "jack-mcguirk",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Emily",
    lastName: "McGurl",
    title: "Administrative Coordinator, Online Programs",
    slug: "emily-mcgurl",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John",
    lastName: "McHugh",
    title: "Custodial Quality Control and Training Specialist",
    slug: "john-mchugh",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jon",
    lastName: "McIlvaine",
    title: "Assistant Dean of Student Conduct & Community Standards",
    slug: "jon-mcilvaine",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ronald",
    lastName: "McKay",
    title: "Senior IT Support Consultant",
    slug: "ronald-mckay",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jennifer",
    lastName: "McKay",
    title: "Assistant Director, Wellness and Benefits Programs",
    slug: "jennifer-mckay",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Katrina",
    lastName: "McKee",
    title: "Associate Director, Capital Assets and Cost Accounting",
    slug: "katrina-mckee",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Cameron",
    lastName: "McKenna",
    title: "HR Service Center Coordinator",
    slug: "cameron-mckenna",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Morgan",
    lastName: "McKenna",
    title: "Admissions and Enrollment Specialist",
    slug: "morgan-mckenna",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Rebekah",
    lastName: "McKinney",
    title: "Director, Corporate and Foundation Relations",
    slug: "rebekah-mckinney",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Steven",
    lastName: "Mclellan",
    title: "Lighting Supervisor",
    slug: "steven-mclellan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jack",
    lastName: "McLoughlin",
    title: "Assistant Site Manager",
    slug: "jack-mcloughlin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ann",
    lastName: "McManus",
    title: "Administrative Assistant",
    slug: "ann-mcmanus",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Allison",
    lastName: "McMaster",
    title: "Assistant Director of Data Analysis and Reporting",
    slug: "allison-mcmaster",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Brendan",
    lastName: "McNally",
    title: "Program Director, Brown IE Executive MBA\xa0Program",
    slug: "brendan-mcnally",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kathleen",
    lastName: "McNamara",
    title: "IT Support Coordinator",
    slug: "kathleen-mcnamara",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sarah",
    lastName: "McPherson",
    title: "Research Programs Training Manager",
    slug: "sarah-mcpherson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Dante",
    lastName: "McPherson",
    title: "Athletics Creative Content Assistant",
    slug: "dante-mcpherson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Gabby",
    lastName: "McVicker",
    title: "Graduate Recruitment Coordinator",
    slug: "gabby-mcvicker",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Victoria",
    lastName: "Mealer-Flowers",
    title:
      " Student-Athlete Development Senior Manager, Community Engagement and DEI Programs",
    slug: "victoria-mealer-flowers",
    dei: true,
    category: "Student Life",
  },
  {
    firstName: "Povilas",
    lastName: "Mecys",
    title: "Front-end Designer",
    slug: "povilas-mecys",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Andrea",
    lastName: "Medeiros",
    title: "Grants and Financial Manager",
    slug: "andrea-medeiros",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Melissa",
    lastName: "Medeiros",
    title: "Assistant Director, Pre-Award Services",
    slug: "melissa-medeiros",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Robert",
    lastName: "Medeiros",
    title: "Senior IT Support Consultant",
    slug: "robert-medeiros",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jeanne",
    lastName: "Medeiros",
    title: "Administrative Coordinator",
    slug: "jeanne-medeiros",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Angela",
    lastName: "Medeiros",
    title: "Project Manager, Communications",
    slug: "angela-medeiros",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Tracie",
    lastName: "Mederos",
    title: "Associate Dean, Finance and Administration",
    slug: "tracie-mederos",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Amy",
    lastName: "Meehan",
    title: "Project Director",
    slug: "amy-meehan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Colette",
    lastName: "Meehan",
    title: "Senior Application Support Specialist",
    slug: "colette-meehan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Alyssa",
    lastName: "Mefford",
    title: "Development Coordinator, Corporate and Foundation Relations",
    slug: "alyssa-mefford",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yolanda",
    lastName: "Meikle",
    title: "Diversity and Inclusion Development Coordinator",
    slug: "yolanda-meikle",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Hannah",
    lastName: "Mellion",
    title: "Project Manager",
    slug: "hannah-mellion",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Peter",
    lastName: "Mello",
    title: "Administrative Manager",
    slug: "peter-mello",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Sarah",
    lastName: "Melo",
    title: "Lead Meat Cutter - 52 Weeks",
    slug: "sarah-melo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emily",
    lastName: "Melsky",
    title: "Research Compliance Assistant",
    slug: "emily-melsky",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tiffany",
    lastName: "Mencos",
    title: "Grants and Financial Coordinator",
    slug: "tiffany-mencos",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jenny",
    lastName: "Mencos",
    title: "Grants and Financial Coordinator",
    slug: "jenny-mencos",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Meredith",
    lastName: "Mendola",
    title:
      " Program Manager - Center for Technological Responsibility,  Reimagination and Redesign",
    slug: "meredith-mendola",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brian",
    lastName: "Mendoza",
    title: "Bilingual (Spanish) Research Interviewer",
    slug: "brian-mendoza",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jose",
    lastName: "Mendoza",
    title: "Event Specialist",
    slug: "jose-mendoza",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sydney",
    lastName: "Menzin",
    title: "Project Manager",
    slug: "sydney-menzin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emily",
    lastName: "Mercer",
    title: "Project Manager, Award Cores",
    slug: "emily-mercer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carmel",
    lastName: "Merrick",
    title: "Lead Developer",
    slug: "carmel-merrick",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "York",
    lastName: "Mgbejume",
    title: "ArtsCrew Marketing & Communications Assistant",
    slug: "york-mgbejume",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Emma",
    lastName: "Miceli",
    title: "Grants and Financial Manager",
    slug: "emma-miceli",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Amy",
    lastName: "Michaluk",
    title: "Grants and Financial Manager",
    slug: "amy-michaluk",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lisa",
    lastName: "Middleton",
    title: "Director of Human Resources for the Division of Campus Life",
    slug: "lisa-middleton",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Sherri",
    lastName: "Miles",
    title: "Research Communications Manager",
    slug: "sherri-miles",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Shane",
    lastName: "Miller",
    title: "Consultant",
    slug: "shane-miller",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ian",
    lastName: "Miller",
    title: "Athletics Public Address Announcer",
    slug: "ian-miller",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Crystal",
    lastName: "Miller",
    title: "Human Resources Specialist",
    slug: "crystal-miller",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Alex",
    lastName: "Minder",
    title: "Associate Director of Financial Planning and Analysis",
    slug: "alex-minder",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Andrew",
    lastName: "Minkel",
    title: "Finance Director, BIRCH",
    slug: "andrew-minkel",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Edel",
    lastName: "Minogue",
    title: "Senior Director, Research Strategy and Development",
    slug: "edel-minogue",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Paulo",
    lastName: "Miranda",
    title: "Groundsworker",
    slug: "paulo-miranda",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sara",
    lastName: "Misgen",
    title: "Assistant Director, Interdisciplinary Teaching Communities",
    slug: "sara-misgen",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michael",
    lastName: "Mitchell",
    title: "Communications and Outreach Specialist",
    slug: "michael-mitchell",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sally",
    lastName: "Mitchell",
    title:
      " Executive Assistant to the Vice President & General Counsel and Deputy General Counsel",
    slug: "sally-mitchell",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Desirae",
    lastName: "Mix",
    title: "Associate Director, Student Accommodations and Services",
    slug: "desirae-mix",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Nilananh",
    lastName: "Miya",
    title: "Data Quality Control Manager",
    slug: "nilananh-miya",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Seke",
    lastName: "Mkhabela",
    title: "Project and Data Specialist",
    slug: "seke-mkhabela",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jason",
    lastName: "Mogen",
    title: "Senior Assistant Director of Admission",
    slug: "jason-mogen",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Sharon",
    lastName: "Moitoso",
    title: "Assistant Director, Pre-Award Services",
    slug: "sharon-moitoso",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nicholas",
    lastName: "Mol",
    title: "Grounds Superintendent",
    slug: "nicholas-mol",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Fiona",
    lastName: "Monaghan",
    title: "Assistant Director of Admissions and Enrollment Services",
    slug: "fiona-monaghan",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Daniela",
    lastName: "Monge",
    title: "Talent Specialist",
    slug: "daniela-monge",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Malcom",
    lastName: "Moniz",
    title: "Assistant Director for Outdoor Leadership and Student Activities",
    slug: "malcom-moniz",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Thea",
    lastName: "Monje",
    title: "Senior Admission Officer",
    slug: "thea-monje",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Brianna",
    lastName: "Montecalvo",
    title: "Campus Visit and Event Manager",
    slug: "brianna-montecalvo",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Tracey",
    lastName: "Monteforte",
    title: "Lifespan Worker",
    slug: "tracey-monteforte",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katherine",
    lastName: "Monteiro",
    title: "Manager, IT Support Consultants",
    slug: "katherine-monteiro",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jose",
    lastName: "Montelongo",
    title: "Maury A. Bromsen Curator of Latin American Books",
    slug: "jose-montelongo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Shaunte",
    lastName: "Montgomery",
    title: "Associate Dean of the College for Class-Year Advising",
    slug: "shaunte-montgomery",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Erin",
    lastName: "Montigny",
    title: "Athletics Event Worker",
    slug: "erin-montigny",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Katherine",
    lastName: "Montilla",
    title: "Administrative and Project Specialist",
    slug: "katherine-montilla",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emma",
    lastName: "Moore",
    title: "Development Coordinator, Regional Development",
    slug: "emma-moore",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chris",
    lastName: "Moore",
    title: "Lead Developer",
    slug: "chris-moore",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Austin",
    lastName: "Moore",
    title: "Service Response Coordinator",
    slug: "austin-moore",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Courtney",
    lastName: "Moore",
    title: "Director of Academic Innovation",
    slug: "courtney-moore",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Geoffrey",
    lastName: "Moran",
    title: "IT Support Consultant",
    slug: "geoffrey-moran",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Maureen",
    lastName: "Moran",
    title: "Director, Gifts and Endowment",
    slug: "maureen-moran",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Carrie",
    lastName: "Morea-Berenback",
    title: "Program Manager for Academic Tutoring",
    slug: "carrie-morea-berenback",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christine",
    lastName: "Moreira",
    title: "Executive Assistant",
    slug: "christine-moreira",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Richard",
    lastName: "Morello",
    title: "Site Manager",
    slug: "richard-morello",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dinka",
    lastName: "Morillo",
    title: "Administrative Coordinator",
    slug: "dinka-morillo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Susan",
    lastName: "Morin",
    title: "Supply Chain Buyer",
    slug: "susan-morin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tracy",
    lastName: "Morkunas",
    title: "Director of BioMed Finance",
    slug: "tracy-morkunas",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Adrienne",
    lastName: "Morris",
    title: "Senior Managing Director of Development, Academic Initiatives",
    slug: "adrienne-morris",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Angela",
    lastName: "Morris",
    title: "LCME Administrative Coordinator",
    slug: "angela-morris",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tanisia",
    lastName: "Morris",
    title: "Assistant Director, Digital Content",
    slug: "tanisia-morris",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kate",
    lastName: "Morrison",
    title: "Project Director",
    slug: "kate-morrison",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eden",
    lastName: "Morrison",
    title: "Lead Teaching Fellow, National Education Equity Lab",
    slug: "eden-morrison",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Eva",
    lastName: "Morrissey",
    title: "Human Resources Specialist",
    slug: "eva-morrissey",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Abigail",
    lastName: "Morse",
    title: "Assessment and Evaluation Specialist",
    slug: "abigail-morse",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Gordon",
    lastName: "Morton",
    title: "Associate Director of Communications and External Relations",
    slug: "gordon-morton",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Amy",
    lastName: "Morton",
    title: "Executive Assistant",
    slug: "amy-morton",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "James",
    lastName: "Morton",
    title: "Senior Web Developer",
    slug: "james-morton",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jenna",
    lastName: "Morton-Aiken",
    title: "Senior Associate Director for Writing and English Language Support",
    slug: "jenna-morton-aiken",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Gilda",
    lastName: "Mossadegh",
    title: "Deputy Dean of the College for Academic Advising",
    slug: "gilda-mossadegh",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "John",
    lastName: "Motta",
    title: "Custodial Shift Assistant",
    slug: "john-motta",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christine",
    lastName: "Moulding",
    title: "Project Manager",
    slug: "christine-moulding",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Richard",
    lastName: "Moyer",
    title: "Seasonal Application Reader",
    slug: "richard-moyer",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Meghan",
    lastName: "Mozea",
    title: "Administrative Assistant, BRYTE Program",
    slug: "meghan-mozea",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Andrea",
    lastName: "Mucci",
    title: "Associate Director of Research Administration Information Systems",
    slug: "andrea-mucci",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Paul",
    lastName: "Muite",
    title: "Assistant Vice President of Development",
    slug: "paul-muite",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Patricia",
    lastName: "Mulcahey",
    title: "Director, Strategic Sourcing",
    slug: "patricia-mulcahey",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kate",
    lastName: "Mullaney",
    title: "Associate Director of Financial Analysis",
    slug: "kate-mullaney",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sean",
    lastName: "Mulligan",
    title: "Groundsworker",
    slug: "sean-mulligan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Paula",
    lastName: "Mulvaney",
    title: "Senior Data Management Specialist",
    slug: "paula-mulvaney",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Javier",
    lastName: "Munoz",
    title: "Groundsworker",
    slug: "javier-munoz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jorge",
    lastName: "Munoz",
    title: "Service Response Coordinator",
    slug: "jorge-munoz",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Saminah",
    lastName: "Munshi",
    title: "Tutor, Gateways Program",
    slug: "saminah-munshi",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Omi",
    lastName: "Murakami-Locke",
    title: "Financial Coordinator",
    slug: "omi-murakami-locke",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jennifer",
    lastName: "Murphy",
    title: "Director of Research Contracting",
    slug: "jennifer-murphy",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Daniel",
    lastName: "Murphy",
    title: "Manager, Marketing & Communications",
    slug: "daniel-murphy",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Elizabeth",
    lastName: "Murphy",
    title: "Seasonal Reader",
    slug: "elizabeth-murphy",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Margaret",
    lastName: "Murphy",
    title:
      " Program Manager, Center for Human Rights and Humanitarian Studies (CHRHS)",
    slug: "margaret-murphy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lynda",
    lastName: "Murphy",
    title: "Executive Assistant to the Provost",
    slug: "lynda-murphy",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Melissa",
    lastName: "Murphy",
    title: "Development Coordinator",
    slug: "melissa-murphy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "William",
    lastName: "Murphy",
    title: "Locksmith",
    slug: "william-murphy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christin",
    lastName: "Murphy",
    title: "Assistant Director, BioMed Shared Services",
    slug: "christin-murphy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kelly",
    lastName: "Murphy",
    title: "Director of Finance",
    slug: "kelly-murphy",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Megan",
    lastName: "Murphy",
    title: "Director of Strategic Communications",
    slug: "megan-murphy",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Pamela",
    lastName: "Murray",
    title: "Athletics Official Scorer",
    slug: "pamela-murray",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Justin",
    lastName: "Muschiano",
    title: "Personal Trainer",
    slug: "justin-muschiano",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David",
    lastName: "Mycue",
    title: "Director of Information Technology",
    slug: "david-mycue",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ryan",
    lastName: "Nabb",
    title: "Brown Sports Network Production Crew",
    slug: "ryan-nabb",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Judith",
    lastName: "Nabb",
    title: "Director, Learning, Development & Engagement",
    slug: "judith-nabb",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Suzanne",
    lastName: "Nacar",
    title: "Manager, IT Support Consultants",
    slug: "suzanne-nacar",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Siddhi",
    lastName: "Nadkarni",
    title: "HIV Test Phone Counselor",
    slug: "siddhi-nadkarni",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kelsey",
    lastName: "Nagel",
    title: "Director, Alumni Leadership",
    slug: "kelsey-nagel",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Mandar",
    lastName: "Naik",
    title: "Structural Biology Core Facility Manager",
    slug: "mandar-naik",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Albertino",
    lastName: "Nascimento",
    title: "Custodial Shift Assistant",
    slug: "albertino-nascimento",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kelly",
    lastName: "Nason",
    title: "Director of Financial Planning and Analysis",
    slug: "kelly-nason",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Allan",
    lastName: "Nassif",
    title: "Custodial Shift Assistant",
    slug: "allan-nassif",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Arunasalam",
    lastName: "Navaraj",
    title: "Program Director for Cancer Biology Research Laboratories",
    slug: "arunasalam-navaraj",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rosario",
    lastName: "Navarro",
    title: "Assistant Dean for Pre-College Experiential and Language Programs",
    slug: "rosario-navarro",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Collin",
    lastName: "Nebeker",
    title: "Academic Coordinator",
    slug: "collin-nebeker",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Eva",
    lastName: "Neczypor",
    title: "Assistant Director of Academic Affairs",
    slug: "eva-neczypor",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Irena",
    lastName: "Nedeljkovic Cunningham",
    title: "Manager of Finance and Administration",
    slug: "irena-nedeljkovic-cunningham",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Cameron",
    lastName: "Neelis",
    title: "Senior IT Support Consultant",
    slug: "cameron-neelis",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jessica",
    lastName: "Nelson",
    title: "Mellon Project Curatorial Assistant",
    slug: "jessica-nelson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lance",
    lastName: "Nelson",
    title: "Project Coordinator",
    slug: "lance-nelson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maren",
    lastName: "Nelson",
    title: "Executive Assistant",
    slug: "maren-nelson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anita",
    lastName: "Nester",
    title: "Undergraduate Concentration Manager",
    slug: "anita-nester",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Melanie",
    lastName: "Neves",
    title: "Director of Financial Aid",
    slug: "melanie-neves",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Leslie",
    lastName: "Nevola",
    title: "Web Strategist and Producer",
    slug: "leslie-nevola",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ryan",
    lastName: "Newell",
    title: "Administrative Coordinator",
    slug: "ryan-newell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lorraine",
    lastName: "Ng",
    title: "Assistant Director, Compensation",
    slug: "lorraine-ng",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Binhminh",
    lastName: "Nguyen",
    title: "SPS Teaching Associate - MHL",
    slug: "binhminh-nguyen",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Roth",
    lastName: "Nhar",
    title: "Grants and Contract Administrator",
    slug: "roth-nhar",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melissa",
    lastName: "Nicholaus",
    title: "MPA Student Affairs Manager",
    slug: "melissa-nicholaus",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Abbey",
    lastName: "Nicholson",
    title: "Program Associate, Alumni Belonging",
    slug: "abbey-nicholson",
    dei: true,
    category: "Communications",
  },
  {
    firstName: "Kyle",
    lastName: "Nicholson",
    title: "Lead Media Technology Systems Administrator",
    slug: "kyle-nicholson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lori",
    lastName: "Nickerson",
    title: "Executive Assistant",
    slug: "lori-nickerson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Scott",
    lastName: "Nickerson",
    title: "Grants and Financial Manager",
    slug: "scott-nickerson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Yu",
    lastName: "Nie",
    title: "Chief of Staff to the Dean of the School of Professional Studies",
    slug: "yu-nie",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lyubov",
    lastName: "Niemann",
    title: "Chief of Staff to the Dean of the School of Professional Studies",
    slug: "lyubov-niemann",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Naomi",
    lastName: "Ninneman",
    title: "BWell Associate Director for Empowerment and Prevention",
    slug: "naomi-ninneman",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Christiana",
    lastName: "Nocera",
    title: "Administrative and Financial Coordinator",
    slug: "christiana-nocera",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kim",
    lastName: "Noe",
    title: "Administrative Coordinator",
    slug: "kim-noe",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jonathan",
    lastName: "Nogueira",
    title: "Assistant Director, Application Support",
    slug: "jonathan-nogueira",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Emily",
    lastName: "Nolan",
    title: "Program Director, Student and Career Services",
    slug: "emily-nolan",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kris",
    lastName: "Nolte",
    title: "Assistant Director, Digital Learning Experience",
    slug: "kris-nolte",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Susana",
    lastName: "Noriega-Edmond",
    title: "Manager, Resource Sharing and Rockefeller Stacks Maintenance",
    slug: "susana-noriega-edmond",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Bobby",
    lastName: "Norigian",
    title: "Assistant Director, Web Services",
    slug: "bobby-norigian",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Stephanie",
    lastName: "Norris",
    title: "Assistant Director, First Year Experience",
    slug: "stephanie-norris",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Emmy",
    lastName: "Nuttall",
    title: "Project Manager, CME",
    slug: "emmy-nuttall",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "SP",
    lastName: "O'Brien",
    title: "Customer Service Team Lead",
    slug: "sp-o-brien",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Corinne",
    lastName: "O'Brien",
    title: "Assistant Director, Academic Records",
    slug: "corinne-o-brien",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kathleen",
    lastName: "O'Connell",
    title: "Pre-College Seasonal Reader",
    slug: "kathleen-o-connell",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Kevan",
    lastName: "O'Donnell",
    title: "Welcome Center Specialist",
    slug: "kevan-o-donnell",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "William",
    lastName: "O'Gara",
    title: "Senior Web Developer",
    slug: "william-o-gara",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Brian",
    lastName: "O'Hara",
    title: "Sergeant",
    slug: "brian-o-hara",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "April",
    lastName: "O'Malley",
    title: "Benefits Manager",
    slug: "april-o-malley",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Brandon",
    lastName: "O'Neall",
    title: "Director of Sports Performance",
    slug: "brandon-o-neall",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Leticia",
    lastName: "O'Neill",
    title: "Associate Director for UX Design & Development",
    slug: "leticia-o-neill",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Caitlin",
    lastName: "O'Neill",
    title: "Director, LGBTQ Center",
    slug: "caitlin-o-neill",
    dei: true,
    category: "Student Life",
  },
  {
    firstName: "Molly",
    lastName: "O'Toole",
    title: "Regional Development Associate",
    slug: "molly-o-toole",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicole",
    lastName: "Oakes",
    title: "Events Manager",
    slug: "nicole-oakes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Courtney",
    lastName: "Oakley",
    title: "Assistant Director, Talent Acquisition",
    slug: "courtney-oakley",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Stephanie",
    lastName: "Obodda",
    title: "Assistant Director, IT User Experience Strategy",
    slug: "stephanie-obodda",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Erik",
    lastName: "Ocean",
    title: "Project Manager",
    slug: "erik-ocean",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Grady",
    lastName: "OConnor",
    title: "Athletics Marketing Assistant",
    slug: "grady-oconnor",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Wendy",
    lastName: "Octeau",
    title: "Assistant to the Vice President & CIO/Administrative Manager",
    slug: "wendy-octeau",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Annette",
    lastName: "Ogunnaike",
    title: "Director of Administration",
    slug: "annette-ogunnaike",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Josephine",
    lastName: "Okunola",
    title: "Associate Director, BioMed Financial Aid",
    slug: "josephine-okunola",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nicole",
    lastName: "Oliveira",
    title: "Supervisor, FM Supply Chain",
    slug: "nicole-oliveira",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mary",
    lastName: "Oliver",
    title: "Assistant Director of Academic Administration",
    slug: "mary-oliver",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Eric",
    lastName: "Olson",
    title: "Grant/Contract Accountant I",
    slug: "eric-olson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jennifer",
    lastName: "Olson",
    title: "Project Director",
    slug: "jennifer-olson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tracy",
    lastName: "Olson",
    title: "Assistant Director of Financial Aid",
    slug: "tracy-olson",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Luckson",
    lastName: "Omoaregba",
    title: "Director of Pathways Programs",
    slug: "luckson-omoaregba",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Natalia",
    lastName: "Onufrieva",
    title: "Senior Application Administrator",
    slug: "natalia-onufrieva",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Josue",
    lastName: "Orellana",
    title: "Custodial Shift Assistant",
    slug: "josue-orellana",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicholas",
    lastName: "Orn",
    title: "Assistant Grounds Superintendent",
    slug: "nicholas-orn",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Liliana",
    lastName: "Ornelas",
    title: "Associate Director, Alumni Community Outreach Network",
    slug: "liliana-ornelas",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kristen",
    lastName: "Orrall",
    title: "Data Management Associate",
    slug: "kristen-orrall",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Matthew",
    lastName: "Osenkowski",
    title: "Strategic Sourcing Category Manager - Research and Scientific",
    slug: "matthew-osenkowski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laimah",
    lastName: "Osman",
    title: "Web Designer and Producer",
    slug: "laimah-osman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jay",
    lastName: "Osper",
    title: "Assistant Director, Compensation",
    slug: "jay-osper",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Cynthia",
    lastName: "Osti",
    title: "Foreign National Tax Manager",
    slug: "cynthia-osti",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Laurie",
    lastName: "Otto",
    title: "Customer Service Assistant",
    slug: "laurie-otto",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katie",
    lastName: "Ouellette",
    title: "Assistant Director of Signature Events",
    slug: "katie-ouellette",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jill",
    lastName: "Ouellette",
    title: "Administrative Coordinator",
    slug: "jill-ouellette",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amanda",
    lastName: "Overend",
    title: "CRM System Administrator",
    slug: "amanda-overend",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Christen",
    lastName: "Owen",
    title: "CARE Training Specialist",
    slug: "christen-owen",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Seth",
    lastName: "Owusu",
    title: "Assistant Director, Resiliency and Adaptation",
    slug: "seth-owusu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Octavia",
    lastName: "Pacheco",
    title: "Cashier/Checker/Clerk",
    slug: "octavia-pacheco",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Luisa",
    lastName: "Pacheco",
    title: "Senior Accounts Payable Specialist",
    slug: "luisa-pacheco",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "James",
    lastName: "Packer",
    title: "Grants and Financial Specialist",
    slug: "james-packer",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Gary",
    lastName: "Padula",
    title: "Managing Director",
    slug: "gary-padula",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nathan",
    lastName: "Palcowski",
    title: "Social Media Engagement Specialist",
    slug: "nathan-palcowski",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Bianca",
    lastName: "Pallo",
    title: "Black History at Brown University Project Archivist",
    slug: "bianca-pallo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erina",
    lastName: "Palmisano",
    title: "Grants and Financial Specialist",
    slug: "erina-palmisano",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Chia-Ying",
    lastName: "Pan",
    title: "Associate Dean of the College for International Students",
    slug: "chia-ying-pan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Anne",
    lastName: "Pancheri",
    title: "Auditor 4",
    slug: "anne-pancheri",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Karin",
    lastName: "Paredes",
    title: "Seasonal Reader",
    slug: "karin-paredes",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Kqantu",
    lastName: "Pareja Bent",
    title: "Senior Regional Director for International Advancement",
    slug: "kqantu-pareja-bent",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Juana",
    lastName: "Parillon",
    title:
      " Assistant Vice President of Institutional Equity and Diversity and Chief of Staff",
    slug: "juana-parillon",
    dei: true,
    category: "Miscellaneous",
  },
  {
    firstName: "Naomi",
    lastName: "Pariseault",
    title: "Senior Learning Designer",
    slug: "naomi-pariseault",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Chris",
    lastName: "Parish",
    title: "Web Content Manager",
    slug: "chris-parish",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ryan",
    lastName: "Park",
    title: "Investment Associate",
    slug: "ryan-park",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Aubrey",
    lastName: "Parker",
    title: "Football Game Day Filmer",
    slug: "aubrey-parker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anna",
    lastName: "Pascone",
    title: "Grants and Financial Specialist",
    slug: "anna-pascone",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Joel",
    lastName: "Pattison",
    title:
      " Assistant Vice President for Web Communications and Digital Experience",
    slug: "joel-pattison",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Narayan",
    lastName: "Paudel",
    title: "Lead UNIX System Administrator",
    slug: "narayan-paudel",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Adam",
    lastName: "Paul",
    title: "Lead System Administrator",
    slug: "adam-paul",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jheraldines",
    lastName: "Paulino",
    title: "Project Director",
    slug: "jheraldines-paulino",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sonja",
    lastName: "Paulson",
    title: "Assistant Director, International Student Services",
    slug: "sonja-paulson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Brittany",
    lastName: "Pavao",
    title: "Grants and Contracts Coordinator",
    slug: "brittany-pavao",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kym",
    lastName: "Pawloski",
    title: "Graduate Recruitment Coordinator",
    slug: "kym-pawloski",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Alyssa",
    lastName: "Peachey",
    title: "Project Director",
    slug: "alyssa-peachey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jeanne",
    lastName: "Pecha",
    title: "Vice President of Advancement Services and Development Support",
    slug: "jeanne-pecha",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brenden",
    lastName: "Peirce",
    title: "ArtsCrew Marketing and Communications Assistant",
    slug: "brenden-peirce",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Susannah",
    lastName: "Peirce",
    title: "Executive Assistant",
    slug: "susannah-peirce",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Simone",
    lastName: "Peixinho",
    title: "Communication Control Officer",
    slug: "simone-peixinho",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jenna",
    lastName: "Pelletier",
    title:
      " Senior Communications Manager and Writer for the Humanities and Social Sciences",
    slug: "jenna-pelletier",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Zac",
    lastName: "Pencikowski",
    title: "Senior Associate General Counsel",
    slug: "zac-pencikowski",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Paula",
    lastName: "Penelton",
    title: "Administrative Project Manager and Assistant to the Vice President",
    slug: "paula-penelton",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nerina",
    lastName: "Penzhorn",
    title: "Senior Educational Digital Media Producer, Editor",
    slug: "nerina-penzhorn",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kevin",
    lastName: "Pepere",
    title: "Sergeant",
    slug: "kevin-pepere",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Meagan",
    lastName: "Pepper",
    title: "Program Manager",
    slug: "meagan-pepper",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joshua",
    lastName: "Pereira",
    title: "Athletics Marketing Assistant",
    slug: "joshua-pereira",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gregory",
    lastName: "Pereira",
    title: "Application Support Specialist",
    slug: "gregory-pereira",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Carissa",
    lastName: "Pereira",
    title: "Assistant Director of Financial Aid",
    slug: "carissa-pereira",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Albert",
    lastName: "Pereira",
    title: "Groundsworker",
    slug: "albert-pereira",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Natalie",
    lastName: "Perez",
    title: "Data Management Associate",
    slug: "natalie-perez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lucelis",
    lastName: "Perez",
    title: "Scheduling and Systems Administrator",
    slug: "lucelis-perez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jailene",
    lastName: "Perez",
    title: "Class Giving Officer",
    slug: "jailene-perez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jayson",
    lastName: "Perez",
    title: "Manager, Endpoint Hardware Services",
    slug: "jayson-perez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Gianna",
    lastName: "Perez",
    title: "Graduate & Professional Student Records and Graduation Coordinator",
    slug: "gianna-perez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Josefina",
    lastName: "Periquito",
    title: "Custodial Shift Assistant",
    slug: "josefina-periquito",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jared",
    lastName: "Perkins",
    title: "Director of Health Policy Strategy",
    slug: "jared-perkins",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kevin",
    lastName: "Perry",
    title: "Senior Financial Systems Specialist",
    slug: "kevin-perry",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Eleanor",
    lastName: "Peters",
    title: "Seasonal Sales Associate",
    slug: "eleanor-peters",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Janet",
    lastName: "Peters",
    title:
      " Associate Director for Academic Tutoring and Assistant Dean of Curricular Support",
    slug: "janet-peters",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nicole",
    lastName: "Peters Sisson",
    title: "Senior Director of Development for Academic Initiatives",
    slug: "nicole-peters-sisson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kathleen",
    lastName: "Peterson",
    title: "Deputy General Counsel for Litigation and Employment Law",
    slug: "kathleen-peterson",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Alicia",
    lastName: "Petrarca",
    title: "Gift Accounting Associate",
    slug: "alicia-petrarca",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Thu",
    lastName: "Pham",
    title: "Grant/Contract Accountant II",
    slug: "thu-pham",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Monica",
    lastName: "Phan",
    title: "Communications Coordinator",
    slug: "monica-phan",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Natalya",
    lastName: "Philibert",
    title: "Senior IT Support Consultant",
    slug: "natalya-philibert",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kira",
    lastName: "Philips",
    title: "Academic and Student Affairs Coordinator",
    slug: "kira-philips",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Susan",
    lastName: "Phillips",
    title: "Regional Development Associate",
    slug: "susan-phillips",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Randy",
    lastName: "Phillips",
    title: "Supervisor, Custodial Services",
    slug: "randy-phillips",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brittany",
    lastName: "Phipps",
    title: "Program Manager, Biotechnology Master's Program",
    slug: "brittany-phipps",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nicole",
    lastName: "Picard",
    title: "Associate General Counsel",
    slug: "nicole-picard",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Traci",
    lastName: "Picard",
    title: "Historical Document Transcriber",
    slug: "traci-picard",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jimmy",
    lastName: "Picerelli",
    title: "Assistant Director of Athletics, Recruiting",
    slug: "jimmy-picerelli",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Russell",
    lastName: "Picozzi",
    title: "Finance Specialist",
    slug: "russell-picozzi",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Trevor",
    lastName: "Pierce",
    title: "Senior Developer",
    slug: "trevor-pierce",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Soraya",
    lastName: "Pierre-Louis",
    title: "Gynecological Exam",
    slug: "soraya-pierre-louis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emily",
    lastName: "Piers",
    title: "Executive Assistant to the Deans",
    slug: "emily-piers",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Corrie",
    lastName: "Pikul",
    title: "Senior Communications Manager and Writer for the Life Sciences",
    slug: "corrie-pikul",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Catherine",
    lastName: "Pincince",
    title: "Senior Associate Secretary of the Corporation",
    slug: "catherine-pincince",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Dana",
    lastName: "Pineda",
    title: "Regional Development Associate",
    slug: "dana-pineda",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joaquim",
    lastName: "Pipa",
    title: "Groundsworker",
    slug: "joaquim-pipa",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Monica",
    lastName: "Piquette",
    title: "Administrative Coordinator for Advising",
    slug: "monica-piquette",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alisha",
    lastName: "Plante",
    title: "Human Resources Specialist",
    slug: "alisha-plante",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "David",
    lastName: "Platz",
    title: "HRPP Consultant",
    slug: "david-platz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Paige",
    lastName: "Plucker",
    title: "Administrative Coordinator",
    slug: "paige-plucker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erica",
    lastName: "Plunkett",
    title: "Project Manager",
    slug: "erica-plunkett",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Benjamin",
    lastName: "Poff",
    title: "Director of Tax",
    slug: "benjamin-poff",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tim",
    lastName: "Poisson",
    title: "Director, Direct Marketing",
    slug: "tim-poisson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Patricia",
    lastName: "Poitevien",
    title:
      " Senior Associate Dean for Diversity, Equity and Inclusion, Associate Professor of Pediatrics",
    slug: "patricia-poitevien",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Lino",
    lastName: "Poli",
    title: "Athletics Event Worker",
    slug: "lino-poli",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Timothy",
    lastName: "Poli",
    title: "Senior Systems Administrator",
    slug: "timothy-poli",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jamall",
    lastName: "Pollock",
    title:
      " Associate Dean of the College for Co-Curricular & Post-Graduate Opportunities",
    slug: "jamall-pollock",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Collin",
    lastName: "Polucha",
    title: "Research Manager",
    slug: "collin-polucha",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jessica",
    lastName: "Pontarelli",
    title: "Assistant Director of Communications",
    slug: "jessica-pontarelli",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Christopher",
    lastName: "Pool",
    title: "IAPA 0020 Teaching Fellow, National Education Equity Lab",
    slug: "christopher-pool",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Kate",
    lastName: "Porter",
    title: "Director of Campus Life Communications",
    slug: "kate-porter",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "DJ",
    lastName: "Potter",
    title: "Senior Technical Supervisor",
    slug: "dj-potter",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jai-Me",
    lastName: "Potter-Rutledge",
    title: "Assistant Dean of Diversity, Equity and Inclusion",
    slug: "jai-me-potter-rutledge",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Steve",
    lastName: "Poueriet",
    title: "Administrative and Financial Coordinator",
    slug: "steve-poueriet",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Logan",
    lastName: "Powell",
    title: "Associate Provost for Enrollment & Dean of Undergraduate Admission",
    slug: "logan-powell",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Samantha",
    lastName: "Powers",
    title: "Cashier/Checker/Clerk",
    slug: "samantha-powers",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shankar",
    lastName: "Prasad",
    title: "Instructor, National Education Equity Lab",
    slug: "shankar-prasad",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Claire",
    lastName: "Pratty",
    title: "Project Manager",
    slug: "claire-pratty",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Matthew",
    lastName: "Price",
    title: "Senior Associate Director of Admission",
    slug: "matthew-price",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Kemi",
    lastName: "Price",
    title: "Talent Acquisition Sourcing Specialist",
    slug: "kemi-price",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Pamela",
    lastName: "Price",
    title: "Seasonal Sales Associate",
    slug: "pamela-price",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amy",
    lastName: "Princiotto",
    title: "Project Manager",
    slug: "amy-princiotto",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gianna",
    lastName: "Procaccini",
    title: "Athletics Event Worker",
    slug: "gianna-procaccini",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Brian",
    lastName: "Procopio",
    title: "Brown Sports Network Production Crew",
    slug: "brian-procopio",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alex",
    lastName: "Provencal",
    title: "Groundsworker",
    slug: "alex-provencal",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Evan",
    lastName: "Provost",
    title: "Athletics Creative Content Assistant",
    slug: "evan-provost",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Michael",
    lastName: "Pulgar-Cabrera",
    title: "Grants and Financial Specialist",
    slug: "michael-pulgar-cabrera",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tanya",
    lastName: "Purdy",
    title: "Director, BWell Health Promotion",
    slug: "tanya-purdy",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Nithya",
    lastName: "Puttige Ramesh",
    title: "Director, Online MPH Program",
    slug: "nithya-puttige-ramesh",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Bill",
    lastName: "Pyne",
    title: "Lead Integration Developer",
    slug: "bill-pyne",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ernest",
    lastName: "Quackenbush",
    title: "Occupational Health & Safety Officer",
    slug: "ernest-quackenbush",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kelvin",
    lastName: "Queliz",
    title:
      " Senior Associate Director of Athletics, Strategic Communications & Content Creation",
    slug: "kelvin-queliz",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sherri",
    lastName: "Quental",
    title: "Legal Administrative Coordinator",
    slug: "sherri-quental",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Cheryl",
    lastName: "Quinlan",
    title: "Administrative Director, CARE",
    slug: "cheryl-quinlan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristin",
    lastName: "Quinn",
    title: "Senior Accounts Payable Specialist",
    slug: "kristin-quinn",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jennifer",
    lastName: "Quinn",
    title: "Senior Associate Director, Business Process Analysis",
    slug: "jennifer-quinn",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Louie",
    lastName: "Quinones",
    title: "Personal Trainer",
    slug: "louie-quinones",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dawson",
    lastName: "Quint",
    title: "Athletics Marketing Assistant",
    slug: "dawson-quint",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Teagan",
    lastName: "Quintana",
    title: "Grant/Contract Accountant I",
    slug: "teagan-quintana",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sean",
    lastName: "Rabbitt",
    title: "Grants and Financial Specialist",
    slug: "sean-rabbitt",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kaitlyn",
    lastName: "Rabold",
    title: "Grants and Financial Specialist",
    slug: "kaitlyn-rabold",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Steven",
    lastName: "Radilla",
    title: "Diversity Initiatives Program Coordinator",
    slug: "steven-radilla",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Ashok",
    lastName: "Ragavendran",
    title: "Associate Director, Computational Biology and Data Science",
    slug: "ashok-ragavendran",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Diane",
    lastName: "Raj",
    title: "Director of Finance and Administration",
    slug: "diane-raj",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Annabella",
    lastName: "Ramer",
    title: "Senior Fixed Asset Accountant",
    slug: "annabella-ramer",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Albert",
    lastName: "Ramos Sterling",
    title: "Mail Carrier",
    slug: "albert-ramos-sterling",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jacob",
    lastName: "Randall",
    title: "Athletics Event Worker",
    slug: "jacob-randall",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Machiste",
    lastName: "Rankin",
    title: "Peer Support Specialist",
    slug: "machiste-rankin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maria",
    lastName: "Raposo",
    title: "Household Assistant",
    slug: "maria-raposo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Neil",
    lastName: "Raposo",
    title: "Preventive Maintenance Planner-Scheduler",
    slug: "neil-raposo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Derek",
    lastName: "Raposo",
    title: "Manager, Preventive Maintenance",
    slug: "derek-raposo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Harold",
    lastName: "Rappoport",
    title: "Head Kosher Supervisor",
    slug: "harold-rappoport",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Scott",
    lastName: "Rathbun",
    title: "Program Manager of Biology Education",
    slug: "scott-rathbun",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jennifer",
    lastName: "Rathlev",
    title: "Administrative and Financial Specialist",
    slug: "jennifer-rathlev",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jon",
    lastName: "Ratner",
    title: "Athletics Photography Assistant",
    slug: "jon-ratner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dacia",
    lastName: "Read",
    title: "Chief of Staff to the President",
    slug: "dacia-read",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Victor",
    lastName: "Rebelo",
    title: "Manager of Contracted Services",
    slug: "victor-rebelo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amy",
    lastName: "Recker",
    title: "Project Director",
    slug: "amy-recker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Megha",
    lastName: "Reddy",
    title: "Project Manager",
    slug: "megha-reddy",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ann",
    lastName: "Reddy",
    title: "Project Director",
    slug: "ann-reddy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alla",
    lastName: "Reese",
    title: "Director of Internal Audits",
    slug: "alla-reese",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Craig",
    lastName: "Reese",
    title: "Senior CRM Developer",
    slug: "craig-reese",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Eliza",
    lastName: "Rego",
    title: "Project Manager",
    slug: "eliza-rego",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Madison",
    lastName: "Reid",
    title: "Development Associate, Brown University Sports Foundation",
    slug: "madison-reid",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hayden",
    lastName: "Reiss",
    title: "Academic Program Manager",
    slug: "hayden-reiss",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ashley",
    lastName: "Rent",
    title: "Financial Coordinator, Systems and Budget",
    slug: "ashley-rent",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Maggie",
    lastName: "Retton",
    title: "Development Coordinator",
    slug: "maggie-retton",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joel",
    lastName: "Revill",
    title: "Deputy Dean for Academic & Student Affairs",
    slug: "joel-revill",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rebecca",
    lastName: "Rex",
    title: "Senior Director of Corporate & Foundation Relations",
    slug: "rebecca-rex",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julio",
    lastName: "Reyes",
    title: "Director, U-FLi Center",
    slug: "julio-reyes",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Nelsy",
    lastName: "Reyes Mateo",
    title: "Academic Coordinator",
    slug: "nelsy-reyes-mateo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Arden",
    lastName: "Reynolds",
    title: "ENGL 0511C Lead Teaching Fellow, National Education Equity Lab",
    slug: "arden-reynolds",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tiffany",
    lastName: "Reynoso",
    title: "Project Coordinator",
    slug: "tiffany-reynoso",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lauren",
    lastName: "Rheaume",
    title: "Human Resources Specialist",
    slug: "lauren-rheaume",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Helen",
    lastName: "Rhines",
    title: "Regional Development Associate",
    slug: "helen-rhines",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jamie",
    lastName: "Rhode",
    title: "ArtsCrew Production Assistant",
    slug: "jamie-rhode",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maria",
    lastName: "Ricci",
    title: "Athletic Ticket Office Representative",
    slug: "maria-ricci",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Geoffrey",
    lastName: "Riccio",
    title: "Athletics Content and Creative Communications Coordinator",
    slug: "geoffrey-riccio",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sean",
    lastName: "Rice",
    title: "Assistant Director, Triage and Case Coordination",
    slug: "sean-rice",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "John",
    lastName: "Rice",
    title: "Senior Application Administrator",
    slug: "john-rice",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Allison",
    lastName: "Rich",
    title: "Head of Cataloging Services",
    slug: "allison-rich",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amanda",
    lastName: "Richards",
    title: "Human Resources Specialist",
    slug: "amanda-richards",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Daniel",
    lastName: "Richards",
    title: "Senior Podcast Producer",
    slug: "daniel-richards",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Patrick",
    lastName: "Riedy",
    title: "Grant and Financial Specialist",
    slug: "patrick-riedy",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jacob",
    lastName: "Rinn",
    title: "Lifeguard",
    slug: "jacob-rinn",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Javier",
    lastName: "Rios",
    title: "HR Service Center Coordinator",
    slug: "javier-rios",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Francisco",
    lastName: "Ripley",
    title: "Assistant Manager, Course Materials",
    slug: "francisco-ripley",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Catrina",
    lastName: "Ritchie",
    title: "Auxiliary Housing Coordinator",
    slug: "catrina-ritchie",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Madelyn",
    lastName: "Ritchie Hilbert",
    title: "Assistant Director, Strategic Sourcing",
    slug: "madelyn-ritchie-hilbert",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Steven",
    lastName: "Rivera",
    title: "Football Game Day Filmer",
    slug: "steven-rivera",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cristian",
    lastName: "Rivera",
    title: "Communication Control Officer",
    slug: "cristian-rivera",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Maribel",
    lastName: "Rivera Sosa",
    title: "Grants & Financial Specialist",
    slug: "maribel-rivera-sosa",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Joseph",
    lastName: "Rizzi",
    title: "Athletics Communications Intern",
    slug: "joseph-rizzi",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Stephanie",
    lastName: "Robert",
    title: "Senior Paralegal",
    slug: "stephanie-robert",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Raquel",
    lastName: "Robertson",
    title: "Associate Director of Academic Special Projects",
    slug: "raquel-robertson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ashton",
    lastName: "Robertson",
    title: "Athletics Photography Assistant",
    slug: "ashton-robertson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Heather",
    lastName: "Robichaud",
    title: "Executive Assistant",
    slug: "heather-robichaud",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alicia",
    lastName: "Robinson",
    title: "Admissions Specialist",
    slug: "alicia-robinson",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Paul",
    lastName: "Rochford",
    title: "Senior Media Producer",
    slug: "paul-rochford",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jordan",
    lastName: "Rockford",
    title: "Assistant Dean of the College for Brown-RISD Programs",
    slug: "jordan-rockford",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Catherine",
    lastName: "Rodarte",
    title: "Associate Director of Admission and Recruitment, MPA Program",
    slug: "catherine-rodarte",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Karla",
    lastName: "Rodas Mendez",
    title: "Regional Development Associate",
    slug: "karla-rodas-mendez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maria",
    lastName: "Rodrigues",
    title: "Custodial Shift Assistant",
    slug: "maria-rodrigues",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cassandra",
    lastName: "Rodrigues",
    title: "Lead Baker - 52 Weeks",
    slug: "cassandra-rodrigues",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Isseniel",
    lastName: "Rodriguez",
    title: "Associate Director, Digital Marketing",
    slug: "isseniel-rodriguez",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Joshua",
    lastName: "Rodriguez",
    title: "Associate Director, Co-Curricular Learning",
    slug: "joshua-rodriguez",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Benny",
    lastName: "Rodriguez",
    title: "Administrative Coordinator, Center for Biomedical Informatics",
    slug: "benny-rodriguez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristen",
    lastName: "Rodriguez",
    title: "Accounts Payable Coordinator",
    slug: "kristen-rodriguez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Aliana",
    lastName: "Rodriguez Acevedo",
    title: "Project Coordinator",
    slug: "aliana-rodriguez-acevedo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ann",
    lastName: "Roe",
    title: "Administrative/Financial Assistant",
    slug: "ann-roe",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kiara",
    lastName: "Roger",
    title: "Manager,  Customer Service",
    slug: "kiara-roger",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Don",
    lastName: "Rogers",
    title: "Assistant CIO, IT Support & Customer Experience",
    slug: "don-rogers",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "CJ",
    lastName: "Rogers",
    title: "Brown Sports Network Production Crew",
    slug: "cj-rogers",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ronald",
    lastName: "Rogers",
    title: "Manager, Identity Services",
    slug: "ronald-rogers",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Corinne",
    lastName: "Roma",
    title: "Project Manager",
    slug: "corinne-roma",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Natalia",
    lastName: "Roman Alicea",
    title: "Assistant Director of Alumni Belonging",
    slug: "natalia-roman-alicea",
    dei: true,
    category: "Miscellaneous",
  },
  {
    firstName: "Tonya",
    lastName: "Rosa",
    title: "Supplier Registration Supervisor",
    slug: "tonya-rosa",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Irvin",
    lastName: "Rosales Garcia",
    title: "Seasonal Research Interviewer",
    slug: "irvin-rosales-garcia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kathleen",
    lastName: "Rose",
    title: "Senior Project Manager",
    slug: "kathleen-rose",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michelle",
    lastName: "Rose",
    title: "Financial Coordinator",
    slug: "michelle-rose",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ilene",
    lastName: "Rose",
    title: "Lead IT Support Consultant",
    slug: "ilene-rose",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michael",
    lastName: "Rosendale",
    title: "Associate Director, Systems and Database Services",
    slug: "michael-rosendale",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tyler",
    lastName: "Rosenholm",
    title: "Grants and Financial Specialist",
    slug: "tyler-rosenholm",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Karen",
    lastName: "Roskelly",
    title: "Senior Assistant Director",
    slug: "karen-roskelly",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Edward",
    lastName: "Roskiewicz",
    title: "Senior Leadership Giving Officer",
    slug: "edward-roskiewicz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kimberly",
    lastName: "Roskiewicz",
    title: "Assistant Vice President for Workforce Strategy",
    slug: "kimberly-roskiewicz",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Shante",
    lastName: "Ross",
    title: "Athletic Ticket Office Representative",
    slug: "shante-ross",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Victor",
    lastName: "Ross",
    title: "Supervisor, Custodial Services",
    slug: "victor-ross",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lisa",
    lastName: "Ross",
    title: "Planned Giving Associate",
    slug: "lisa-ross",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rebecca",
    lastName: "Rossi",
    title: "Patent and Agreement Data Coordinator",
    slug: "rebecca-rossi",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "John",
    lastName: "Rossi",
    title: "Loan Counselor",
    slug: "john-rossi",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Shelley",
    lastName: "Roth",
    title: "Director of Development for Academic Initiatives",
    slug: "shelley-roth",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Giovanna",
    lastName: "Roz Gastaldi",
    title: "Associate Director, Media Services",
    slug: "giovanna-roz-gastaldi",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Marjorie",
    lastName: "Rubin",
    title: "Director, OIT Human Resources",
    slug: "marjorie-rubin",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Zaria",
    lastName: "Ruiz",
    title: "Development Coordinator",
    slug: "zaria-ruiz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Arianna",
    lastName: "Ruolo",
    title: "Human Resources Coordinator",
    slug: "arianna-ruolo",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Michelle",
    lastName: "Ruscito",
    title: "Grants and Financial Specialist",
    slug: "michelle-ruscito",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Priscilla",
    lastName: "Ruscito",
    title: "Grants and Financial Specialist",
    slug: "priscilla-ruscito",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nathan",
    lastName: "Rush",
    title: "Associate Director of Masters Admissions Systems",
    slug: "nathan-rush",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Emma",
    lastName: "Russell",
    title: "Senior Grant and Contract Administrator",
    slug: "emma-russell",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Teniesea",
    lastName: "Russell",
    title: "Residential Area Coordinator",
    slug: "teniesea-russell",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Megan",
    lastName: "Russell",
    title: "Associate Dean of Diversity, Equity and Inclusion",
    slug: "megan-russell",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Daniel",
    lastName: "Ruth",
    title: "Senior Visual Designer",
    slug: "daniel-ruth",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jay",
    lastName: "Ruzicka",
    title: "Athletics Photography Assistant",
    slug: "jay-ruzicka",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Vanessa",
    lastName: "Ryan",
    title: "Senior Associate Dean of Student Development",
    slug: "vanessa-ryan",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Rachel",
    lastName: "Ryan",
    title: "Senior Learning Designer",
    slug: "rachel-ryan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Frances",
    lastName: "Saadeh",
    title: "Associate Director, Non-Degree Programs",
    slug: "frances-saadeh",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Simeon",
    lastName: "Sabo",
    title: "Mail Clerk",
    slug: "simeon-sabo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anthony",
    lastName: "Saccoccia",
    title: "Video Producer",
    slug: "anthony-saccoccia",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Alana",
    lastName: "Sacks",
    title: "BWell Associate Director of Response Services",
    slug: "alana-sacks",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Joseph",
    lastName: "Sadak",
    title: "Director, Real Estate",
    slug: "joseph-sadak",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David",
    lastName: "Saenz",
    title: "Manager of Special Housing",
    slug: "david-saenz",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jessica",
    lastName: "Saenz Gomez",
    title: "Manager, Community-Engaged Learning",
    slug: "jessica-saenz-gomez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Elaine",
    lastName: "Saklad",
    title: "Associate Director, Business Systems and Integration",
    slug: "elaine-saklad",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Peter",
    lastName: "Salant",
    title: "Senior Grants and Contracts Accountant",
    slug: "peter-salant",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Felicia",
    lastName: "Salinas-Moniz",
    title: "Director, Sarah Doyle Center for Women and Gender",
    slug: "felicia-salinas-moniz",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Joanna",
    lastName: "Saltonstall",
    title: "Senior Program Manager",
    slug: "joanna-saltonstall",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katharine",
    lastName: "Salvaggio",
    title: "IT Contract & Risk Assessment Specialist",
    slug: "katharine-salvaggio",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Matthew",
    lastName: "Salvatore",
    title: "Executive Director, Advancement Data Strategies & Marketing",
    slug: "matthew-salvatore",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessi",
    lastName: "Samuel",
    title: "Development Officer, Academic Initiatives",
    slug: "jessi-samuel",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Marlon",
    lastName: "Sanchez",
    title: "Project Manager",
    slug: "marlon-sanchez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth",
    lastName: "Sandberg",
    title:
      " Executive Assistant to the Vice President of Advancement Services and Development Support",
    slug: "elizabeth-sandberg",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Terrance",
    lastName: "Sanders",
    title: "Director of Greek, Program and Theme Communities",
    slug: "terrance-sanders",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Amy",
    lastName: "Sanderson",
    title: "Director of Emergency Management for Student Health and Wellness",
    slug: "amy-sanderson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Christina",
    lastName: "Sandoval-Galvao",
    title: "Administrative Assistant",
    slug: "christina-sandoval-galvao",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tarika",
    lastName: "Sankar",
    title: "Digital Humanities Librarian",
    slug: "tarika-sankar",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Stephen",
    lastName: "Sanquist",
    title: "Associate Equipment Room Manager",
    slug: "stephen-sanquist",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Margaret",
    lastName: "Santiago",
    title: "Director of Human Resources",
    slug: "margaret-santiago",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Kristina",
    lastName: "Santilli",
    title: "Grants and Financial Specialist",
    slug: "kristina-santilli",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Johnny",
    lastName: "Santini",
    title: "ArtsCrew Production Assistant",
    slug: "johnny-santini",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael",
    lastName: "Santoemmo",
    title: "Event Meeting Coordinator",
    slug: "michael-santoemmo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah",
    lastName: "Santos",
    title: "Director of Development for Academic Initiatives",
    slug: "sarah-santos",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Claudio",
    lastName: "Santos",
    title: "Lead Technical Services Specialist",
    slug: "claudio-santos",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Daniel",
    lastName: "Santos",
    title: "Assistant Director of Financial Planning and Analysis",
    slug: "daniel-santos",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Stephanie",
    lastName: "Santucci",
    title: "Assistant Director of Occupational Health & Safety",
    slug: "stephanie-santucci",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Theresa",
    lastName: "Saritelli",
    title: "Stewardship Officer",
    slug: "theresa-saritelli",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Janyce",
    lastName: "Sarmaniote",
    title: "Assistant Director, Finance",
    slug: "janyce-sarmaniote",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "David",
    lastName: "Sartori",
    title: "Senior IT Support Consultant",
    slug: "david-sartori",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ana",
    lastName: "Saul-Sykes",
    title: "Director of Special Programs",
    slug: "ana-saul-sykes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jake",
    lastName: "Saunders",
    title: "Associate Director, Annual Giving",
    slug: "jake-saunders",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Margot",
    lastName: "Saurette",
    title: "Executive Assistant and Project Coordinator",
    slug: "margot-saurette",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Francesca",
    lastName: "Savella",
    title: "Assistant Director",
    slug: "francesca-savella",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Micah",
    lastName: "Saxton",
    title: "Humanities Librarian",
    slug: "micah-saxton",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "William",
    lastName: "Sayles",
    title: "Auditor 4",
    slug: "william-sayles",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Oliver",
    lastName: "Scampoli",
    title: "Senior Video Producer",
    slug: "oliver-scampoli",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Eric",
    lastName: "Scantlebury",
    title: "Senior IT Support Consultant",
    slug: "eric-scantlebury",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Debra",
    lastName: "Scaramuzzi",
    title: "Senior Procurement & Contracts Specialist",
    slug: "debra-scaramuzzi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Patrick",
    lastName: "Schaefer",
    title:
      " Senior Director, Academic Initiatives for the School of Public Health",
    slug: "patrick-schaefer",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ajee",
    lastName: "Schaeffer",
    title: "Assistant Director for the Brown Center for Students of Color",
    slug: "ajee-schaeffer",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ellen",
    lastName: "Schatz",
    title: "Major Gifts Officer",
    slug: "ellen-schatz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laura",
    lastName: "Schellin",
    title: "Communications Specialist",
    slug: "laura-schellin",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Karson",
    lastName: "Schenk",
    title: "Educational Media Producer, Editor",
    slug: "karson-schenk",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Diane",
    lastName: "Schlacter",
    title: "Assistant Director of MPH Program",
    slug: "diane-schlacter",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lauren",
    lastName: "Schlichting",
    title: "Director of Data Analytics",
    slug: "lauren-schlichting",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Emily",
    lastName: "Schlosnagle",
    title: "Senior Project Manager",
    slug: "emily-schlosnagle",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Daniel",
    lastName: "Schmidlin",
    title: "Regional Development Director, West Coast",
    slug: "daniel-schmidlin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julie",
    lastName: "Schmidt",
    title: "Director of Board Relations and Special Projects",
    slug: "julie-schmidt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melissa",
    lastName: "Schmiedeknecht",
    title: "Senior Computing Accounts Specialist",
    slug: "melissa-schmiedeknecht",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Gracie",
    lastName: "Schneider",
    title: "Financial Coordinator",
    slug: "gracie-schneider",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rebekah",
    lastName: "Schoenecker",
    title: "Brown Sports Network Production Crew",
    slug: "rebekah-schoenecker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marty",
    lastName: "Scholtz",
    title: "Deputy Vice President for Research",
    slug: "marty-scholtz",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Gretchen",
    lastName: "Schrafft",
    title: "Scientific Communications Specialist",
    slug: "gretchen-schrafft",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Monique",
    lastName: "Schroth",
    title: "Human Resources Coordinator",
    slug: "monique-schroth",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Rob",
    lastName: "Schulbaum",
    title: "Educational Media Editor",
    slug: "rob-schulbaum",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Katy",
    lastName: "Schultz",
    title: "Communications and Events Coordinator",
    slug: "katy-schultz",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Peter",
    lastName: "Schwaller",
    title: "Athletics Photography Assistant",
    slug: "peter-schwaller",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joanne",
    lastName: "Schwendner",
    title: "Senior Developer",
    slug: "joanne-schwendner",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Olivia",
    lastName: "Scott",
    title: "Grants and Financial Coordinator",
    slug: "olivia-scott",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jorge",
    lastName: "Scott",
    title: "Supervisor, Custodial Services",
    slug: "jorge-scott",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Debra",
    lastName: "Scott",
    title: "Financial Coordinator",
    slug: "debra-scott",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Katie",
    lastName: "Scott-Haughey",
    title: "Project Director",
    slug: "katie-scott-haughey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Celia",
    lastName: "Scurry",
    title: "Administrative Coordinator",
    slug: "celia-scurry",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carly",
    lastName: "Seaman",
    title: "Supplier / Payee Registration Coordinator",
    slug: "carly-seaman",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kerri",
    lastName: "Sears",
    title: "Admissions Coordinator",
    slug: "kerri-sears",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Lisa",
    lastName: "Seawell",
    title: "Grants and Financial Specialist",
    slug: "lisa-seawell",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Allison",
    lastName: "Seeley",
    title:
      " Health Promotion Specialist: Relationship Empowerment and Interpersonal Violence Prevention Coordinator",
    slug: "allison-seeley",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Gregory",
    lastName: "Seiler",
    title: "Associate Director, Student Exploration",
    slug: "gregory-seiler",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Leonardo",
    lastName: "Selvaggio",
    title: "Senior Specialist, Creative Technologies",
    slug: "leonardo-selvaggio",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kat",
    lastName: "Semenova",
    title: "Financial Specialist",
    slug: "kat-semenova",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lonna",
    lastName: "Seng",
    title: "Financial and Administrative Coordinator",
    slug: "lonna-seng",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tamara",
    lastName: "Sequeira",
    title: "Project Director",
    slug: "tamara-sequeira",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yuliia",
    lastName: "Sereda",
    title: "Project Manager",
    slug: "yuliia-sereda",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lisa",
    lastName: "Sergi",
    title: "Creative Director",
    slug: "lisa-sergi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kathryn",
    lastName: "Sever",
    title: "Online Order Fulfillment Clerk",
    slug: "kathryn-sever",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Arline",
    lastName: "Sewell",
    title: "Administrative Coordinator",
    slug: "arline-sewell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Komal",
    lastName: "Shah",
    title: "Associate Director of Career Services and Professional Development",
    slug: "komal-shah",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Zachary",
    lastName: "Shain",
    title: "Director, Regional Development",
    slug: "zachary-shain",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elle",
    lastName: "Shannon",
    title: "Seasonal Sales Associate",
    slug: "elle-shannon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Evelyn",
    lastName: "Shapiro",
    title: "Assistant Director of Financial Reporting and Analysis",
    slug: "evelyn-shapiro",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Shreenidhi",
    lastName: "Sharma",
    title: "Data Manager",
    slug: "shreenidhi-sharma",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sarah",
    lastName: "Sharpe",
    title: "Assistant Director",
    slug: "sarah-sharpe",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rowan",
    lastName: "Shaw-Jones",
    title: "ArtsCrew Production Assistant",
    slug: "rowan-shaw-jones",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anna-Mariya",
    lastName: "Shepherd",
    title: "Computing Accounts Specialist",
    slug: "anna-mariya-shepherd",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "John",
    lastName: "Shepherd",
    title: "Master Locksmith",
    slug: "john-shepherd",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Morgan",
    lastName: "Sherburne",
    title: "Athletics Marketing Coordinator",
    slug: "morgan-sherburne",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Wendy",
    lastName: "Sheridan",
    title: "Academic Program Manager",
    slug: "wendy-sheridan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Vanessa",
    lastName: "Sherman",
    title: "Research Contract Administrator",
    slug: "vanessa-sherman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kunchong",
    lastName: "Shi",
    title: "Research Program/Project Director",
    slug: "kunchong-shi",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Derek",
    lastName: "Shields",
    title: "Sergeant",
    slug: "derek-shields",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dae",
    lastName: "Shields",
    title: "Equipment Room Specialist",
    slug: "dae-shields",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Timothy",
    lastName: "Shiner",
    title: "Senior Associate Dean of the College for Advising",
    slug: "timothy-shiner",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michael",
    lastName: "Shiner",
    title: "SPS Teaching Associate - MTL",
    slug: "michael-shiner",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Costigan",
    lastName: "Shoniber",
    title: "Mail Clerk",
    slug: "costigan-shoniber",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jorean",
    lastName: "Sicks",
    title: "Special Projects Biostatistics Group Manager",
    slug: "jorean-sicks",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Claire",
    lastName: "Sidla",
    title: "Director of Labor Relations",
    slug: "claire-sidla",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Molly",
    lastName: "Siegel",
    title: "Admission Officer",
    slug: "molly-siegel",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Michelle",
    lastName: "Sierra Zayas",
    title: "Bilingual (Spanish) Research Interviewer",
    slug: "michelle-sierra-zayas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katya",
    lastName: "Sigal",
    title: "Tutor, Gateways Programs",
    slug: "katya-sigal",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Becca",
    lastName: "Siladi",
    title: "Communications and Outreach Coordinator",
    slug: "becca-siladi",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Juan",
    lastName: "Siliezar",
    title:
      " Associate Director of Media Relations and Leadership Communications",
    slug: "juan-siliezar",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kimberly",
    lastName: "Silva",
    title: "Grant/Contract Accountant I",
    slug: "kimberly-silva",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Patricia",
    lastName: "Silva",
    title: "Cashier/Checker/Clerk",
    slug: "patricia-silva",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Vanessa",
    lastName: "Silva",
    title: "Project Manager",
    slug: "vanessa-silva",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shannon",
    lastName: "Silva",
    title: "Department Manager",
    slug: "shannon-silva",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kimberly",
    lastName: "Silva",
    title: "Head, Access Services and Reserves",
    slug: "kimberly-silva-1",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jake",
    lastName: "Silverman",
    title: "Assistant Vice President for Athletics and Recreation",
    slug: "jake-silverman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Meghan",
    lastName: "Silvestri",
    title: "Associate Director of Event Management",
    slug: "meghan-silvestri",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Dawn",
    lastName: "Silvia",
    title: "Executive Assistant, Office of the University Librarian",
    slug: "dawn-silvia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emanuel",
    lastName: "Simas",
    title: "Groundsworker",
    slug: "emanuel-simas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Wendy",
    lastName: "Simas",
    title: "Manager of Finance and Administration",
    slug: "wendy-simas",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Claudio",
    lastName: "Simeone",
    title: "Lead, Workday Reporting",
    slug: "claudio-simeone",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sherie",
    lastName: "Simino",
    title: "Senior IT Support Consultant",
    slug: "sherie-simino",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Stephanie",
    lastName: "Simon",
    title: "Senior Application Administrator",
    slug: "stephanie-simon",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kenneth",
    lastName: "Simone",
    title: "Athletics Public Address Announcer",
    slug: "kenneth-simone",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tony",
    lastName: "Siravo",
    title: "Supervisor, Controls",
    slug: "tony-siravo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "James",
    lastName: "Sisson",
    title: "Senior Construction Manager",
    slug: "james-sisson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Grace",
    lastName: "Skavdahl",
    title: "Athletics Creative Content Assistant",
    slug: "grace-skavdahl",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Alexander",
    lastName: "Skibinski",
    title: "Athletics Ticket Office Intern",
    slug: "alexander-skibinski",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jayne",
    lastName: "Skinner",
    title: "Tutor, Gateways Program",
    slug: "jayne-skinner",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Todd",
    lastName: "Skoglund",
    title: "Web Strategist and Producer",
    slug: "todd-skoglund",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kat",
    lastName: "Skowyra",
    title: "Senior IT Support Consultant",
    slug: "kat-skowyra",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Brenda",
    lastName: "Slaney",
    title: "Training Grants Specialist",
    slug: "brenda-slaney",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Louise",
    lastName: "Sloan",
    title: "Brown Alumni Magazine Editorial Content Director",
    slug: "louise-sloan",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kyle",
    lastName: "Sloane",
    title: "Lead Specialist, Media Platforms and Innovation",
    slug: "kyle-sloane",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Nathan",
    lastName: "Sloat",
    title: "Brown Sports Network Production Crew",
    slug: "nathan-sloat",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mary",
    lastName: "Smith",
    title: "Manager, Data Analytics",
    slug: "mary-smith",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Christina",
    lastName: "Smith",
    title: "Associate Director for Undergraduate STEM Development",
    slug: "christina-smith",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Carl",
    lastName: "Smith",
    title: "Preparator",
    slug: "carl-smith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rory",
    lastName: "Smith",
    title: "Research and Investigation Manager",
    slug: "rory-smith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth",
    lastName: "Smith",
    title: "Assistant Director, Medical Education/Program Director, PC-PM",
    slug: "elizabeth-smith",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Laura",
    lastName: "Smith",
    title: "Executive Director, Parent and Family Giving",
    slug: "laura-smith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Heather",
    lastName: "Smith",
    title: "Manager, Data Analytics",
    slug: "heather-smith",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Molly",
    lastName: "Smith",
    title: "Stewardship Officer",
    slug: "molly-smith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Corinne",
    lastName: "Smith",
    title: "Adjunct Reader",
    slug: "corinne-smith",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Takyah",
    lastName: "Smith",
    title: "Health Promotion Specialist: Social Wellness Coordinator",
    slug: "takyah-smith",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sandra",
    lastName: "Smith",
    title: "Senior Associate Dean, Professional and Executive Education",
    slug: "sandra-smith",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kate",
    lastName: "Smith",
    title: "Multimedia Video Producer",
    slug: "kate-smith",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jennie",
    lastName: "Smithken-Lindsay",
    title: "Collections Assistant",
    slug: "jennie-smithken-lindsay",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maria",
    lastName: "Snead",
    title: "Study Abroad Administrative Coordinator",
    slug: "maria-snead",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Megan",
    lastName: "Snell",
    title: "Senior Research Contracts Administrator",
    slug: "megan-snell",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rina",
    lastName: "Snyder",
    title: "Data Assistant/ Interviewer (Bilingual)",
    slug: "rina-snyder",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sandy",
    lastName: "Soares",
    title: "Manager, Community-Engaged Learning",
    slug: "sandy-soares",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ryan",
    lastName: "Soares",
    title: "Athletics Creative Content Assistant",
    slug: "ryan-soares",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Linda",
    lastName: "Soeurt",
    title: "Administrative Coordinator",
    slug: "linda-soeurt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maria",
    lastName: "Sokolova",
    title: "Center Manager",
    slug: "maria-sokolova",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Indrani",
    lastName: "Solomon",
    title: "Grant and Financial Specialist",
    slug: "indrani-solomon",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Cheny",
    lastName: "Som",
    title: "Assistant Director, Post-Award Services",
    slug: "cheny-som",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Gianna",
    lastName: "Soprano",
    title: "ArtsCrew Production Assistant",
    slug: "gianna-soprano",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mum",
    lastName: "Sou-Coffey",
    title: "Financial Services Coordinator (Gift Processor)",
    slug: "mum-sou-coffey",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Katrina",
    lastName: "Souder",
    title: "Associate Director of Admission",
    slug: "katrina-souder",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Amy",
    lastName: "Sousa",
    title: "Department Manager",
    slug: "amy-sousa",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jenna",
    lastName: "Sousa",
    title: "Associate Director of Administration and Finance",
    slug: "jenna-sousa",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Stacy",
    lastName: "Sousa",
    title: "Human Resources Specialist",
    slug: "stacy-sousa",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Rachel",
    lastName: "Souza",
    title: "Academic Records Compliance Coordinator",
    slug: "rachel-souza",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lauren",
    lastName: "Souza",
    title: "Research Services Manager",
    slug: "lauren-souza",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Cheryl",
    lastName: "Souza",
    title: "Data Assistant/Interviewer",
    slug: "cheryl-souza",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Martha",
    lastName: "Souza",
    title: "Senior Parent Giving and Recognition Officer",
    slug: "martha-souza",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessica",
    lastName: "Souza",
    title: "Assistant Director, Editorial and Creative Content",
    slug: "jessica-souza",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Enoch",
    lastName: "Sowah",
    title: "Custodial Shift Assistant",
    slug: "enoch-sowah",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robert",
    lastName: "Sowah",
    title: "Custodial Shift Assistant",
    slug: "robert-sowah",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ebenezer",
    lastName: "Sowah",
    title: "Custodial Shift Assistant",
    slug: "ebenezer-sowah",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Thera",
    lastName: "Sparks",
    title: "Alumni Leadership Associate",
    slug: "thera-sparks",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Melissa",
    lastName: "Sparrow",
    title: "Senior Accounts Payable Specialist",
    slug: "melissa-sparrow",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Michael",
    lastName: "Spaur",
    title: "Media Producer and Coordinator",
    slug: "michael-spaur",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Erin",
    lastName: "Spear",
    title: "Director of Marketing and Communications",
    slug: "erin-spear",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Maggie",
    lastName: "Spear",
    title: "Communications Manager and Writer for Student Life",
    slug: "maggie-spear",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Endawnis",
    lastName: "Spears",
    title: "Practitioner in Residence for Tribal Engagement",
    slug: "endawnis-spears",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "June",
    lastName: "Spencer",
    title: "Program Manager",
    slug: "june-spencer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jeanne",
    lastName: "Spinosa",
    title: "Manager, Telecommunications",
    slug: "jeanne-spinosa",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Daniel",
    lastName: "St John",
    title: "Senior Grant and Contract Administrator",
    slug: "daniel-st-john",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Allison",
    lastName: "St Onge",
    title: "Development Officer, Corporate and Foundation Relations",
    slug: "allison-st-onge",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Danielle",
    lastName: "St Pierre",
    title: "Research Development and Support Specialist",
    slug: "danielle-st-pierre",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mikele",
    lastName: "St-Germain",
    title: "Director of Parent and Family Engagement",
    slug: "mikele-st-germain",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sarah",
    lastName: "St. Laurent",
    title: "Production Manager",
    slug: "sarah-st-laurent",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andre",
    lastName: "St. Pierre",
    title: "Senior IT Support Consultant",
    slug: "andre-st-pierre",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kevin",
    lastName: "Stacey",
    title: "Senior Communications Manager and Writer for the Physical Sciences",
    slug: "kevin-stacey",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Beth",
    lastName: "Stachura",
    title: "Director of Labor Relations",
    slug: "beth-stachura",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Mason",
    lastName: "Stalph",
    title: "Athletics Public Address Announcer",
    slug: "mason-stalph",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jill",
    lastName: "Stange",
    title: "Assistant Director, Shared Interest Groups",
    slug: "jill-stange",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Patricia",
    lastName: "Stebbins",
    title: "Assistant Director for Diagnostics, Imaging, and PROs",
    slug: "patricia-stebbins",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nate",
    lastName: "Stemple",
    title: "Grants and Contracts Specialist",
    slug: "nate-stemple",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jasper",
    lastName: "Sterling",
    title: "Culinary Assistant",
    slug: "jasper-sterling",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maya",
    lastName: "Stern",
    title: "ArtsCrew Exhibitions Assistant",
    slug: "maya-stern",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah",
    lastName: "Stetson",
    title: "Equity & Diversity Data Analyst",
    slug: "sarah-stetson",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Asia",
    lastName: "Stevens",
    title: "Department Manager",
    slug: "asia-stevens",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katie",
    lastName: "Stewart",
    title:
      " Assistant Director of Pre-College Programs, Humanities & Online Courses",
    slug: "katie-stewart",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ava",
    lastName: "Stipanovich",
    title: "Tutor, Gateways Program",
    slug: "ava-stipanovich",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Laura",
    lastName: "Stokes",
    title: "Performing Arts Librarian",
    slug: "laura-stokes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emma",
    lastName: "Stolle",
    title: "Investment Associate",
    slug: "emma-stolle",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sophia",
    lastName: "Stone",
    title: "Musical Director and Worship Leader",
    slug: "sophia-stone",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Curtis",
    lastName: "Stoychoff",
    title: "Web Producer and Content Strategist",
    slug: "curtis-stoychoff",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Maria",
    lastName: "Stringfellow",
    title: "Senior Leadership Giving Officer",
    slug: "maria-stringfellow",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Yulia",
    lastName: "Strizheus",
    title: "Executive Assistant",
    slug: "yulia-strizheus",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nyrel",
    lastName: "Stroup",
    title: "Athletic Trainer",
    slug: "nyrel-stroup",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Shelly",
    lastName: "Strunk",
    title: "Educational Media Producer, Editor",
    slug: "shelly-strunk",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Aspen",
    lastName: "Stuart-Cunningham",
    title: "Communications and Events Coordinator",
    slug: "aspen-stuart-cunningham",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Seth",
    lastName: "Stulen",
    title: "Assistant Director of Global Partnerships",
    slug: "seth-stulen",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kyle",
    lastName: "Stumpe",
    title: "Grant/Contract Administrator",
    slug: "kyle-stumpe",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Stephanie",
    lastName: "Stuttard",
    title: "Grants Specialist",
    slug: "stephanie-stuttard",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Peter",
    lastName: "Su",
    title: "Director, Reporting & Data Analytics",
    slug: "peter-su",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Maria",
    lastName: "Suarez",
    title: "Associate Dean of Student Support Services",
    slug: "maria-suarez",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Henry",
    lastName: "Suazo",
    title: "Custodial Shift Assistant",
    slug: "henry-suazo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sunjeek",
    lastName: "Sukhbaatar",
    title: "Event Specialist",
    slug: "sunjeek-sukhbaatar",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maria",
    lastName: "Sullivan",
    title: "Director Of Continuing Medical Education",
    slug: "maria-sullivan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Colin",
    lastName: "Sullivan",
    title: "Digital Media and Event Specialist",
    slug: "colin-sullivan",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kristie",
    lastName: "Sullivan",
    title: "Associate Director of Student Health and Wellness",
    slug: "kristie-sullivan",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Michelle",
    lastName: "Sullivan",
    title: "Data Management Associate",
    slug: "michelle-sullivan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Wendy",
    lastName: "Sullivan",
    title: "Seasonal Reader",
    slug: "wendy-sullivan",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Dawn",
    lastName: "Sullo",
    title: "Communications Production Manager",
    slug: "dawn-sullo",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Samuel",
    lastName: "Sumeracki",
    title: "Director of Systems & Business Analysis",
    slug: "samuel-sumeracki",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Aarav",
    lastName: "Sundaresh",
    title: "Assistant Director for Engagement and Partnerships",
    slug: "aarav-sundaresh",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Yoni",
    lastName: "Sunshine",
    title: "Assistant Director, Annual Giving Leadership Programs",
    slug: "yoni-sunshine",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Julia",
    lastName: "Surdel",
    title: "Health System Grant & Financial Specialist",
    slug: "julia-surdel",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Dana",
    lastName: "Sutcliffe",
    title: "Communications Specialist",
    slug: "dana-sutcliffe",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Monica",
    lastName: "Sutcliffe",
    title: "Director, Digital Systems of Engagement",
    slug: "monica-sutcliffe",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Christopher",
    lastName: "Sutcliffe",
    title: "Athletics Photography Assistant",
    slug: "christopher-sutcliffe",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Linda",
    lastName: "Sutherland",
    title: "Co-Curricular Program Manager",
    slug: "linda-sutherland",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Andrew",
    lastName: "Sutherland",
    title: "Senior Staff Accountant",
    slug: "andrew-sutherland",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Cassie",
    lastName: "Sutten Coats",
    title: "Associate Director of Student Activities",
    slug: "cassie-sutten-coats",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Eric",
    lastName: "Swanson",
    title: "Senior Strategic Sourcing Manager",
    slug: "eric-swanson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Charlene",
    lastName: "Sweeney",
    title: "Associate Vice President and University Controller",
    slug: "charlene-sweeney",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Deborah",
    lastName: "Swenson",
    title: "Grants and Financial Specialist",
    slug: "deborah-swenson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jasmine",
    lastName: "Sykes-Kunk",
    title: "Head of Research Services",
    slug: "jasmine-sykes-kunk",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tony",
    lastName: "Sylvester",
    title: "Director of Systems",
    slug: "tony-sylvester",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Brett",
    lastName: "Sylvia",
    title: "ArtsCrew Production Assistant",
    slug: "brett-sylvia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katarzyna",
    lastName: "Szulc",
    title: "Consultant",
    slug: "katarzyna-szulc",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Megan",
    lastName: "Szwyd",
    title: "Associate Director, Real Estate",
    slug: "megan-szwyd",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Patricia",
    lastName: "Szyndlar",
    title: "Gift Accounting Associate",
    slug: "patricia-szyndlar",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Shannon",
    lastName: "Tacelli",
    title: "Administrative Coordinator",
    slug: "shannon-tacelli",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mandy",
    lastName: "Tachiki",
    title: "Seasonal Reader",
    slug: "mandy-tachiki",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Mackenzie",
    lastName: "Tagliaferro",
    title: "IT Project Manager",
    slug: "mackenzie-tagliaferro",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kisa",
    lastName: "Takesue",
    title: "Director, Pre-College & Leadership Programs",
    slug: "kisa-takesue",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Amanda",
    lastName: "Talbot",
    title: "Senior Annual Leadership Giving Officer",
    slug: "amanda-talbot",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Polly",
    lastName: "Talbott",
    title: "Associate Director, Planned Giving",
    slug: "polly-talbott",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Stephanie",
    lastName: "Tam",
    title: "Evening Events Manager",
    slug: "stephanie-tam",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Michael",
    lastName: "Tan",
    title: "Project Coordinator",
    slug: "michael-tan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Milindkumar",
    lastName: "Tandel",
    title: "Lead Developer",
    slug: "milindkumar-tandel",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kristoffer",
    lastName: "Tangen",
    title: "Assistant Director, Student Exploration",
    slug: "kristoffer-tangen",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Rick",
    lastName: "Tao",
    title: "Lifelong Learning Associate",
    slug: "rick-tao",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amy",
    lastName: "Tarbox",
    title: "Associate Director, Career Counseling",
    slug: "amy-tarbox",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Joshua",
    lastName: "Taub",
    title: "Associate Vice President for Development",
    slug: "joshua-taub",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shawn",
    lastName: "Tavares",
    title: "Senior Technical Director",
    slug: "shawn-tavares",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Milary",
    lastName: "Tavarez",
    title: "Athletics Ticket Representative",
    slug: "milary-tavarez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rosenny",
    lastName: "Taveras",
    title: "Director, Health Equity Scholars Program",
    slug: "rosenny-taveras",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Michael",
    lastName: "Taylor",
    title: "Custodial Shift Assistant",
    slug: "michael-taylor",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julie",
    lastName: "Taylor",
    title: "Administrative Coordinator",
    slug: "julie-taylor",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lee",
    lastName: "Taylor-Penn",
    title: "Associate Director, State Alliance",
    slug: "lee-taylor-penn",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Valentine",
    lastName: "Tendo-Kuharic",
    title: "Generational Programs Coordinator",
    slug: "valentine-tendo-kuharic",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Robert",
    lastName: "Terra",
    title: "Lead VMware System Administrator",
    slug: "robert-terra",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Frances",
    lastName: "Terry",
    title: "Assistant Director of Research Development",
    slug: "frances-terry",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jason",
    lastName: "Tessitore",
    title: "Supervisor, Custodial Services (weekend, part time)",
    slug: "jason-tessitore",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrew",
    lastName: "Tetreault",
    title: "EMS Performance and Training Coordinator",
    slug: "andrew-tetreault",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Justin",
    lastName: "Tetreault",
    title: "Personal Trainer",
    slug: "justin-tetreault",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sharon",
    lastName: "Tetreault",
    title: "Senior Admission Coordinator",
    slug: "sharon-tetreault",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Dawn",
    lastName: "Tevyaw",
    title: "Catering Banquet Captain",
    slug: "dawn-tevyaw",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jayden",
    lastName: "Thai",
    title: "Psychotherapist",
    slug: "jayden-thai",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ansley",
    lastName: "Thoma",
    title: "Director of Design and Construction",
    slug: "ansley-thoma",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Johna",
    lastName: "Thomas",
    title: "Cashier/Checker/Clerk",
    slug: "johna-thomas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hazel",
    lastName: "Thomas",
    title: "Lifeguard",
    slug: "hazel-thomas",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sydney",
    lastName: "Thomas",
    title: "Admissions Specialist",
    slug: "sydney-thomas",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Keith",
    lastName: "Thompson",
    title: "Assistant Director, Learning, Development & Engagement",
    slug: "keith-thompson",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Sean",
    lastName: "Thompson",
    title: "Assistant Dean of the College and Director, Student Exploration",
    slug: "sean-thompson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Tina",
    lastName: "Thompson",
    title: "Assistant Director, Auxiliary Housing",
    slug: "tina-thompson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Celeste",
    lastName: "Thompson-Roach",
    title: "Grant and Contract Compliance Manager",
    slug: "celeste-thompson-roach",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kerri",
    lastName: "Thornton",
    title: "Financial Coordinator",
    slug: "kerri-thornton",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Timothy",
    lastName: "Thorp",
    title: "Senior Project Manager",
    slug: "timothy-thorp",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tammy",
    lastName: "Thorson",
    title: "Project Manager, CEO Core",
    slug: "tammy-thorson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Connor",
    lastName: "Thropp",
    title: "House Staff Officer in Radiation Oncology",
    slug: "connor-thropp",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Claire",
    lastName: "Tichi Grezemkovsky",
    title: "Major Gifts Officer",
    slug: "claire-tichi-grezemkovsky",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lisa",
    lastName: "Tillson",
    title: "Admission Coordinator",
    slug: "lisa-tillson",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Emily",
    lastName: "Timm",
    title: "ArtsCrew Preparator",
    slug: "emily-timm",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amir",
    lastName: "Toft",
    title: "Associate Chaplain of the University for the Muslim Community",
    slug: "amir-toft",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Gabriela",
    lastName: "Tolentino",
    title: "BIRCH Shared Services Assistant Director",
    slug: "gabriela-tolentino",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jack",
    lastName: "Tolman",
    title: "Manager of Creative Video",
    slug: "jack-tolman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Steve",
    lastName: "Tompkins",
    title: "Senior Technical Lead, Departmental Systems",
    slug: "steve-tompkins",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kathryn",
    lastName: "Tompson",
    title: "Assistant Director, Corporate and Foundation Relations",
    slug: "kathryn-tompson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kimberly",
    lastName: "Toney",
    title: "Coordinating Curator for Native American & Indigenous Collections",
    slug: "kimberly-toney",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christine",
    lastName: "Torgovec",
    title: "Development Associate",
    slug: "christine-torgovec",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kathy",
    lastName: "Toro-Ibanez",
    title: "Assistant Director, Career Counseling",
    slug: "kathy-toro-ibanez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Philip",
    lastName: "Torphy",
    title: "Progam Coordinator",
    slug: "philip-torphy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ruth",
    lastName: "Torres",
    title:
      " Tribal Community Member in Residence and Student Engagement Specialist",
    slug: "ruth-torres",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Erin",
    lastName: "Torres",
    title: "Title IX Case Manager",
    slug: "erin-torres",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Benjamin",
    lastName: "Trachman",
    title: "Assistant Director, Labor Relations",
    slug: "benjamin-trachman",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Kevin",
    lastName: "Travassos",
    title: "Supervisor, HVAC and Controls",
    slug: "kevin-travassos",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joshua",
    lastName: "Travis",
    title: "Senior Leadership Giving Officer",
    slug: "joshua-travis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sydney",
    lastName: "Treanor",
    title: "Executive Assistant to the Vice President for Community Engagement",
    slug: "sydney-treanor",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Grace",
    lastName: "Tremblay",
    title: "Administrative Coordinator",
    slug: "grace-tremblay",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Josh",
    lastName: "Trepanier",
    title: "Senior IT Support Consultant",
    slug: "josh-trepanier",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Melissa",
    lastName: "Trudeau",
    title: "IACUC Specialist",
    slug: "melissa-trudeau",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Louis",
    lastName: "Trujillo",
    title: "Adjunct Reader",
    slug: "louis-trujillo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Loc",
    lastName: "Truong",
    title:
      " Associate Vice President of Campus Life for Inclusive Community and Belonging",
    slug: "loc-truong",
    dei: true,
    category: "Student Life",
  },
  {
    firstName: "Torrey",
    lastName: "Truszkowski",
    title: "Assistant Director, Research Security & Export Control",
    slug: "torrey-truszkowski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nadia",
    lastName: "Tsado",
    title: "Data and Reporting Manager",
    slug: "nadia-tsado",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michelle",
    lastName: "Turcotte",
    title: "Administrative Coordinator",
    slug: "michelle-turcotte",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anne",
    lastName: "Turgeon",
    title: "Executive Assistant",
    slug: "anne-turgeon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Beau",
    lastName: "Turgeon",
    title: "Brown Sports Network Production Crew",
    slug: "beau-turgeon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniel",
    lastName: "Turner",
    title:
      " Assistant Director Community-Engaged Data and Evaluation Collaborative",
    slug: "daniel-turner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Samantha",
    lastName: "Turner",
    title: "Associate Director, Communications Strategy and Planning",
    slug: "samantha-turner",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jeffrey",
    lastName: "Turner",
    title: "Project Coordinator",
    slug: "jeffrey-turner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ben",
    lastName: "Tyler",
    title: "Publications and Design Specialist",
    slug: "ben-tyler",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jamie",
    lastName: "Tyrol",
    title: "Chief of Staff",
    slug: "jamie-tyrol",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eric",
    lastName: "Uffer",
    title: "Sales and Event Manager",
    slug: "eric-uffer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John",
    lastName: "Umbel",
    title: "Director of Planning and Analytics",
    slug: "john-umbel",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Samantha",
    lastName: "Urbaez",
    title: "ArtsCrew Producing Assistant",
    slug: "samantha-urbaez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shaydanay",
    lastName: "Urbani",
    title: "Project Manager for Outreach & Partnerships",
    slug: "shaydanay-urbani",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Andrea",
    lastName: "Vacca",
    title: "Financial Coordinator",
    slug: "andrea-vacca",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lisa",
    lastName: "Vaillancourt",
    title: "Project Coordinator",
    slug: "lisa-vaillancourt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cassandra",
    lastName: "Valdez Delapaix",
    title: "Project Manager",
    slug: "cassandra-valdez-delapaix",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jovani",
    lastName: "Valentin",
    title: "Financial Coordinator",
    slug: "jovani-valentin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lehi",
    lastName: "Valladares",
    title: "Residential Area Coordinator",
    slug: "lehi-valladares",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Carolyn",
    lastName: "van Artsdalen",
    title: "ArtsCrew Exhibitions Assistant",
    slug: "carolyn-van-artsdalen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chris",
    lastName: "Van Booven",
    title: "Assistant Director of Global Programs",
    slug: "chris-van-booven",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Griffin",
    lastName: "van Horne",
    title: "Instruction and Technical Specialist",
    slug: "griffin-van-horne",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sandra",
    lastName: "Van Wagoner",
    title: "Administrative Coordinator",
    slug: "sandra-van-wagoner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stacey",
    lastName: "Vanasse",
    title: "Senior Assistant Director",
    slug: "stacey-vanasse",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Sheila",
    lastName: "Vandal",
    title: "Human Research Protection Program (HRPP) Assistant Director",
    slug: "sheila-vandal",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Emily",
    lastName: "Vander Werf",
    title: "Grants and Financial Specialist",
    slug: "emily-vander-werf",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Damion",
    lastName: "Vania",
    title: "Psychotherapist",
    slug: "damion-vania",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Natacha",
    lastName: "Varela",
    title: "Project Manager",
    slug: "natacha-varela",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kerri-Ann",
    lastName: "Varela",
    title: "Assistant Director, Counseling and Psychological Services",
    slug: "kerri-ann-varela",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Elise",
    lastName: "Varkonyi",
    title: "Pharmacist",
    slug: "elise-varkonyi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ty",
    lastName: "Varszegi",
    title: "Program Manager, Office of Education",
    slug: "ty-varszegi",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kathleen",
    lastName: "Vaslet",
    title: "Admission Coordinator",
    slug: "kathleen-vaslet",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Nicholas",
    lastName: "Vasques",
    title: "Research Greenhouse Manager",
    slug: "nicholas-vasques",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elena",
    lastName: "Vasquez",
    title: "Assistant Director, Community Partnership",
    slug: "elena-vasquez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amaya",
    lastName: "Vazquez",
    title: "Campus Planning & Design Coordinator",
    slug: "amaya-vazquez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maggie",
    lastName: "Vecchione",
    title: "Assistant Director, Program Management",
    slug: "maggie-vecchione",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Isadora",
    lastName: "Vega",
    title: "Seasonal Sales Associate",
    slug: "isadora-vega",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katheryn",
    lastName: "Vega",
    title: "Administrative Assistant",
    slug: "katheryn-vega",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Neil",
    lastName: "Veloso",
    title: "Executive Director of Industrial Engagement & Corporate Ventures",
    slug: "neil-veloso",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michelle",
    lastName: "Venditelli",
    title: "Director of Collections Care",
    slug: "michelle-venditelli",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Clayton",
    lastName: "VerBerkmoes",
    title: "Seasonal Application Reader",
    slug: "clayton-verberkmoes",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Mike",
    lastName: "Verzino",
    title: "Assistant Vice President, Academic Initiatives",
    slug: "mike-verzino",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Gracie",
    lastName: "Vicente",
    title: "Choices/OIT Media Producer and Coordinator",
    slug: "gracie-vicente",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Janae",
    lastName: "Victoria",
    title: "Assistant Dean of Student Affairs",
    slug: "janae-victoria",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lisa",
    lastName: "Vidal",
    title: "Associate Director, Program Support",
    slug: "lisa-vidal",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alex",
    lastName: "Vidmar",
    title: "Assistant Director, IT Service Center",
    slug: "alex-vidmar",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kate",
    lastName: "Vieillard",
    title: "Director of Event Strategy and Management",
    slug: "kate-vieillard",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer",
    lastName: "Vieira",
    title: "Assistant Director, Licensing Compliance and Royalty Distribution",
    slug: "jennifer-vieira",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Susan",
    lastName: "Vieira",
    title: "Assistant Director of Upper Division Communities",
    slug: "susan-vieira",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Isabel",
    lastName: "Vieira",
    title: "Grants and Financial Specialist",
    slug: "isabel-vieira",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Derek",
    lastName: "Vieira",
    title: "Manager, Network Services",
    slug: "derek-vieira",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lydia",
    lastName: "Vigneau",
    title: "Athletics Photography Assistant",
    slug: "lydia-vigneau",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nina",
    lastName: "Villanova",
    title: "Learning Designer",
    slug: "nina-villanova",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Eddie",
    lastName: "Villanueva",
    title: "ArtsCrew Preparator Assistant",
    slug: "eddie-villanueva",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrew",
    lastName: "Vincent",
    title: "Assistant Director for the Brown Center for Students of Color",
    slug: "andrew-vincent",
    dei: true,
    category: "Student Life",
  },
  {
    firstName: "Wendy",
    lastName: "Virgadamo",
    title: "Grants and Financial Specialist",
    slug: "wendy-virgadamo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Thomas-Anthony",
    lastName: "Viscione",
    title: "Financial Coordinator",
    slug: "thomas-anthony-viscione",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Christina",
    lastName: "Visinho",
    title: "Senior Assistant Director",
    slug: "christina-visinho",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Sarah",
    lastName: "Vitale",
    title: "Training and Outreach Specialist",
    slug: "sarah-vitale",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Janice",
    lastName: "Viticonte",
    title: "Coordinator, Career Development",
    slug: "janice-viticonte",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Katherine",
    lastName: "Vitug",
    title: "Director of Finance and Administration",
    slug: "katherine-vitug",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Yi",
    lastName: "Vizard",
    title: "Project Manager",
    slug: "yi-vizard",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Khanh",
    lastName: "Vo",
    title: "Digital Humanities Specialist",
    slug: "khanh-vo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kelly",
    lastName: "Volpe",
    title: "Financial Specialist",
    slug: "kelly-volpe",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Suthida",
    lastName: "Vongkaysone",
    title: "Admission Coordinator",
    slug: "suthida-vongkaysone",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Katherine",
    lastName: "Vorenberg",
    title: "Associate Director of Data Mining and Prospect Identification",
    slug: "katherine-vorenberg",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Keegan",
    lastName: "Wade",
    title: "Senior Application Developer",
    slug: "keegan-wade",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Emily",
    lastName: "Wagg",
    title: "Admission Officer",
    slug: "emily-wagg",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Sophia",
    lastName: "Wagner",
    title: "Administrative HR Coordinator",
    slug: "sophia-wagner",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Corinne",
    lastName: "Wahlberg",
    title: "Project Coordinator",
    slug: "corinne-wahlberg",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah",
    lastName: "Wait",
    title: "Associate Director of Annual Giving",
    slug: "sarah-wait",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Wanda",
    lastName: "Walker",
    title: "Financial Coordinator",
    slug: "wanda-walker",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sarah",
    lastName: "Walker",
    title: "Human Resources Director",
    slug: "sarah-walker",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Wendy",
    lastName: "Wallace",
    title: "Director of Civic Engagement",
    slug: "wendy-wallace",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Linsey",
    lastName: "Wallace",
    title: "ArtsCrew Preparator",
    slug: "linsey-wallace",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Love",
    lastName: "Wallace",
    title: "Associate Dean of the College for the Academic Code",
    slug: "love-wallace",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Matthew",
    lastName: "Wallace",
    title: "Assistant Director of Student Recruitment and Marketing",
    slug: "matthew-wallace",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Melissa",
    lastName: "Walsh",
    title: "Director of Graduate Education",
    slug: "melissa-walsh",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "James",
    lastName: "Walsh",
    title: "Senior Assistant Director of Admission",
    slug: "james-walsh",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Sara",
    lastName: "Walsh",
    title: "Executive Dean of Finance and Administration",
    slug: "sara-walsh",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "William",
    lastName: "Walsh",
    title: "Associate Director, Strategic Donor and Development Communications",
    slug: "william-walsh",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Marcy",
    lastName: "Walsh",
    title: "Associate Director of Admissions",
    slug: "marcy-walsh",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Joe",
    lastName: "Walsmith",
    title:
      " Senior Associate Director of Athletics for Wellness and Performance",
    slug: "joe-walsmith",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Summer",
    lastName: "Walters",
    title: "Financial Coordinator",
    slug: "summer-walters",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Paul",
    lastName: "Waltz",
    title: "Manager, HVAC and Controls",
    slug: "paul-waltz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sean",
    lastName: "Wang",
    title: "Tutor, Gateways Program",
    slug: "sean-wang",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Hilary",
    lastName: "Wang",
    title: "Digital Archivist",
    slug: "hilary-wang",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Xinyao",
    lastName: "Wang",
    title: "Marketing Cloud Specialist",
    slug: "xinyao-wang",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Xin",
    lastName: "Wang",
    title: "Marketing Cloud Specialist",
    slug: "xin-wang",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Li",
    lastName: "Wang",
    title: "Curator, East Asian Collection",
    slug: "li-wang",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bethany",
    lastName: "Warburton",
    title: "Senior Project Manager",
    slug: "bethany-warburton",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mary",
    lastName: "Ward",
    title: "Senior Director, Alumni Belonging",
    slug: "mary-ward",
    dei: true,
    category: "Communications",
  },
  {
    firstName: "Lisa",
    lastName: "Ward",
    title: "Grants and Research Manager (Pre-Award)",
    slug: "lisa-ward",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Elizabeth",
    lastName: "Warner",
    title: "Director, Compensation & Organizational Services",
    slug: "elizabeth-warner",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jessica",
    lastName: "Warrington",
    title: "IBES Associate Director of Communications",
    slug: "jessica-warrington",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Daniel",
    lastName: "Warshay",
    title:
      " Executive Director, The Jonathan M. Nelson Center for Entrepreneurship",
    slug: "daniel-warshay",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Taelor",
    lastName: "Washington",
    title: "Paid Media Specialist",
    slug: "taelor-washington",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jessica",
    lastName: "Wasilewski",
    title: "Producing Director",
    slug: "jessica-wasilewski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Olivia",
    lastName: "Watson",
    title: "Assistant Director, Alumni Events and Experiences",
    slug: "olivia-watson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jennifer",
    lastName: "Watson",
    title: "Financial Services Coordinator (Receivables)",
    slug: "jennifer-watson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Richard",
    lastName: "Waugh",
    title: "Administrative and Financial Coordinator",
    slug: "richard-waugh",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Chantee",
    lastName: "Weah",
    title: "Manager of Administrative Support",
    slug: "chantee-weah",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Phoebe",
    lastName: "Weatherall",
    title: "Investment Director",
    slug: "phoebe-weatherall",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Amy",
    lastName: "Webber",
    title: "Regulatory Manager",
    slug: "amy-webber",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Julie",
    lastName: "Weber",
    title: "University Ombudsperson",
    slug: "julie-weber",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sarah",
    lastName: "Weesner",
    title: "Associate Director, Annual Leadership Giving",
    slug: "sarah-weesner",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Thomas",
    lastName: "Wegner Foskett",
    title: "Project Manager",
    slug: "thomas-wegner-foskett",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Devorah",
    lastName: "Weiner",
    title: "BioSafety Coordinator",
    slug: "devorah-weiner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Susan",
    lastName: "Weiner",
    title: "Prestigious Nominations Manager",
    slug: "susan-weiner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Janet",
    lastName: "Weinstein-Zanger",
    title: "Seasonal Reader",
    slug: "janet-weinstein-zanger",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Alyson",
    lastName: "Weiss",
    title: "Associate Director, Corporate and Executive Education",
    slug: "alyson-weiss",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "David",
    lastName: "Weitz",
    title: "ArtsCrew Preparator",
    slug: "david-weitz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mandy",
    lastName: "Welsch",
    title: "Grants and Financial Specialist",
    slug: "mandy-welsch",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Anthony",
    lastName: "Westendorf",
    title: "Senior HRPP Administrator",
    slug: "anthony-westendorf",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kris",
    lastName: "Wetterland",
    title: "EMS Shift Supervisor",
    slug: "kris-wetterland",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Matthew",
    lastName: "Whalen",
    title: "Associate Director of Athletics Sports Medicine",
    slug: "matthew-whalen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kelly",
    lastName: "Whalen",
    title: "Assistant Director, Office of Student Affairs",
    slug: "kelly-whalen",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Hannah",
    lastName: "Whitbeck",
    title: "Executive Assistant & Administrative Coordinator",
    slug: "hannah-whitbeck",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Toby",
    lastName: "White",
    title: "Brown Sports Network Production Crew",
    slug: "toby-white",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hayden",
    lastName: "White",
    title: "Athletic Trainer",
    slug: "hayden-white",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ellen",
    lastName: "White",
    title: "Senior Manager of Events and Special Projects",
    slug: "ellen-white",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Michael",
    lastName: "White",
    title:
      " Vice President for Finance and Administrative Services & Chief Financial Officer",
    slug: "michael-white",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Joi",
    lastName: "Whitehead",
    title:
      " Assistant Dean for Equity Initiatives and University K-12 Engagement",
    slug: "joi-whitehead",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Cheryl",
    lastName: "Whiteside",
    title: "Manager of Finance and Administration",
    slug: "cheryl-whiteside",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Charmaine",
    lastName: "Whitman-Jemison",
    title: "Human Resources Specialist",
    slug: "charmaine-whitman-jemison",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Margarite",
    lastName: "Whitten",
    title: "Program Manager",
    slug: "margarite-whitten",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Karen",
    lastName: "Whittet",
    title: "Associate Director, Career Counseling",
    slug: "karen-whittet",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Nicole",
    lastName: "Wholean",
    title: "Registrar and Curator of Campus Collections",
    slug: "nicole-wholean",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jen",
    lastName: "Wicoff",
    title: "Collections Manager/Registrar",
    slug: "jen-wicoff",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Derek",
    lastName: "Wietsma",
    title: "Assistant Director of Programs and Data",
    slug: "derek-wietsma",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rachel",
    lastName: "Wilbourne",
    title: "Class Giving Associate",
    slug: "rachel-wilbourne",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "John",
    lastName: "Wilbur",
    title: "Athletics Public Address Announcer",
    slug: "john-wilbur",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Catherine",
    lastName: "Wilcox",
    title: "Accounts Payable Supervisor",
    slug: "catherine-wilcox",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sean",
    lastName: "Wilder",
    title: "Residential Area Coordinator",
    slug: "sean-wilder",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Anne",
    lastName: "Wilding",
    title: "Annual Leadership Giving Associate",
    slug: "anne-wilding",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Beverly",
    lastName: "Wiley",
    title: "Athletics Public Address Announcer",
    slug: "beverly-wiley",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kristina",
    lastName: "Wilk",
    title: "Associate Director, Annual Giving",
    slug: "kristina-wilk",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Richard",
    lastName: "Wilkinson",
    title: "Associate Director, Network Integration",
    slug: "richard-wilkinson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cass",
    lastName: "Wilkinson Saldana",
    title: "Social Science Data Librarian",
    slug: "cass-wilkinson-saldana",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Geoffrey",
    lastName: "Williams",
    title: "Manager, Bioimaging Facility",
    slug: "geoffrey-williams",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cindy",
    lastName: "Williams",
    title: "Project Manager",
    slug: "cindy-williams",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amanda",
    lastName: "Williams",
    title: "Cashier/Checker/Clerk",
    slug: "amanda-williams",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marie",
    lastName: "Williams",
    title: "Vice President for Human Resources",
    slug: "marie-williams",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "James",
    lastName: "Williams",
    title: "Stockroom Coordinator",
    slug: "james-williams",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Roger",
    lastName: "Williams",
    title: "Head of Libraries Conservation",
    slug: "roger-williams",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brian",
    lastName: "Williamson",
    title: "Administrative and Systems Coordinator",
    slug: "brian-williamson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Darlene",
    lastName: "Williamson",
    title: "Manager of Engagement and Volunteer Programs",
    slug: "darlene-williamson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Austin",
    lastName: "Wilson",
    title: "Manager, Community-Engaged Learning",
    slug: "austin-wilson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alexis",
    lastName: "Wilson",
    title: "Administrative Coordinator for Advising",
    slug: "alexis-wilson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jamila",
    lastName: "Wilson",
    title: "Administrative Coordinator",
    slug: "jamila-wilson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marta",
    lastName: "Wilson-Barthes",
    title: "Project Manager",
    slug: "marta-wilson-barthes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daisy",
    lastName: "Winner",
    title: "Program Manager, Dean's Special Projects",
    slug: "daisy-winner",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jane",
    lastName: "Winograd",
    title: "Associate Director, Pre-College Programs & Environmental Studies",
    slug: "jane-winograd",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jarrod",
    lastName: "Winsor",
    title: "Lead System Administrator",
    slug: "jarrod-winsor",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "William",
    lastName: "Wittels",
    title: "Assistant Dean of Academic Affairs",
    slug: "william-wittels",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Cheryl",
    lastName: "Wojciechowski",
    title: "Residency Program Assistant Coordinator",
    slug: "cheryl-wojciechowski",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kirsten",
    lastName: "Wolfe",
    title:
      " Associate Dean and Associate Director of Student Conduct & Community Standards",
    slug: "kirsten-wolfe",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Linnea",
    lastName: "Wolfe",
    title: "Deputy CIO",
    slug: "linnea-wolfe",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Adeline",
    lastName: "Wong",
    title: "Director of Global Partnerships and Programs",
    slug: "adeline-wong",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brandon",
    lastName: "Wong",
    title: "Alumni Relations Help Desk Representative",
    slug: "brandon-wong",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Heather",
    lastName: "Wong Bailey",
    title: "Psychotherapist",
    slug: "heather-wong-bailey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erin",
    lastName: "Woo",
    title:
      " Assistant Director, Mindfulness for Educators Programs and Diversity, Equity, and Inclusion Initiatives, Instructor and Trainer",
    slug: "erin-woo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Roxanne",
    lastName: "Wood",
    title: "Director, Brown University Oncology Research Group",
    slug: "roxanne-wood",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nathan",
    lastName: "Wood",
    title: "Senior Research Systems Administrator",
    slug: "nathan-wood",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Telma",
    lastName: "Woodson",
    title: "Administrative Coordinator",
    slug: "telma-woodson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David",
    lastName: "Woodward",
    title: "Director, Finance",
    slug: "david-woodward",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Pamela",
    lastName: "Woodward",
    title:
      " Senior Director of Executive Leadership Support and Liaison to the President",
    slug: "pamela-woodward",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "George",
    lastName: "Worth",
    title: "Senior Technical Assistant",
    slug: "george-worth",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Eileen",
    lastName: "Wright",
    title: "Administrative Manager, Global Health Initiative",
    slug: "eileen-wright",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Adam",
    lastName: "Wright",
    title: "Brown Sports Network Production Crew",
    slug: "adam-wright",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kathleen",
    lastName: "Wright",
    title: "International Advancement Coordinator",
    slug: "kathleen-wright",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kimberley",
    lastName: "Wright",
    title: "Equipment Room Specialist",
    slug: "kimberley-wright",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Don",
    lastName: "Wright",
    title: "Instrument Maker/Machinist",
    slug: "don-wright",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Courtney",
    lastName: "Wuethrich",
    title: "Senior Application & Contracts Support Specialist",
    slug: "courtney-wuethrich",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brooke",
    lastName: "Wyeth",
    title: "Community Emergency Response Coordinator",
    slug: "brooke-wyeth",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michele",
    lastName: "Xavier",
    title: "Grant and Financial Specialist",
    slug: "michele-xavier",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jun",
    lastName: "Xiao",
    title: "Senior Internal Auditor, Information Technology",
    slug: "jun-xiao",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Youlim",
    lastName: "Yai",
    title: "Director of Enrollment Management",
    slug: "youlim-yai",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Kairi",
    lastName: "Yang",
    title: "Seasonal Sales Associate",
    slug: "kairi-yang",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Steven",
    lastName: "Yang",
    title: "Storage Administrator",
    slug: "steven-yang",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jesse",
    lastName: "Yedinak",
    title: "Assistant Dean of Education",
    slug: "jesse-yedinak",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lauren",
    lastName: "Young",
    title: "Grants and Financial Manager",
    slug: "lauren-young",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Quiana",
    lastName: "Young",
    title: "Director of Advocacy, Engagement, and Communications",
    slug: "quiana-young",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sally",
    lastName: "Yu",
    title: "Assistant Director of IT, Brown Bookstore",
    slug: "sally-yu",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Catherine",
    lastName: "Zabriskie",
    title: "Senior Director of Digital Learning & Design",
    slug: "catherine-zabriskie",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Camil",
    lastName: "Zaganjor",
    title: "SPS Teaching Associate - Staff",
    slug: "camil-zaganjor",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michele",
    lastName: "Zager",
    title: "Psychotherapist",
    slug: "michele-zager",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kaela",
    lastName: "Zaino",
    title: "Grants and Financial Specialist",
    slug: "kaela-zaino",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Gabriella",
    lastName: "Zambrano",
    title: "Athletic Ticket Office Representative",
    slug: "gabriella-zambrano",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessica",
    lastName: "Zambrano",
    title: "Athletic Ticket Office Representative",
    slug: "jessica-zambrano",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gerald",
    lastName: "Zani",
    title: "Senior Technical Assistant",
    slug: "gerald-zani",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kristina",
    lastName: "Zanni",
    title: "Receptionist/Administrative Assistant",
    slug: "kristina-zanni",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ted",
    lastName: "Zarek",
    title: "Assistant Manager, Technology Center",
    slug: "ted-zarek",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lillian",
    lastName: "Zemba",
    title: "Administrative Coordinator",
    slug: "lillian-zemba",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Blanca",
    lastName: "Zevallos",
    title: "ARISE Coordinator",
    slug: "blanca-zevallos",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Weibin",
    lastName: "Zhang",
    title: "Systems Manager",
    slug: "weibin-zhang",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Wei",
    lastName: "Zhang",
    title: "Systems Manager",
    slug: "wei-zhang",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Yong",
    lastName: "Zhou",
    title: "Lead Developer",
    slug: "yong-zhou",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Wendy",
    lastName: "Zhu",
    title: "Labor Relations Data Specialist",
    slug: "wendy-zhu",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Stephanie",
    lastName: "Zielinski",
    title: "Partner Engagement Manager",
    slug: "stephanie-zielinski",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Julia",
    lastName: "Zimring",
    title: "Communications Coordinator",
    slug: "julia-zimring",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kenneth",
    lastName: "Zirkel",
    title: "Web and Multimedia Manager",
    slug: "kenneth-zirkel",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Brian",
    lastName: "Zuppardi",
    title: "Lead Developer",
    slug: "brian-zuppardi",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Wynette",
    lastName: "Zuppardi",
    title: "Assistant Vice President, Financial Services",
    slug: "wynette-zuppardi",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tyler",
    lastName: "Zuspan",
    title: "Senior IT Support Consultant",
    slug: "tyler-zuspan",
    dei: false,
    category: "Technology",
  },
];
export default people;
